
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3aa9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3aa9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9gvWC", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

const $74aebeb5449e6ba2$export$8705dc5aff02db1e = document.getElementById('board');
const $74aebeb5449e6ba2$export$b287834adb48eda0 = document.getElementById('submit');
const $74aebeb5449e6ba2$export$1c95e5a3d23490a7 = document.getElementById('share');
const $74aebeb5449e6ba2$export$b570aed48b9d105c = document.getElementById('game-over');
const $74aebeb5449e6ba2$export$fed815b607737baf = document.getElementById('game-over-reason');
const $74aebeb5449e6ba2$export$c4d92acf9380a94c = document.getElementById('score');
const $74aebeb5449e6ba2$export$ecc23bed38c179ea = document.getElementById('message');
const $74aebeb5449e6ba2$export$cab97797e3c0aa22 = document.getElementById('keyboard');
const $74aebeb5449e6ba2$export$f4e26a28022c6db9 = document.getElementById('ai-thoughts');
const $74aebeb5449e6ba2$export$c8da60a5ff0de965 = document.getElementById('tutorial');
const $74aebeb5449e6ba2$export$81fc1209cf588684 = document.getElementById('tooltip');
const $74aebeb5449e6ba2$export$da311280a2a8e6ec = document.getElementById('tooltip-popup');
const $74aebeb5449e6ba2$export$fec9b67616b12887 = document.getElementById('settings-button');
const $74aebeb5449e6ba2$export$907f28b59c553b3d = document.getElementById('settings-popup');
const $74aebeb5449e6ba2$export$19548a89c019c2ed = document.getElementById('high-contrast-mode');
const $74aebeb5449e6ba2$export$6061d98ec2420823 = document.getElementById('controls');
const $74aebeb5449e6ba2$export$b1b09e44340c395b = document.getElementById('time-left');
const $74aebeb5449e6ba2$export$d28bc5c38c1a0aa6 = document.getElementById('high-score');
const $74aebeb5449e6ba2$export$b48e59ca96ef2c97 = document.getElementById('why-did-i-lose-popup-button');
const $74aebeb5449e6ba2$export$38f5db09d065a732 = document.getElementById('why-did-i-lose-popup');
const $74aebeb5449e6ba2$export$2f53bdb6d49832f0 = document.getElementById('why-did-i-lose-input');
const $74aebeb5449e6ba2$export$6aaa1c15f016a019 = document.getElementById('why-did-i-lose-button');
const $74aebeb5449e6ba2$export$7a5c8245032329ac = document.getElementById('why-did-i-lose-output');
const $74aebeb5449e6ba2$export$bbea856fdb3e3c5f = Array.from(document.getElementById('buttons').children);


const $09b17a1eda282565$export$3e4081d61af9cb90 = [
    'THEIR',
    'WOULD',
    'ABOUT',
    'COULD',
    'OTHER',
    'FIRST',
    'AFTER',
    'THOSE',
    'BEING',
    'WHILE',
    'RIGHT',
    'WORLD',
    'YEARS',
    'THINK',
    'MIGHT',
    'UNDER',
    'PLACE',
    'FOUND',
    'GREAT',
    'SINCE',
    'POWER',
    'ASKED',
    'HUMAN',
    'WATER',
    'HOUSE',
    'BASED',
    'WOMEN',
    'OFTEN',
    'POINT',
    'GIVEN',
    'UNTIL',
    'USING',
    'TABLE',
    'GROUP',
    'LARGE',
    'LATER',
    'WORDS',
    'NIGHT',
    'STUDY',
    'AMONG',
    'YOUNG',
    'EARLY',
    'THING',
    'WOMAN',
    'TIMES',
    'LIGHT',
    'HEART',
    'WHITE',
    'HANDS',
    'LEAST',
    'VALUE',
    'MODEL',
    'BLACK',
    'MEANS',
    'ALONG',
    'WHOLE',
    'CHILD',
    'VOICE',
    'DEATH',
    'ABOVE',
    'TAKEN',
    'BEGAN',
    'HEARD',
    'DOING',
    'FRONT',
    'MONEY',
    'CLOSE',
    'COURT',
    'PARTY',
    'SPACE',
    'TERMS',
    'SHORT',
    'QUITE',
    'CLEAR',
    'STORY',
    'FIELD',
    'THIRD',
    'TODAY',
    'SOUTH',
    'MAJOR',
    'FORCE',
    'MAKES',
    'ALONE',
    'WHOSE',
    'MAYBE',
    'SHOWN',
    'CAUSE',
    'NORTH',
    'HOURS',
    'SOUND',
    'TRIED',
    'EARTH',
    'BRING',
    'LOWER',
    'MUSIC',
    'FOCUS',
    'MOUTH',
    'IMAGE',
    'RANGE',
    'MOVED',
    'BELOW',
    'WORKS',
    'TRADE',
    'MEDIA',
    'READY',
    'COMES',
    'LIVES',
    'FORMS',
    'WRONG',
    'SPEAK',
    'CHINA',
    'SMILE',
    'STAGE',
    'BASIC',
    'JAMES',
    'FINAL',
    'TYPES',
    'RULES',
    'SHARE',
    'PHONE',
    'ROUND',
    'MEANT',
    'PRICE',
    'IDEAS',
    'PARTS',
    'TAKES',
    'BRAIN',
    'LEARN',
    'STAND',
    'FAITH',
    'LINES',
    'MARCH',
    'BOARD',
    'SCALE',
    'THANK',
    'WRITE',
    'WROTE',
    'BROWN',
    'DAILY',
    'LIVED',
    'MORAL',
    'NOTES',
    'BUILT',
    'SPOKE',
    'PHASE',
    'REACH',
    'WATCH',
    'GIRLS',
    'DOUBT',
    'GIVES',
    'BEGIN',
    'COVER',
    'CLAIM',
    'HEAVY',
    'LOVED',
    'BREAK',
    'OLDER',
    'SPENT',
    'CHAIR',
    'CHEST',
    'EIGHT',
    'AVOID',
    'FIGHT',
    'NOTED',
    'EQUAL',
    'DRIVE',
    'LABOR',
    'STONE',
    'URBAN',
    'PLANT',
    'KNOWS',
    'MILES',
    'CHIEF',
    'STYLE',
    'TOUCH',
    'SHAPE',
    'SIGHT',
    'WORTH',
    'RATES',
    'MONTH',
    'NAMES',
    'CRIME',
    'BUILD',
    'FIXED',
    'HORSE',
    'SMITH',
    'PARIS',
    'HENRY',
    'TRIAL',
    'WANTS',
    'PLANS',
    'DRINK',
    'TEARS',
    'INDEX',
    'QUIET',
    'FRESH',
    'QUICK',
    'GUIDE',
    'BIRTH',
    'STOCK',
    'DREAM',
    'FORTH',
    'AGENT',
    'YOUTH',
    'EMPTY',
    'EXIST',
    'GOALS',
    'NAMED',
    'METAL',
    'JUDGE',
    'NOVEL',
    'ROYAL',
    'WORSE',
    'VIEWS',
    'CLEAN',
    'GRACE',
    'STORE',
    'CRIED',
    'TRAIN',
    'TRULY',
    'UNITS',
    'HOTEL',
    'SHIFT',
    'JOINT',
    'ADULT',
    'ROMAN',
    'DRAWN',
    'BROAD',
    'ITEMS',
    'LEADS',
    'BLOCK',
    'FALSE',
    'BRIEF',
    'BOUND',
    'SOLID',
    'LAYER',
    'THICK',
    'NOISE',
    'CHAIN',
    'ANGER',
    'ALIVE',
    'RATIO',
    'FACTS',
    'DRUGS',
    'BROKE',
    'SPEND',
    'LIKED',
    'COUNT',
    'GRAND',
    'ASIDE',
    'DANCE',
    'FRAME',
    'ENJOY',
    'WASTE',
    'INPUT',
    'CROWD',
    'LYING',
    'MIXED',
    'KINDS',
    'GAMES',
    'PROVE',
    'ANGRY',
    'GUARD',
    'SHARP',
    'VIDEO',
    'LAUGH',
    'TURNS',
    'TRACK',
    'UNCLE',
    'PLANE',
    'EXTRA',
    'IDEAL',
    'PLATE',
    'OUGHT',
    'HEADS',
    'SHIRT',
    'GROWN',
    'TWICE',
    'RADIO',
    'GRANT',
    'FACES',
    'FACED',
    'BANKS',
    'ARGUE',
    'SUGAR',
    'FRANK',
    'HOPED',
    'PAGES',
    'LOGIC',
    'ENTRY',
    'OWNER',
    'FORTY',
    'DEPTH',
    'FLUID',
    'SHOCK',
    'COAST',
    'FUNDS',
    'ROLES',
    'FRUIT',
    'CLOUD',
    'RAISE',
    'ABUSE',
    'TEACH',
    'TIRED',
    'TOPIC',
    'MAGIC',
    'MATCH',
    'FIRMS',
    'HELPS',
    'FLESH',
    'SCOPE',
    'BREAD',
    'SWORD',
    'RAPID',
    'THREW',
    'BEACH',
    'WAVES',
    'ROUTE',
    'ACUTE',
    'SMOKE',
    'OCEAN',
    'DROVE',
    'SMART',
    'PLAYS',
    'JONES',
    'ARMED',
    'ANGLE',
    'PLAIN',
    'SCORE',
    'HOLDS',
    'WORST',
    'BIRDS',
    'PRIME',
    'FAULT',
    'TRANS',
    'PRINT',
    'FILMS',
    'LOUIS',
    'SAVED',
    'NURSE',
    'LUNCH',
    'CURVE',
    'GRADE',
    'BRAND',
    'MINOR',
    'OWNED',
    'SPAIN',
    'THROW',
    'PRIDE',
    'REPLY',
    'YIELD',
    'ADMIT',
    'STORM',
    'YOURS',
    'SLAVE',
    'STICK',
    'GLORY',
    'LINKS',
    'MOVES',
    'TRAIL',
    'BLIND',
    'FAVOR',
    'WOUND',
    'PROUD',
    'BEGUN',
    'CRAZY',
    'FINDS',
    'STUCK',
    'MINDS',
    'MARKS',
    'CHOSE',
    'TRUCK',
    'TEXAS',
    'SPLIT',
    'KNIFE',
    'WIDER',
    'PANEL',
    'DYING',
    'KINGS',
    'ROUGH',
    'SAINT',
    'MOVIE',
    'EXACT',
    'BONES',
    'SPORT',
    'HOMES',
    'VITAL',
    'TEAMS',
    'FILES',
    'DUTCH',
    'LIVER',
    'DEVIL',
    'SOLVE',
    'CREAM',
    'NORMS',
    'CROWN',
    'SHAME',
    'TAXES',
    'UNITY',
    'ANGEL',
    'DELAY',
    'CITED',
    'BURST',
    'LANDS',
    'BLAME',
    'GRAVE',
    'TOWER',
    'LUCKY',
    'NEWLY',
    'SPITE',
    'FLOWS',
    'OUTER',
    'ARISE',
    'NAKED',
    'ROCKS',
    'DOZEN',
    'CARDS',
    'TRACE',
    'LEWIS',
    'GIANT',
    'BONDS',
    'VALID',
    'SHORE',
    'AIMED',
    'NOBLE',
    'SHAKE',
    'SOLAR',
    'GRAPH',
    'MERCY',
    'REALM',
    'TUMOR',
    'GRAIN',
    'TREND',
    'GUILT',
    'HATED',
    'WINGS',
    'GRIEF',
    'PILOT',
    'HABIT',
    'TOWNS',
    'VIRUS',
    'MODES',
    'PULSE',
    'MOUNT',
    'FIRED',
    'GHOST',
    'UPSET',
    'ROADS',
    'HONEY',
    'GIFTS',
    'WAIST',
    'EMAIL',
    'DIRTY',
    'HOPES',
    'FLASH',
    'PAUSE',
    'SLEPT',
    'PANIC',
    'PAINT',
    'NODES',
    'WAVED',
    'GUEST',
    'CABIN',
    'BLANK',
    'INTER',
    'FEARS',
    'BADLY',
    'FANCY',
    'ADOPT',
    'DRAFT',
    'WAGES',
    'LOVES',
    'ACTOR',
    'GATES',
    'SUPER',
    'ACTED',
    'CHART',
    'LOVER',
    'POEMS',
    'TOUGH',
    'BEAST',
    'DRUNK',
    'USAGE',
    'CLOTH',
    'CODES',
    'YARDS',
    'SIXTY',
    'OPENS',
    'JUICE',
    'MIDST',
    'STEAM',
    'SWEPT',
    'BOXES',
    'ACIDS',
    'BLADE',
    'DATES',
    'FAINT',
    'ORGAN',
    'MALES',
    'SLOPE',
    'FIBER',
    'RENAL',
    'PATHS',
    'SWEAT',
    'GRASP',
    'STARE',
    'CHASE',
    'SIXTH',
    'LASER',
    'PITCH',
    'OLIVE',
    'AWFUL',
    'TENDS',
    'SPINE',
    'GAINS',
    'CORPS',
    'BRAVE',
    'PAIRS',
    'LIKES',
    'SPARE',
    'LOANS',
    'HOLES',
    'WALKS',
    'BENCH',
    'CRAFT',
    'ONSET',
    'CLIMB',
    'CARED',
    'HIRED',
    'SLIDE',
    'SAUCE',
    'PANTS',
    'BRUSH',
    'FLAME',
    'THUMB',
    'CROPS',
    'DEALT',
    'WIDTH',
    'MOUSE',
    'WIVES',
    'SCENT',
    'PRIZE',
    'SWUNG',
    'ALIKE',
    'TALES',
    'RULED',
    'CRUEL',
    'WHEAT',
    'AUDIT',
    'CHEAP',
    'SHADE',
    'TRIBE',
    'FORUM',
    'JEANS',
    'BOATS',
    'FAILS',
    'FLOUR',
    'REIGN',
    'CHAOS',
    'AROSE',
    'LINED',
    'WALES',
    'ALERT',
    'WEIRD',
    'TRUMP',
    'BAKER',
    'TRIES',
    'DROPS',
    'RINGS',
    'MAYOR',
    'WRIST',
    'ALTER',
    'DRAWS',
    'STRIP',
    'POUND',
    'TALKS',
    'LUNGS',
    'DIARY',
    'RELAX',
    'ATOMS',
    'REACT',
    'BEARS',
    'MEALS',
    'BANDS',
    'FILED',
    'CABLE',
    'PORCH',
    'ALIEN',
    'DEALS',
    'READS',
    'SIZED',
    'MICRO',
    'TRUNK',
    'FOLKS',
    'QUEST',
    'WIPED',
    'BUNCH',
    'RIFLE',
    'TOXIC',
    'URGED',
    'CURSE',
    'STERN',
    'VAGUE',
    'CRASH',
    'GLOBE',
    'BASIN',
    'BRICK',
    'ZONES',
    'OPERA',
    'RANKS',
    'DRANK',
    'ELBOW',
    'TRICK',
    'DEMON',
    'SERUM',
    'FRAUD',
    'RIDGE',
    'MASON',
    'HUMOR',
    'SWING',
    'HAVEN',
    'BRIDE',
    'SWEAR',
    'SWIFT',
    'GROWS',
    'BOWED',
    'COHEN',
    'ALOUD',
    'PIANO',
    'AMINO',
    'LEMON',
    'PATCH',
    'GAZED',
    'BEANS',
    'OXIDE',
    'STAKE',
    'IMPLY',
    'RANCH',
    'CLERK',
    'SHELF',
    'SNAKE',
    'FEAST',
    'LIMBS',
    'SANDY',
    'WINDS',
    'CLUBS',
    'BURNS',
    'BEARD',
    'WITCH',
    'FIRES',
    'CAMPS',
    'VEINS',
    'TRIPS',
    'OWING',
    'NEGRO',
    'URINE',
    'ANGLO',
    'ROBIN',
    'BACON',
    'SUITE',
    'SHEAR',
    'QUOTE',
    'BUYER',
    'RACES',
    'RALPH',
    'PURSE',
    'FAIRY',
    'STEAL',
    'CHARM',
    'CRIES',
    'STACK',
    'QUERY',
    'PARKS',
    'AUDIO',
    'VOTES',
    'BORNE',
    'ROCKY',
    'POSED',
    'POETS',
    'FARMS',
    'PEARL',
    'SKIRT',
    'DRAIN',
    'MERIT',
    'SHAFT',
    'RIVAL',
    'SHOUT',
    'MAKER',
    'TANKS',
    'LORDS',
    'BURNT',
    'PUNCH',
    'WEARY',
    'SPRAY',
    'DECAY',
    'TWINS',
    'SADLY',
    'LODGE',
    'TOWEL',
    'PSALM',
    'WAGON',
    'VIRAL',
    'PALMS',
    'FLUNG',
    'BITCH',
    'CARGO',
    'BLAST',
    'STRAW',
    'LOGAN',
    'DRIFT',
    'ACRES',
    'RISEN',
    'PRONE',
    'LOADS',
    'SHALT',
    'BLOWN',
    'FETAL',
    'TYLER',
    'CAROL',
    'CRUDE',
    'LAKES',
    'PORTS',
    'FOCAL',
    'CRAIG',
    'SLICE',
    'NAILS',
    'SUPRA',
    'MINES',
    'COLIN',
    'BACKS',
    'VOCAL',
    'BLEND',
    'WRATH',
    'POLES',
    'ANKLE',
    'TIGER',
    'PROBE',
    'STOLE',
    'VITRO',
    'POLAR',
    'RUINS',
    'PEAKS',
    'BORED',
    'FLIES',
    'PLOTS',
    'COINS',
    'DELTA',
    'QUASI',
    'STARK',
    'SPARK',
    'SHONE',
    'ALBUM',
    'DEBTS',
    'TONES',
    'RACED',
    'BARON',
    'AMBER',
    'VERBS',
    'CLOAK',
    'PROSE',
    'CHIPS',
    'PAINS',
    'SETUP',
    'CREPT',
    'TUBES',
    'RILEY',
    'BLOND',
    'SCREW',
    'CANDY',
    'IRONY',
    'ORBIT',
    'MACRO',
    'BEAMS',
    'SHINE',
    'CHILE',
    'DAISY',
    'MYTHS',
    'DOUGH',
    'BURKE',
    'DAIRY',
    'GROVE',
    'AGONY',
    'CARES',
    'TOURS',
    'SAITH',
    'STOVE',
    'SAFER',
    'FROST',
    'COUGH',
    'NICHT',
    'BOWEL',
    'FROWN',
    'HERBS',
    'BLOWS',
    'CYBER',
    'THIEF',
    'GLARE',
    'BATCH',
    'CRUSH',
    'INTRA',
    'KNELT',
    'LACKS',
    'OSCAR',
    'MONKS',
    'HINTS',
    'VOTED',
    'FETCH',
    'SPEAR',
    'FROZE',
    'RISKY',
    'TRASH',
    'NASTY',
    'FLORA',
    'SWORE',
    'CHANG',
    'VAPOR',
    'THINE',
    'LADEN',
    'AMPLE',
    'FLOAT',
    'FLUSH',
    'SURGE',
    'FRIED',
    'RATED',
    'PASTE',
    'TOKEN',
    'SHINY',
    'GLAND',
    'BAKED',
    'BASIL',
    'DUSTY',
    'JOKES',
    'CLUNG',
    'BROWS',
    'COSTA',
    'HEARS',
    'CRISP',
    'FUELS',
    'DRAKE',
    'CLUES',
    'BLUES',
    'MATER',
    'CASTE',
    'HASTE',
    'LAMPS',
    'HARDY',
    'FLOCK',
    'WELSH',
    'STAMP',
    'MARSH',
    'SQUAD',
    'WIRES',
    'FOLDS',
    'SOBER',
    'LOCKS',
    'MONTE',
    'NOISY',
    'PINCH',
    'YEAST',
    'BEADS',
    'LANCE',
    'SWORN',
    'SPERM',
    'HORNS',
    'HURTS',
    'GENUS',
    'SCARY',
    'HOMER',
    'DEITY',
    'BEATS',
    'VENUS',
    'BLUNT',
    'SCARE',
    'FIERY',
    'LYMPH',
    'RAVEN',
    'BONUS',
    'GRAFT',
    'WHALE',
    'WEIGH',
    'JOHNS',
    'CORAL',
    'PILED',
    'GROAN',
    'CAKES',
    'RITES',
    'TORCH',
    'CREST',
    'ALIGN',
    'MINUS',
    'CURLS',
    'HANDY',
    'CRUST',
    'STAIN',
    'AWOKE',
    'FUNGI',
    'FIBRE',
    'ROPES',
    'PICKS',
    'SHRUG',
    'CLAWS',
    'WOVEN',
    'FLAGS',
    'LOCUS',
    'GOATS',
    'STEIN',
    'AISLE',
    'IVORY',
    'ULTRA',
    'PACED',
    'PILES',
    'CRAWL',
    'COATS',
    'MOIST',
    'OUNCE',
    'CENTS',
    'PEDRO',
    'OPTIC',
    'ROAST',
    'LIONS',
    'PROXY',
    'OVERT',
    'SYRUP',
    'WEARS',
    'NICHE',
    'BLUSH',
    'PENIS',
    'MANOR',
    'MOUND',
    'LEAPT',
    'DITCH',
    'BLINK',
    'CAVES',
    'TURKS',
    'NAZIS',
    'WINES',
    'CRANE',
    'CLASH',
    'SLAIN',
    'HAZEL',
    'STRAY',
    'PIETY',
    'SCOUT',
    'WRECK',
    'HAIRS',
    'GRAMS',
    'CURED',
    'VEGAS',
    'BOWLS',
    'MATES',
    'LOFTY',
    'PIOUS',
    'DARCY',
    'KNOTS',
    'CIGAR',
    'LIFTS',
    'BRAKE',
    'ROBES',
    'FLANK',
    'UNITE',
    'LYNCH',
    'ACHED',
    'TAILS',
    'MODAL',
    'CHOIR',
    'SNEAK',
    'MEDAL',
    'MOTIF',
    'BINDS',
    'CANOE',
    'ABIDE',
    'REINS',
    'CREWS',
    'MAPLE',
    'SCRAP',
    'PENAL',
    'SPIKE',
    'TRAPS',
    'ETHIC',
    'DIANE',
    'ETHOS',
    'RUSTY',
    'STING',
    'TORAH',
    'SILVA',
    'PAVED',
    'RIOTS',
    'DRUMS',
    'MAIZE',
    'SPOIL',
    'FETUS',
    'BITES',
    'RIDES',
    'SCARF',
    'BRUTE',
    'FLOWN',
    'TIDAL',
    'LEANS',
    'FLINT',
    'FORGE',
    'INFER',
    'BROTH',
    'CITES',
    'STEAK',
    'TILES',
    'WORMS',
    'DEVON',
    'EXAMS',
    'SCALP',
    'VOTER',
    'MITCH',
    'PIXEL',
    'VINES',
    'APRON',
    'DIETS',
    'DRONE',
    'GUILD',
    'LIANG',
    'SLICK',
    'BRACE',
    'VAULT',
    'RESIN',
    'GLOVE',
    'SPICE',
    'SNACK',
    'RELAY',
    'BLAZE',
    'PERIL',
    'CURLY',
    'SLACK',
    'HATES',
    'BADGE',
    'GRABS',
    'EVILS',
    'TUNED',
    'OPTED',
    'GROWL',
    'INLET',
    'TIRES',
    'POKED',
    'SHAKY',
    'RANDY',
    'SWAMP',
    'AGILE',
    'STRAP',
    'JUMPS',
    'SALON',
    'REPAY',
    'YACHT',
    'WAITS',
    'HYPER',
    'SWARM',
    'FINER',
    'PACES',
    'HEIRS',
    'DWARF',
    'SCORN',
    'CHORD',
    'SHARK',
    'NOTCH',
    'CEDAR',
    'NAIVE',
    'FLAWS',
    'JOINS',
    'DOWNS',
    'HANGS',
    'LEVIN',
    'ROGUE',
    'BOLTS',
    'VOWEL',
    'TREAD',
    'JUDAS',
    'METRO',
    'TYPED',
    'SHOVE',
    'HASTY',
    'GRAPE',
    'TEMPO',
    'RAINS',
    'RENTS',
    'TOMBS',
    'GLEAM',
    'OPIUM',
    'WIRED',
    'SLATE',
    'BOAST',
    'RAIDS',
    'TYING',
    'OMEGA',
    'HIDES',
    'FREAK',
    'LANES',
    'NEXUS',
    'CAMEL',
    'BLEAK',
    'POUCH',
    'POKER',
    'FRAIL',
    'MOTEL',
    'PACKS',
    'BRINK',
    'FUSED',
    'WISER',
    'THORN',
    'STUNG',
    'DWELT',
    'CLING',
    'URGES',
    'IDOLS',
    'PEACH',
    'RAILS',
    'PLEAD',
    'FINES',
    'CHALK',
    'ENACT',
    'EPOCH',
    'DROWN',
    'RAINY',
    'DENIS',
    'SPAKE',
    'AZURE',
    'ABODE',
    'VOWED',
    'BRENT',
    'LUNAR',
    'PATIO',
    'SMIRK',
    'ICONS',
    'PORES',
    'FLARE',
    'PINES',
    'BLOGS',
    'RAPED',
    'LEXIS',
    'BATHS',
    'BIRCH',
    'DEPOT',
    'TWAIN',
    'FRITZ',
    'QUOTA',
    'MUSED',
    'DIMLY',
    'SATIN',
    'WHORE',
    'RHYME',
    'CHEAT',
    'GUISE',
    'DUCKS',
    'HYMNS',
    'SCRUB',
    'FLATS',
    'HAIRY',
    'DOVER',
    'SPICY',
    'BATES',
    'LINUX',
    'CHANT',
    'MANLY',
    'MISTY',
    'BROCK',
    'CUBES',
    'ROUGE',
    'WHISK',
    'MOLAR',
    'ROWAN',
    'TOXIN',
    'PRIVY',
    'VICAR',
    'MOULD',
    'CORDS',
    'PRIMA',
    'JOKED',
    'DINER',
    'GODLY',
    'LACED',
    'LYRIC',
    'QUILT',
    'LOTUS',
    'BELTS',
    'BLAND',
    'GRIND',
    'STUMP',
    'CLEFT',
    'CHUNK',
    'DOCKS',
    'TONIC',
    'HAUNT',
    'FOYER',
    'LAPSE',
    'SLUNG',
    'FLASK',
    'CHOKE',
    'VODKA',
    'MAIDS',
    'VICES',
    'FLICK',
    'BRISK',
    'SALTY',
    'BUCKS',
    'INERT',
    'NECKS',
    'TAXED',
    'STONY',
    'RUGBY',
    'FLUTE',
    'PLANK',
    'DEBUT',
    'HERDS',
    'VERSO',
    'WARNS',
    'HARMS',
    'VINYL',
    'CORES',
    'CLIPS',
    'GEARS',
    'SHALE',
    'CARTS',
    'WARDS',
    'WOKEN',
    'SILKY',
    'TIMED',
    'REDOX',
    'FROGS',
    'ULCER',
    'KINDA',
    'STALE',
    'PIVOT',
    'INTEL',
    'PRICK',
    'DORIS',
    'STOIC',
    'TUNIC',
    'TIMER',
    'RHINE',
    'FACET',
    'SCANT',
    'LATCH',
    'SIGMA',
    'WRAPS',
    'SNOWY',
    'SMOKY',
    'LACEY',
    'SLOAN',
    'SHAWL',
    'CIDER',
    'GROIN',
    'RUBIN',
    'GRUNT',
    'AMEND',
    'PONDS',
    'MUTED',
    'EXITS',
    'CLOWN',
    'ANODE',
    'MOURN',
    'BIKES',
    'JIHAD',
    'ERICA',
    'MINER',
    'ADEPT',
    'MEATS',
    'TAPES',
    'PERCH',
    'GRIPS',
    'MORSE',
    'CLANS',
    'FRIES',
    'SHAWN',
    'GLUED',
    'WAKES',
    'TIDES',
    'LUMEN',
    'STAIR',
    'TENOR',
    'THUMP',
    'SHADY',
    'BUMPS',
    'MALIK',
    'STALK',
    'FANGS',
    'SHACK',
    'COALS',
    'SMACK',
    'TUNES',
    'PRISM',
    'SWINE',
    'HOUND',
    'SIREN',
    'FLING',
    'DEBIT',
    'HUMID',
    'SQUAT',
    'WIDEN',
    'THYME',
    'STEAD',
    'DERBY',
    'BENDS',
    'HAVOC',
    'VENOM',
    'MILKY',
    'NIGER',
    'SCOWL',
    'ARIEL',
    'GAZES',
    'PADRE',
    'TRIAD',
    'LOBES',
    'MULES',
    'LEASH',
    'BOXER',
    'ALOFT',
    'TRUCE',
    'VISTA',
    'VIGOR',
    'MENUS',
    'COILS',
    'DOGMA',
    'RINSE',
    'DECKS',
    'LEAPS',
    'RAGED',
    'PALSY',
    'LEAKS',
    'VOMIT',
    'SMEAR',
    'LAMBS',
    'CONES',
    'HICKS',
    'LENDS',
    'BULKY',
    'MANGO',
    'HEAPS',
    'HUSKY',
    'UNFIT',
    'KIRBY',
    'LOSER',
    'MIXER',
    'GLIDE',
    'SHAVE',
    'ROUSE',
    'DUNES',
    'COMET',
    'VEGAN',
    'BATON',
    'WHARF',
    'BOWIE',
    'COMTE',
    'TRAMP',
    'SLING',
    'PLUCK',
    'LINER',
    'WELCH',
    'MOANS',
    'PEDAL',
    'INCUR',
    'BARGE',
    'GAUNT',
    'TRAYS',
    'PURGE',
    'SANTO',
    'TROPE',
    'CROWS',
    'GRIDS',
    'SLANG',
    'FAMED',
    'FLAPS',
    'SONIC',
    'HELIX',
    'CRATE',
    'PLUME',
    'WAGED',
    'DUCTS',
    'MAINS',
    'SNORT',
    'PLEAS',
    'BRAID',
    'CODEX',
    'SWIRL',
    'RELIC',
    'VIOLA',
    'HINGE',
    'CLASP',
    'OATHS',
    'PIERS',
    'GOWNS',
    'APTLY',
    'MIRTH',
    'FOLEY',
    'TWIGS',
    'BULGE',
    'ADORE',
    'LEAFY',
    'AMUSE',
    'BATHE',
    'FORTS',
    'SPIED',
    'NODAL',
    'GLINT',
    'MAILS',
    'CLAMP',
    'AUNTS',
    'MONDE',
    'FECAL',
    'BUDGE',
    'CAGES',
    'FUMES',
    'STINK',
    'COREY',
    'LEANT',
    'GRINS',
    'USHER',
    'VALET',
    'PORTA',
    'CARVE',
    'GRATE',
    'CLONE',
    'SHUNT',
    'WALTZ',
    'CLINT',
    'AXIOM',
    'EUROS',
    'FORKS',
    'SMOTE',
    'WAGER',
    'SLADE',
    'YATES',
    'MADLY',
    'WARES',
    'FINCH',
    'WINDY',
    'FILTH',
    'LAIRD',
    'HOGAN',
    'OVARY',
    'SEDAN',
    'GIVER',
    'FABLE',
    'EPOXY',
    'CHAPS',
    'MELTS',
    'BYTES',
    'CHASM',
    'ETHYL',
    'TAPED',
    'ADOBE',
    'SPADE',
    'MURKY',
    'SPECK',
    'VOGUE',
    'PLUTO',
    'BINGE',
    'HADES',
    'MIXES',
    'NUDGE',
    'JUICY',
    'GRAVY',
    'FOXES',
    'SNARE',
    'ENVOY',
    'ADMIN',
    'QUART',
    'LATEX',
    'NICER',
    'EDICT',
    'MANIC',
    'PHARM',
    'ACTIN',
    'FATES',
    'FEMUR',
    'GATED',
    'SHIVA',
    'AMINE',
    'DROIT',
    'LUCID',
    'CRAVE',
    'MURAL',
    'HOVER',
    'MONTY',
    'ZEROS',
    'CUMIN',
    'FERMI',
    'FADES',
    'LEACH',
    'CATER',
    'BARED',
    'GARTH',
    'RAKED',
    'REGAL',
    'RACKS',
    'SNUCK',
    'GAUZE',
    'CULTS',
    'WIELD',
    'CURES',
    'SNAIL',
    'FIXES',
    'FATED',
    'DOWRY',
    'TONED',
    'HYDRO',
    'BERTH',
    'AVERT',
    'LURED',
    'NORMA',
    'EQUIP',
    'EBONY',
    'MOLES',
    'POURS',
    'GAPED',
    'GLAZE',
    'BRAVO',
    'HAWKS',
    'FERAL',
    'FOURS',
    'BRINE',
    'AIRED',
    'CLUMP',
    'WAFER',
    'ACHES',
    'LUMPS',
    'FAIRS',
    'PEARS',
    'LAWNS',
    'HEADY',
    'PLUSH',
    'HORDE',
    'CHOPS',
    'WHINE',
    'GENOA',
    'ASPEN',
    'TICKS',
    'TEMPS',
    'SYNOD',
    'DENIM',
    'POSIT',
    'FROCK',
    'EARNS',
    'DARTS',
    'AIDES',
    'FLIRT',
    'SWIPE',
    'CRANK',
    'HURST',
    'MINED',
    'PINTO',
    'CRABS',
    'PONTY',
    'ULNAR',
    'TILED',
    'SAHIB',
    'VITAE',
    'DUSKY',
    'BLOKE',
    'CHEFS',
    'ALEPH',
    'SMELT',
    'INFRA',
    'HOTLY',
    'COBRA',
    'SHRUB',
    'CLOVE',
    'VALOR',
    'REMIT',
    'THUGS',
    'AXONS',
    'WHIRL',
    'TAXIS',
    'MATHS',
    'DARES',
    'TONAL',
    'CADRE',
    'TIERS',
    'FARCE',
    'BURLY',
    'WRUNG',
    'GERMS',
    'HERON',
    'REHAB',
    'BUSHY',
    'PALER',
    'BOWER',
    'FARED',
    'FINED',
    'TESLA',
    'KRAFT',
    'SNARL',
    'THROB',
    'FERNS',
    'INSET',
    'PATSY',
    'IRONS',
    'HORNY',
    'PUBIC',
    'HONDA',
    'BISON',
    'CARBS',
    'FARES',
    'SLIME',
    'DINGY',
    'BRUNT',
    'AUGHT',
    'BARNS',
    'GAILY',
    'TINGE',
    'MOIRA',
    'LOUSY',
    'SQUID',
    'WIPES',
    'BAYES',
    'FLAIR',
    'BALES',
    'WAXED',
    'SNOUT',
    'SWAMI',
    'BOLUS',
    'DUKES',
    'TAPER',
    'PALED',
    'POLIS',
    'BOILS',
    'CREAK',
    'NYMPH',
    'LOGIN',
    'WINCE',
    'FEATS',
    'FLYER',
    'HAREM',
    'COLBY',
    'CHING',
    'SLUMP',
    'BANGS',
    'BUTCH',
    'SHRED',
    'LIBER',
    'DOVES',
    'NOSED',
    'BINGO',
    'CRYPT',
    'ANGST',
    'BOUTS',
    'MOVER',
    'HEFTY',
    'LAITY',
    'FIEND',
    'SYBIL',
    'GRAZE',
    'PANES',
    'AUNTY',
    'MOTHS',
    'MODUS',
    'TANGO',
    'WHIPS',
    'BOXED',
    'PLAID',
    'LITER',
    'CAMPO',
    'PRAYS',
    'DECOR',
    'GRAIL',
    'MOLDS',
    'ARSON',
    'LOUIE',
    'SLANT',
    'AMPLY',
    'PATER',
    'AFORE',
    'JANKY',
    'DUTTY',
    'KYLIE',
    'PETRI',
    'MORES',
    'GYRUS',
    'SAVOR',
    'NAVEL',
    'CADET',
    'CUPID',
    'HONED',
    'SAVOY',
    'CANST',
    'SABER',
    'ROWDY',
    'DISCO',
    'SLIMY',
    'LOINS',
    'GABLE',
    'VENTS',
    'MELON',
    'CANTO',
    'JERKS',
    'FORTE',
    'HEALS',
    'HUNTS',
    'JERKY',
    'DRAGS',
    'DOMES',
    'ADIEU',
    'CAGED',
    'OILED',
    'WALDO',
    'TAMED',
    'COWAN',
    'VOIDS',
    'HIRES',
    'ROACH',
    'MUSTY',
    'DIVER',
    'CHURN',
    'PLUGS',
    'ROWED',
    'CLAYS',
    'TAKER',
    'SKATE',
    'FLOPS',
    'WANED',
    'VOLTS',
    'BLITZ',
    'ARGON',
    'WHIGS',
    'SPAWN',
    'UNIFY',
    'FLEUR',
    'CHUTE',
    'TALON',
    'QUOTH',
    'LURCH',
    'SCRUM',
    'SPIRE',
    'LIMBO',
    'JAILS',
    'COMBS',
    'SCOLD',
    'FRANC',
    'TAWNY',
    'ERUPT',
    'CHORE',
    'BEGAT',
    'LIARS',
    'HERTZ',
    'PLAST',
    'HOARD',
    'PANGS',
    'AMOUR',
    'DATUM',
    'CLOUT',
    'WAIVE',
    'THONG',
    'POISE',
    'GOETH',
    'CROFT',
    'INTRO',
    'YARNS',
    'VICHY',
    'YOLKS',
    'ALDER',
    'QUAIL',
    'JACKS',
    'COMER',
    'CLANG',
    'TOWED',
    'DIVES',
    'TWINE',
    'ADORN',
    'GRIMY',
    'BERYL',
    'MEDIC',
    'FUDGE',
    'PAYER',
    'FLIPS',
    'VEILS',
    'SABLE',
    'LONGS',
    'LURID',
    'ROBED',
    'HOIST',
    'PETAL',
    'SWAIN',
    'DUCHY',
    'ZEBRA',
    'HEATS',
    'VIPER',
    'SPECT',
    'BARKS',
    'ROUEN',
    'TUPLE',
    'MADRE',
    'WHIMS',
    'CHIME',
    'CHAMP',
    'OVENS',
    'MAVIS',
    'CHEMO',
    'PERKS',
    'STAVE',
    'OMITS',
    'VIALS',
    'RAINE',
    'LICKS',
    'FOLIC',
    'CAMUS',
    'PHAGE',
    'LITHE',
    'MADGE',
    'CRUMB',
    'BIKER',
    'LUNGE',
    'LITRE',
    'WHACK',
    'MITES',
    'SPELT',
    'SURLY',
    'ISLET',
    'JUNTA',
    'PLUMB',
    'DEMOS',
    'ASHEN',
    'WIGHT',
    'SMITE',
    'OBEYS',
    'LACES',
    'BAYER',
    'TYRES',
    'CLAMS',
    'FONTS',
    'CARTE',
    'HIKES',
    'MACHO',
    'PRIMO',
    'GRIME',
    'QUAKE',
    'GIRTH',
    'LEAKY',
    'EMITS',
    'STOKE',
    'SPURT',
    'PINTS',
    'PLUMS',
    'TONGS',
    'ANVIL',
    'HORST',
    'SCAND',
    'MATED',
    'FITCH',
    'DUMPS',
    'SHEAF',
    'BOGUS',
    'COVEN',
    'PRANK',
    'BUMPY',
    'WARTS',
    'JOKER',
    'GAUDY',
    'MARGE',
    'BRANT',
    'UNMET',
    'FAKED',
    'GUSTO',
    'FLEAS',
    'LANKY',
    'WAVER',
    'TOYED',
    'CHEVY',
    'RUNES',
    'HIKED',
    'GAMUT',
    'QUIRK',
    'TROIS',
    'FLAKE',
    'LOWRY',
    'WINKS',
    'WENCH',
    'PESTO',
    'GLADE',
    'DRIES',
    'YEARN',
    'SPOUT',
    'DRILY',
    'MOREL',
    'FIRTH',
    'FOWLS',
    'TACOS',
    'BOUGH',
    'MARES',
    'CURIE',
    'SALVE',
    'QUINE',
    'DIMER',
    'ITCHY',
    'HOWLS',
    'ACRID',
    'SCOUR',
    'COMFY',
    'SPORE',
    'PHONY',
    'MINCE',
    'CRAZE',
    'LEARY',
    'FORAY',
    'EXALT',
    'NOBLY',
    'RAMPS',
    'PINKY',
    'GEIST',
    'JUMBO',
    'BAYOU',
    'ACORN',
    'AMIDE',
    'SUTRA',
    'AKING',
    'VISOR',
    'ACTON',
    'PRIED',
    'LIVRE',
    'ASKEW',
    'MACON',
    'DUMAS',
    'ARGUS',
    'HAUTE',
    'GLEAN',
    'SONAR',
    'AEGIS',
    'PARSE',
    'WARMS',
    'LOATH',
    'COLES',
    'SHARD',
    'EPICS',
    'MAGES',
    'WAUGH',
    'LUMPY',
    'WILDS',
    'SHIRE',
    'FROTH',
    'RABID',
    'DRAPE',
    'WILES',
    'SERVO',
    'RASPY',
    'ATONE',
    'BANTU',
    'INEPT',
    'CHATS',
    'UNTIE',
    'HIVES',
    'RAFTS',
    'HOLED',
    'BANJO',
    'EDITS',
    'OLDEN',
    'TULIP',
    'QUARK',
    'TURBO',
    'NADIR',
    'BUTYL',
    'STAID',
    'SCALY',
    'PILAR',
    'FRITH',
    'CRAMP',
    'DEBUG',
    'LAGER',
    'BRAWL',
    'RHINO',
    'WRING',
    'KNAVE',
    'SLOTH',
    'MIRED',
    'GOTHS',
    'MEATY',
    'CANES',
    'WINCH',
    'SWATH',
    'KARST',
    'PRUNE',
    'SHORN',
    'DREGS',
    'BRASH',
    'STOMP',
    'DRAWL',
    'GOURD',
    'HELMS',
    'SABRE',
    'DUVET',
    'EARLS',
    'TIPSY',
    'SHANK',
    'PECAN',
    'CLINK',
    'BUNDY',
    'FOAMS',
    'SCUBA',
    'DIVAN',
    'VAGUS',
    'BANCO',
    'DONUT',
    'YANKS',
    'FISHY',
    'PLIED',
    'FLUKE',
    'OMENS',
    'CAFES',
    'LUSTY',
    'OVERS',
    'BEAUX',
    'PINOT',
    'RADON',
    'LINDY',
    'SPIKY',
    'SHOWY',
    'INBOX',
    'TELOS',
    'ABORT',
    'DOETH',
    'LIDAR',
    'CLOTS',
    'LANDE',
    'SELAH',
    'TROVE',
    'RECAP',
    'NOMAD',
    'QUITS',
    'AYRES',
    'WREAK',
    'LIENS',
    'CAKED',
    'MORPH',
    'LOPES',
    'TONGA',
    'DIALS',
    'ASTER',
    'DELFT',
    'KNOBS',
    'DAMES',
    'TWEAK',
    'CAVED',
    'TABOR',
    'RAPES',
    'DRIPS',
    'HAKIM',
    'CURVY',
    'COUPS',
    'ANTES',
    'VOXEL',
    'SATED',
    'ANIME',
    'AMITY',
    'COPSE',
    'PAWNS',
    'MULCH',
    'PARTI',
    'CREDO',
    'MANET',
    'FUNKY',
    'IMAGO',
    'MIRZA',
    'SPILT',
    'GNOME',
    'THANE',
    'MUNCH',
    'SOPHY',
    'DECOY',
    'STORK',
    'RAGES',
    'BUGLE',
    'HYDRA',
    'HANKS',
    'SOWED',
    'MOWER',
    'IRATE',
    'DORMS',
    'BLEST',
    'CRONE',
    'SUING',
    'SITED',
    'DEANS',
    'FUMED',
    'KNEAD',
    'SIBYL',
    'COLDS',
    'PSYCH',
    'VYING',
    'SAUCY',
    'WROTH',
    'GUILE',
    'SULKY',
    'TEPID',
    'STILE',
    'GLOWS',
    'ENDOW',
    'VOUCH',
    'SNORE',
    'POLKA',
    'RHEUM',
    'BLOCS',
    'CALMS',
    'BLURS',
    'DURAL',
    'HARES',
    'CLINE',
    'SLUNK',
    'WAITE',
    'SOAPY',
    'SHREW',
    'SHIED',
    'GALES',
    'MANGE',
    'RUNGS',
    'FEIGN',
    'BUNKS',
    'AUGER',
    'SHOAL',
    'BLURT',
    'DETOX',
    'GULPS',
    'BALMY',
    'ZAIRE',
    'GRITS',
    'CROAK',
    'LIMES',
    'GRICE',
    'TORUS',
    'WREST',
    'DOERS',
    'CRAGS',
    'CHARD',
    'TOADS',
    'RAMUS',
    'QUACK',
    'WAKED',
    'TUBAL',
    'VOLTA',
    'SMOCK',
    'SAWED',
    'SENOR',
    'DOWER',
    'DOWNY',
    'LURKS',
    'LARGO',
    'WISPY',
    'COVEY',
    'CAIRN',
    'TOPAZ',
    'CHINK',
    'PANSY',
    'FELON',
    'CLAPS',
    'COWED',
    'CHIRP',
    'MINAS',
    'CAMEO',
    'OCHRE',
    'CONTE',
    'DURST',
    'COVET',
    'SPRIG',
    'SALVO',
    'LIBRA',
    'CELTS',
    'COLTS',
    'CAPES',
    'STANK',
    'ANISE',
    'CUBED',
    'BURSA',
    'RIPEN',
    'MISER',
    'LONER',
    'BONED',
    'NITRO',
    'KILOS',
    'MOGUL',
    'PROIN',
    'THIOL',
    'SHEIK',
    'AMBIT',
    'CURIA',
    'SETON',
    'SPANK',
    'HIJAB',
    'KITES',
    'FEUDS',
    'DYKES',
    'SCION',
    'FAMES',
    'ILEUM',
    'ROPED',
    'PICKY',
    'SPATE',
    'REBUS',
    'SARGE',
    'TOILS',
    'BEAKS',
    'GOLEM',
    'SPINA',
    'COURS',
    'MUCHO',
    'JUMPY',
    'DUCAL',
    'LEFTY',
    'BAGEL',
    'MOCKS',
    'RECON',
    'GULCH',
    'TIMON',
    'FADER',
    'SUAVE',
    'MAGUS',
    'GIPSY',
    'FIDES',
    'SHIRK',
    'COPED',
    'MUSHY',
    'HYENA',
    'VESTA',
    'MUSKY',
    'TARDY',
    'QUALE',
    'QUINT',
    'GRAYS',
    'ABHOR',
    'PERKY',
    'PUSHY',
    'WELDS',
    'COUPE',
    'MAUVE',
    'FLAKY',
    'RAYNE',
    'CORNY',
    'ZONAL',
    'ONELY',
    'UNLIT',
    'TAXON',
    'BEADY',
    'WAILS',
    'PIQUE',
    'FORME',
    'LURES',
    'SAVER',
    'GIRLY',
    'TACKY',
    'DENTS',
    'TANGY',
    'TALUS',
    'PONCE',
    'CAJUN',
    'SPINY',
    'AUXIN',
    'PROWL',
    'FONDS',
    'JOURS',
    'SHEOL',
    'PASTY',
    'BOREL',
    'MUFTI',
    'RAZED',
    'LUPIN',
    'LINGO',
    'HACKS',
    'FIVES',
    'DAWNS',
    'GOERS',
    'BIOTA',
    'XYLEM',
    'TWIRL',
    'TAKIN',
    'VIXEN',
    'LICHT',
    'NOYES',
    'HARPS',
    'LATHE',
    'STOMA',
    'MICKY',
    'TEARY',
    'SQUAW',
    'CONEY',
    'PIKES',
    'SOPRA',
    'HAIKU',
    'VARUS',
    'CAPRI',
    'CLADE',
    'VIBES',
    'INKED',
    'SINEW',
    'PESKY',
    'BICEP',
    'WRITS',
    'HALTS',
    'DICKY',
    'BRITS',
    'RILED',
    'CUBIT',
    'HOVEL',
    'TRAMS',
    'JOULE',
    'CARON',
    'CLARY',
    'RIVET',
    'AHOLD',
    'FUCKS',
    'GROUT',
    'MANES',
    'MOCHA',
    'PRION',
    'FJORD',
    'MANUS',
    'NICOL',
    'LEGIT',
    'TUBER',
    'EPHOD',
    'HADST',
    'GORSE',
    'DICKS',
    'BARDS',
    'TECHS',
    'GROPE',
    'POKES',
    'FOALS',
    'SURAT',
    'CHINS',
    'RADIX',
    'WICKS',
    'FIXER',
    'MOWED',
    'AMIGO',
    'BURGH',
    'SATYR',
    'HOARY',
    'JORAM',
    'NEVUS',
    'PRAWN',
    'GENTS',
    'PRONG',
    'CORED',
    'IRKED',
    'RIVEN',
    'LOUSE',
    'SABIN',
    'MORAY',
    'QUANT',
    'SHEWN',
    'FONDA',
    'DICEY',
    'TINEA',
    'CALYX',
    'SAYER',
    'FRISK',
    'REBUT',
    'WANDS',
    'PINKS',
    'JAWED',
    'BAWDY',
    'PUDGY',
    'BAYLE',
    'BUOYS',
    'HOMEY',
    'LAPIS',
    'MANSE',
    'TUCKS',
    'MINTS',
    'PARED',
    'PUNKS',
    'WAXES',
    'ALINE',
    'FLECK',
    'AGLOW',
    'FOAMY',
    'HINDS',
    'ARLES',
    'DUELS',
    'BORES',
    'CAPER',
    'CLANK',
    'DEIGN',
    'ORANG',
    'FLIER',
    'PUBIS',
    'PITHY',
    'WHIST',
    'AXLES',
    'RUMEN',
    'TWANG',
    'BRATS',
    'LYTIC',
    'KILNS',
    'KNOWE',
    'TOMES',
    'HALES',
    'HOYLE',
    'ACKER',
    'OHMIC',
    'RIFTS',
    'DEWAR',
    'GAMER',
    'FETID',
    'ZONED',
    'RAVED',
    'SEPTA',
    'CODER',
    'PAWED',
    'HAVES',
    'HAUSE',
    'PELTS',
    'MUCIN',
    'JACKY',
    'BLUME',
    'FOILS',
    'SNIDE',
    'MIDGE',
    'DEARS',
    'GAVEL',
    'DOLCE',
    'YOKED',
    'ILEUS',
    'MINTY',
    'LAKHS',
    'BEGOT',
    'CHEWS',
    'GRIST',
    'CRUMP',
    'LIKEN',
    'MOLDY',
    'COWER',
    'OLEIC',
    'SPITZ',
    'CHEWY',
    'HEIST',
    'REMIX',
    'HOWES',
    'SEPIA',
    'AFIRE',
    'BOARS',
    'OAKEN',
    'GREYS',
    'PACTS',
    'GRUEL',
    'MAVEN',
    'ATMOS',
    'DORIC',
    'SOWER',
    'BODHI',
    'JOLTS',
    'QUASH',
    'LOUGH',
    'GATOR',
    'FAKES',
    'GHOUL',
    'WAKEN',
    'SNIPE',
    'FAGIN',
    'HALVE',
    'DRACO',
    'EXONS',
    'DULCE',
    'CARPI',
    'FOUNT',
    'YOGIC',
    'TONER',
    'MONAD',
    'HIKER',
    'VOLAR',
    'HATER',
    'APHID',
    'OSTIA',
    'GROSZ',
    'GLANS',
    'CLOGS',
    'HAILS',
    'DICTA',
    'FAERY',
    'DIKES',
    'MITRE',
    'SLINK',
    'MAZES',
    'PLAIT',
    'TASER',
    'MOTES',
    'PRISE',
    'COMBE',
    'MUNGO',
    'SCONE',
    'PORED',
    'PAILS',
    'ORIEL',
    'GLOAT',
    'RAMEN',
    'SCRIP',
    'RICKS',
    'SORTA',
    'SPIEL',
    'TANSY',
    'RAKES',
    'AUTOS',
    'CLUNK',
    'THUNK',
    'SYNTH',
    'SPUNK',
    'FEINT',
    'JAUNT',
    'HOWDY',
    'EXTOL',
    'LOBED',
    'CROUP',
    'DELOS',
    'CRIMP',
    'QUBIT',
    'DIMES',
    'HYMEN',
    'DOEST',
    'PUNTO',
    'EVICT',
    'DIELS',
    'SCAPE',
    'RIVAS',
    'TACKS',
    'SURAH',
    'YAWNS',
    'RAVEL',
    'MANOS',
    'NUBIA',
    'TRAWL',
    'ROQUE',
    'BIGHT',
    'AFOUL',
    'IMBUE',
    'BREWS',
    'KETCH',
    'BREAM',
    'PEALS',
    'SHURA',
    'INGOT',
    'TAMER',
    'MATIN',
    'ERICK',
    'EMOJI',
    'DIRGE',
    'BEGUM',
    'FESTA',
    'DALES',
    'BRAWN',
    'GOEST',
    'PLOWS',
    'BASER',
    'BIOME',
    'HUMIC',
    'BROIL',
    'ELFIN',
    'SWART',
    'CHAFE',
    'RUBLE',
    'IDLER',
    'UNZIP',
    'SENZA',
    'BRUIN',
    'DEGAS',
    'BILGE',
    'APTER',
    'SKEIN',
    'PAGER',
    'WACKY',
    'FORDS',
    'GUANO',
    'ARCED',
    'HAFIZ',
    'REAMS',
    'ANTSY',
    'GAUZY',
    'LEAFS',
    'LOBAR',
    'LARKS',
    'WELTS',
    'QUAYS',
    'METIS',
    'SHITE',
    'MINOS',
    'LARCH',
    'SOREL',
    'PEONY',
    'KRAUT',
    'NEARS',
    'KEFIR',
    'BUXOM',
    'OVATE',
    'PAVES',
    'BELCH',
    'TARES',
    'FILMY',
    'PALES',
    'POSEY',
    'CHUMS',
    'RANCE',
    'FLACK',
    'SAYED',
    'FLUME',
    'BIGOT',
    'SILTY',
    'CHINE',
    'BAIRN',
    'HYOID',
    'ENROL',
    'THRUM',
    'GECKO',
    'BLARE',
    'SIMUL',
    'BALDY',
    'HILAR',
    'KANJI',
    'NOVUM',
    'WORDY',
    'RHONE',
    'GNATS',
    'DINGO',
    'NERDS',
    'CAPUT',
    'PANTY',
    'NERDY',
    'GUMBO',
    'UNWED',
    'COVES',
    'SUMAC',
    'NEATH',
    'NIZAM',
    'CURBS',
    'JAGER',
    'YOGIS',
    'SIEUR',
    'QUIPS',
    'DEISM',
    'SCRAM',
    'CHIDE',
    'LAVER',
    'DEVAS',
    'SCAMP',
    'PRODS',
    'BOWES',
    'KYRIE',
    'RAYON',
    'CURDS',
    'LUDIC',
    'MANGY',
    'HALOS',
    'CRONY',
    'NEIGH',
    'ROVED',
    'VANES',
    'GLYPH',
    'REDUX',
    'THUDS',
    'GWINE',
    'CHIMP',
    'FILET',
    'SKIER',
    'VISTO',
    'FOVEA',
    'KLUGE',
    'SARIN',
    'KUDOS',
    'LOPED',
    'LOVEY',
    'NICKS',
    'BLOTS',
    'NIFTY',
    'PARLE',
    'CULPA',
    'FOREX',
    'EOSIN',
    'TRIPE',
    'GUSTY',
    'NAVES',
    'TRICE',
    'ROSIN',
    'LONGE',
    'JUNTO',
    'EYING',
    'OBJET',
    'MOPED',
    'OGRES',
    'RAPHE',
    'SERIF',
    'CLIME',
    'SPURN',
    'VIRES',
    'RECTO',
    'CUTIE',
    'HARPY',
    'UNARY',
    'CLODS',
    'GAULT',
    'MAIRE',
    'PLIES',
    'HAPLY',
    'VAMPS',
    'MARLY',
    'SAVIN',
    'BANDY',
    'MAYST',
    'GRUBS',
    'TAELS',
    'SOLED',
    'ONTIC',
    'MILKS',
    'HANKY',
    'AZIDE',
    'PINED',
    'APHIS',
    'SWARD',
    'ALECK',
    'RANTS',
    'WAXEN',
    'WIPER',
    'FUTON',
    'MELBA',
    'PICOT',
    'THORP',
    'WHORL',
    'VENAL',
    'CORKY',
    'BLING',
    'STREP',
    'CURIO',
    'BUNCE',
    'VOLTE',
    'VINER',
    'NOSEY',
    'DOUSE',
    'PRUDE',
    'CATES',
    'GRIPE',
    'WIGAN',
    'DOUCE',
    'SIDER',
    'JOCKS',
    'SITKA',
    'TABER',
    'VOLES',
    'CHERT',
    'AMBLE',
    'GARBO',
    'BATED',
    'REFIT',
    'DECRY',
    'TREKS',
    'HAULS',
    'YIKES',
    'FOULE',
    'HYPED',
    'OVALS',
    'CORAM',
    'PHYLA',
    'SOLER',
    'VILDE',
    'CASED',
    'IMPEL',
    'CHINO',
    'THANG',
    'BAITS',
    'WHINY',
    'GOMER',
    'KANDY',
    'HUNKY',
    'POUTY',
    'PAGED',
    'BOCHE',
    'VETCH',
    'NARES',
    'JOWLS',
    'ASCOT',
    'RANKE',
    'BLUED',
    'CORKS',
    'GOWAN',
    'WANES',
    'GHATS',
    'EXULT',
    'DUETS',
    'DOWEL',
    'FICUS',
    'HURLS',
    'GLENS',
    'EXPAT',
    'PASEO',
    'SIDHE',
    'CONUS',
    'ROWEN',
    'GRUND',
    'NUDES',
    'DEMUR',
    'CLAES',
    'FRETS',
    'REIFY',
    'HILUM',
    'MOULT',
    'MODER',
    'ULEMA',
    'MILCH',
    'CRIBS',
    'PYLON',
    'DINGE',
    'SLURP',
    'LOMAS',
    'TILAK',
    'INLAY',
    'QUADS',
    'MEALY',
    'LEVIS',
    'STELA',
    'TERNS',
    'PHIAL',
    'JAKES',
    'BOLES',
    'BETAS',
    'AEONS',
    'SANGH',
    'FAZED',
    'STRUM',
    'BOGEY',
    'SPLAT',
    'RUNIC',
    'AMBOS',
    'DIRKS',
    'CAIRD',
    'SNARK',
    'FURAN',
    'VROUW',
    'POESY',
    'MOUSY',
    'PSHAW',
    'AVERS',
    'FARTS',
    'VAPID',
    'MAFIC',
    'PAYOR',
    'CUTIS',
    'STUPA',
    'FITLY',
    'BASTE',
    'SIRED',
    'FOLIA',
    'FILER',
    'POACH',
    'TINES',
    'UMBER',
    'COPES',
    'FROSH',
    'LOCUM',
    'DINES',
    'DUPES',
    'CLIFT',
    'COKES',
    'YOUSE',
    'LUGER',
    'FLORY',
    'BONER',
    'SHAUL',
    'MEATH',
    'BAIZE',
    'GHAZI',
    'BAKES',
    'PLEBS',
    'SCALD',
    'YELPS',
    'URATE',
    'WOMBS',
    'BOGLE',
    'HUMPS',
    'CUSHY',
    'NOIRS',
    'LONGA',
    'GOLDS',
    'JANES',
    'BOGIE',
    'BITSY',
    'PAOLI',
    'TRIMS',
    'GONER',
    'REALS',
    'SWANK',
    'MARSE',
    'KILEY',
    'CHUMP',
    'SAMBO',
    'BARDO',
    'BRACK',
    'CORNS',
    'DUNCE',
    'BRUIT',
    'BONEY',
    'GULFS',
    'OUIJA',
    'SWARE',
    'BRINY',
    'BENTO',
    'SYLVA',
    'XENIA',
    'DEWAN',
    'MUDGE',
    'CENTO',
    'ODIUM',
    'COPRA',
    'ICTAL',
    'ARTIS',
    'PERDU',
    'CRUSE',
    'ASTIR',
    'WHATS',
    'BORAX',
    'REPOS',
    'BLAIN',
    'CRAPE',
    'DIWAN',
    'GANDY',
    'VALES',
    'QUIRE',
    'LYASE',
    'PIEZO',
    'UMBRA',
    'HUNKS',
    'FLOUT',
    'WEALD',
    'JINKS',
    'MUDRA',
    'SHUTE',
    'DINAR',
    'TYPOS',
    'MUTES',
    'ROAMS',
    'CORSE',
    'LOFTS',
    'PREST',
    'HULKS',
    'FASTI',
    'LOWED',
    'GRYCE',
    'CLAVE',
    'COMUS',
    'INGLE',
    'MORTS',
    'CHUSE',
    'WRAPT',
    'JOIST',
    'SINGE',
    'ERGOT',
    'NARCO',
    'PEDIS',
    'VELAR',
    'JOUST',
    'CLARO',
    'YOKES',
    'JUKES',
    'SHUCK',
    'BELAY',
    'WRACK',
    'MANDI',
    'WHELP',
    'FAWNS',
    'GIZMO',
    'KNITS',
    'SELVA',
    'GONAD',
    'BIRKS',
    'LOAMY',
    'RAVES',
    'NACHO',
    'CAGEY',
    'ALTOS',
    'RETCH',
    'WARPS',
    'SAULT',
    'DOPEY',
    'FLITS',
    'DURAS',
    'CULEX',
    'WAFTS',
    'BORIC',
    'BOEUF',
    'FAXED',
    'DEOXY',
    'MARON',
    'OUTED',
    'BLUER',
    'MALIC',
    'GUTSY',
    'WONKY',
    'ANKER',
    'THINS',
    'DUMPY',
    'FURZE',
    'HONKY',
    'GOUTY',
    'FORZA',
    'PINGS',
    'PINEY',
    'SYNCH',
    'REAPS',
    'HAVER',
    'MOXIE',
    'HORAS',
    'ALOES',
    'ARTSY',
    'DUCKY',
    'CAPEX',
    'SPLAY',
    'NOMIC',
    'BLOAT',
    'WAZIR',
    'OUTRE',
    'SIMBA',
    'CARBO',
    'TUNER',
    'BIJOU',
    'WRENS',
    'FOLIE',
    'VESPA',
    'SAGER',
    'RIOJA',
    'VOILA',
    'OPINE',
    'SOLUM',
    'WEIRS',
    'HOLME',
    'RAYED',
    'RUEDA',
    'KRANZ',
    'ORCAS',
    'MESON',
    'CORBY',
    'COLEY',
    'BLIVE',
    'JUNKS',
    'DAMPS',
    'SHAND',
    'SOYUZ',
    'CRAPS',
    'DEARY',
    'LEMUR',
    'SLAKE',
    'TROMP',
    'BRANE',
    'BOULE',
    'PREYS',
    'FLOES',
    'CAPON',
    'BLEAT',
    'BECKS',
    'CRISE',
    'SULCI',
    'QUARE',
    'WIMPY',
    'FECIT',
    'FAKIR',
    'PECKS',
    'TARPS',
    'PEKIN',
    'STICH',
    'DECAF',
    'RIMES',
    'GROAT',
    'PAROL',
    'LIVEN',
    'NUKES',
    'GLUES',
    'QUALM',
    'PUKED',
    'KRONE',
    'DEIST',
    'VOLKS',
    'TENCH',
    'LAUDS',
    'CARLE',
    'DEVOS',
    'SALIX',
    'ERGON',
    'LATED',
    'DINKY',
    'SHERD',
    'FROND',
    'SANER',
    'LORIS',
    'SYRAH',
    'SCARP',
    'LEMAN',
    'WANLY',
    'BOURG',
    'RIVES',
    'SPINK',
    'SEPOY',
    'HOMED',
    'CLOKE',
    'SALUT',
    'PAULS',
    'OCULI',
    'PURTY',
    'PACEY',
    'LIGNE',
    'PARES',
    'PANKO',
    'RANGY',
    'CAROB',
    'RUMBA',
    'PLAGE',
    'MALUS',
    'DOYEN',
    'TRIOS',
    'TORIC',
    'FIVER',
    'BATIK',
    'HARKS',
    'TSKED',
    'CLUED',
    'THERM',
    'TAUBE',
    'KAMES',
    'HIJRA',
    'GLACE',
    'EDIFY',
    'CADES',
    'ZETAS',
    'SKIED',
    'STADE',
    'MOATS',
    'BIPED',
    'RINDS',
    'LUCRE',
    'PLOYS',
    'SURAL',
    'GETUP',
    'NAZIR',
    'LORDY',
    'EXPOS',
    'STREW',
    'GAYER',
    'PANED',
    'GENOM',
    'BURKS',
    'OMBRE',
    'CALIX',
    'UVEAL',
    'SUCRE',
    'PACER',
    'IZARD',
    'LAIRS',
    'AMPED',
    'DYERS',
    'OVINE',
    'GLUON',
    'BUNTY',
    'BOSUN',
    'SEBUM',
    'MELAS',
    'KHANS',
    'POSER',
    'OTAKU',
    'PILAF',
    'EMIRS',
    'SAKTI',
    'OBEAH',
    'MEADS',
    'ERING',
    'HOCUS',
    'CERIA',
    'LYCRA',
    'COLAS',
    'MACHI',
    'HANTS',
    'LIANE',
    'MITER',
    'WILTS',
    'HAMED',
    'BYLAW',
    'TAXOL',
    'OVULE',
    'PORKY',
    'TULSI',
    'ANTIC',
    'CRAKE',
    'RONDE',
    'UPEND',
    'BURQA',
    'RALES',
    'HILTS',
    'AILED',
    'GLITZ',
    'DIVAS',
    'LIFES',
    'KILTS',
    'DAUNT',
    'JIBES',
    'ARGOT',
    'COMAS',
    'PROMS',
    'FOYLE',
    'COMPS',
    'ABIES',
    'STIPE',
    'DANCY',
    'SADHU',
    'GORED',
    'KERNS',
    'PEONS',
    'CAMPI',
    'BODES',
    'FINCA',
    'MARTS',
    'NEGUS',
    'MILOS',
    'STAPH',
    'NERVY',
    'BROCH',
    'STANE',
    'DITES',
    'STUNK',
    'SPRUE',
    'TELIC',
    'ZESTY',
    'WARTY',
    'SIDLE',
    'CHIAO',
    'MUCKY',
    'DINGS',
    'CHEKA',
    'SULFA',
    'LOVAT',
    'LAMED',
    'MECHS',
    'BRIMS',
    'BARES',
    'SHOJI',
    'CLEAT',
    'ELAND',
    'ARCUS',
    'WHARE',
    'ALTHO',
    'DRAMS',
    'BLIMP',
    'YAGER',
    'TOLAN',
    'SIGNA',
    'FERIA',
    'POKEY',
    'HEALD',
    'DOZER',
    'YERBA',
    'PROST',
    'BRACH',
    'OGLED',
    'COSTE',
    'FAXES',
    'TEMPI',
    'HYLAS',
    'BEATY',
    'LIMPS',
    'ROUTH',
    'DUMBO',
    'GAWKY',
    'DATOS',
    'SAHEB',
    'LOACH',
    'MALTS',
    'CORNU',
    'SPRAT',
    'MAURI',
    'MASER',
    'MACHE',
    'ABLED',
    'STENO',
    'CHARY',
    'DUCES',
    'UTILE',
    'SOUPY',
    'RECTA',
    'STRIA',
    'DASHI',
    'TRINE',
    'HADJI',
    'FOULS',
    'THEMA',
    'HOMAS',
    'AURIC',
    'ATOPY',
    'PROEM',
    'NIDUS',
    'CANTY',
    'DUITS',
    'FORAM',
    'THEIN',
    'BERKS',
    'BROME',
    'DUCAT',
    'BEFIT',
    'BEALS',
    'CUNTS',
    'PHLOX',
    'MOZES',
    'CHELA',
    'VOCES',
    'KOHEN',
    'FAYRE',
    'MENSA',
    'BOGUE',
    'ARCOS',
    'COADY',
    'DOULA',
    'TALER',
    'YORKS',
    'VERTU',
    'CHYME',
    'SITAR',
    'DOBIE',
    'LUTES',
    'PLASM',
    'SYLPH',
    'DEBAR',
    'BRAGS',
    'KUGEL',
    'LARES',
    'SWAMY',
    'FEIST',
    'MUONS',
    'WAIFS',
    'RESTO',
    'VELDT',
    'MAXED',
    'JONTY',
    'APING',
    'CHOLA',
    'WETLY',
    'OPALS',
    'AZOLE',
    'HOCKS',
    'AGERS',
    'DOGAN',
    'SWALE',
    'MEANY',
    'EIDOS',
    'BITER',
    'GAITS',
    'MATEY',
    'LAKER',
    'CHARS',
    'ARCHI',
    'ASPER',
    'ABORD',
    'STANG',
    'CORGI',
    'ZINES',
    'TOQUE',
    'NIQAB',
    'CHOMP',
    'ADIOS',
    'CUTER',
    'SERAI',
    'WASHY',
    'LAYUP',
    'LAYIN',
    'SNICK',
    'PLATS',
    'DRYAS',
    'DECAL',
    'OCTAL',
    'SNAKY',
    'GNAWS',
    'PRIES',
    'INCUS',
    'BLIPS',
    'HOKEY',
    'JAMBS',
    'GRADS',
    'CAMPY',
    'TARSI',
    'DROPT',
    'PORGY',
    'CALIF',
    'CIVET',
    'NEWTS',
    'SHEVA',
    'YAMEN',
    'KAFIR',
    'SNEAD',
    'TRIGO',
    'CAVIL',
    'GAPES',
    'SCHWA',
    'TAPIR',
    'MANTO',
    'DELIS',
    'FUNDY',
    'PLUNK',
    'FOIST',
    'KLANG',
    'DICER',
    'CONGA',
    'ENIAC',
    'MYLAR',
    'PLENA',
    'VELUM',
    'SPICA',
    'GUYOT',
    'LOWES',
    'WHEAL',
    'BORDE',
    'ZILCH',
    'ICHOR',
    'AMRIT',
    'DIOLS',
    'PLEAT',
    'HURLY',
    'RACHE',
    'PYREX',
    'VINCA',
    'LOCHS',
    'PEATY',
    'DOWIE',
    'KENAF',
    'BLUEY',
    'OCHER',
    'ABUTS',
    'KOINE',
    'BALED',
    'LATHS',
    'HOSED',
    'CAWED',
    'PYRES',
    'DHIKR',
    'CHIVE',
    'POUTS',
    'THECA',
    'OXIME',
    'SPICK',
    'CYANO',
    'GOADS',
    'FLUOR',
    'HAZED',
    'ROSHI',
    'LAPIN',
    'BRONC',
    'UTERI',
    'LIMOS',
    'QUIST',
    'TOMAN',
    'CRIPS',
    'MOYLE',
    'BUNDT',
    'BUSTY',
    'XYLAN',
    'BRUNG',
    'KIANG',
    'IDENT',
    'SKIMP',
    'DREST',
    'GAZER',
    'AIMER',
    'TILDE',
    'AIDER',
    'RILES',
    'SCUDI',
    'RITZY',
    'BOGAN',
    'LADER',
    'EKING',
    'SODIC',
    'FURTH',
    'TAIKO',
    'BERGS',
    'SAMEN',
    'LYSED',
    'LIFER',
    'RUTIN',
    'DUPLE',
    'KLUTZ',
    'FRONS',
    'DOTES',
    'COSET',
    'HOMIE',
    'FRITS',
    'TAXUS',
    'TONEY',
    'NOVAE',
    'FIORD',
    'LEAVY',
    'TONKS',
    'SPIER',
    'FIBRO',
    'LAVED',
    'HARTS',
    'STOND',
    'SOMAN',
    'VOILE',
    'WIMPS',
    'HARIM',
    'RENDS',
    'TERAI',
    'JUNCO',
    'AGIOS',
    'CHURL',
    'PILUS',
    'MUCOR',
    'UNSAY',
    'GILTS',
    'PINTA',
    'GLOBS',
    'SAFED',
    'SICHT',
    'LINAC',
    'TAUPE',
    'KERMA',
    'TOADY',
    'VAUNT',
    'MIKES',
    'POLED',
    'YOURN',
    'LOUTS',
    'LUTEA',
    'JINGO',
    'DENCH',
    'LIMAN',
    'HANSE',
    'JULEP',
    'THAWS',
    'MORIA',
    'ABLER',
    'MOTEN',
    'MANIS',
    'PETAR',
    'ASPIC',
    'LYRES',
    'CARET',
    'PEART',
    'CLOZE',
    'BOTCH',
    'PRATE',
    'PIGMY',
    'CAREX',
    'AMUCK',
    'MAZER',
    'ANCHO',
    'DOSHA',
    'JOKEY',
    'BASTI',
    'SQUIB',
    'DOVIE',
    'GNASH',
    'HOLEY',
    'LORAN',
    'CAULK',
    'EJIDO',
    'RIALS',
    'WISHT',
    'PIONS',
    'FLUES',
    'SOFTY',
    'FAUNS',
    'OAKUM',
    'DORKY',
    'TRIKE',
    'ARSED',
    'BAULK',
    'STOUR',
    'MOTUS',
    'COTES',
    'CAPED',
    'MENDS',
    'KURTA',
    'LINGA',
    'AGONE',
    'MACES',
    'BULKS',
    'MATZO',
    'PRAMS',
    'OILER',
    'WENDS',
    'BOTHY',
    'DOLES',
    'RIBES',
    'SAUTE',
    'SHOYU',
    'BANES',
    'RANGI',
    'MESIC',
    'PERIS',
    'NIDAL',
    'RIBAS',
    'COBLE',
    'RAMIE',
    'CHOWK',
    'KHADI',
    'MOSEY',
    'RINKS',
    'NOVAS',
    'PROFS',
    'GEOID',
    'DELPH',
    'NOMES',
    'SALMI',
    'HAMES',
    'SALTO',
    'KUTCH',
    'MUSCA',
    'BOYAR',
    'ACNES',
    'PADRI',
    'BRIGS',
    'PISCO',
    'CHOUX',
    'REDAN',
    'RUBEL',
    'HERBY',
    'GAOLS',
    'VALSE',
    'MORNE',
    'PODGE',
    'OPSIN',
    'PAYED',
    'PROWS',
    'WURST',
    'WADES',
    'HONKS',
    'HIVER',
    'GYROS',
    'FRATE',
    'VOCAB',
    'BLASE',
    'CANED',
    'SCRIM',
    'COMBI',
    'DROME',
    'ADOWN',
    'GARNI',
    'NITRE',
    'TORAN',
    'PRESA',
    'LORES',
    'BORDS',
    'BURKA',
    'BLENT',
    'TURDS',
    'BALKS',
    'AXILS',
    'GILDS',
    'BEKAH',
    'SIZER',
    'DAINE',
    'LOGIE',
    'DIAZO',
    'ANTIS',
    'KISAN',
    'JUVIE',
    'MOSTE',
    'BIKED',
    'KOMBU',
    'YUKOS',
    'PONTS',
    'CUING',
    'DARKY',
    'BOURN',
    'WORMY',
    'LOUPE',
    'YOKEL',
    'FORBS',
    'SOLAN',
    'MELDS',
    'MINKS',
    'TELCO',
    'WADIS',
    'GENIC',
    'QUAIS',
    'HONES',
    'OCTYL',
    'QUIRT',
    'PUBES',
    'DHOTI',
    'DICES',
    'RELIT',
    'FREON',
    'SEGNI',
    'ABLES',
    'JAKEY',
    'NIXED',
    'CZARS',
    'GAMIN',
    'GIBES',
    'LATEN',
    'LAVES',
    'FLEXI',
    'BINKS',
    'HUGER',
    'MINKE',
    'VALIS',
    'SLANE',
    'SAKER',
    'DOILY',
    'BRUST',
    'POULT',
    'STROP',
    'TOGAS',
    'ASKER',
    'PLASH',
    'ITHER',
    'YURTS',
    'PIETA',
    'NGATI',
    'HOVEN',
    'SPUME',
    'MUZAK',
    'WINED',
    'LEARS',
    'MERCS',
    'SANGO',
    'FAKER',
    'SULPH',
    'BILES',
    'MANED',
    'MONIC',
    'SAYID',
    'WHUMP',
    'BRACT',
    'GULPH',
    'LIKER',
    'JUNKY',
    'DIVOT',
    'GRUMP',
    'VERTS',
    'CEIBA',
    'DYNES',
    'PITON',
    'HANCE',
    'DARKS',
    'WHANG',
    'ANDRO',
    'LAYED',
    'CHOTA',
    'STOEP',
    'KAPUT',
    'GOLDY',
    'GULES',
    'KENDO',
    'PIRLS',
    'SEPAL',
    'FUSTY',
    'PUMAS',
    'NKOSI',
    'LITES',
    'BENDY',
    'ARTIC',
    'LOVIE',
    'BAILS',
    'DRAVE',
    'PUCKS',
    'FILCH',
    'PANDY',
    'RAMIS',
    'CALVE',
    'SABOT',
    'FLOCS',
    'PISTE',
    'FLUNK',
    'SEAMY',
    'MUTCH',
    'SOLDI',
    'ANIGH',
    'RODES',
    'SEGNO',
    'VARDY',
    'PLONK',
    'KIVAS',
    'ATONY',
    'UMBLE',
    'MOCHI',
    'TRAGI',
    'REDON',
    'ONLAY',
    'VOMER',
    'TAKIS',
    'BASHO',
    'BAITH',
    'SLATY',
    'PEATS',
    'DEBUS',
    'BURIN',
    'MULEY',
    'AVOWS',
    'BIDET',
    'GRIOT',
    'OSIER',
    'BUTOH',
    'LOUED',
    'PUNTS',
    'TAMIS',
    'BRULE',
    'FELTS',
    'TAMES',
    'KHEDA',
    'HELIO',
    'AESIR',
    'DAUBE',
    'CHITS',
    'ALKYD',
    'FAGOT',
    'TUNAS',
    'DHOWS',
    'LARDY',
    'COATE',
    'NACRE',
    'ALGUM',
    'SHIEL',
    'BERMS',
    'BARMY',
    'LUBED',
    'BAYED',
    'RAMIN',
    'HAOLE',
    'LAITH',
    'LOCIS',
    'TAINS',
    'SQUAB',
    'GOUTS',
    'OARED',
    'RAVIN',
    'GORES',
    'PLINK',
    'BOING',
    'WOFUL',
    'PSEUD',
    'REDLY',
    'HALED',
    'LOHAN',
    'SEDUM',
    'TICAL',
    'BALER',
    'WIFEY',
    'COPAL',
    'FILUM',
    'GLUTE',
    'MICAS',
    'UNSET',
    'CLEWS',
    'SICKO',
    'SPRIT',
    'RAMET',
    'MIRES',
    'LAKIN',
    'RICHT',
    'CORMS',
    'VIOLS',
    'SCENA',
    'SALIC',
    'INURE',
    'MALTY',
    'PHANG',
    'KAURI',
    'SILEX',
    'HAWED',
    'BUSED',
    'DAVIT',
    'JADES',
    'TONKA',
    'PROLE',
    'BROSE',
    'VIREO',
    'JIRGA',
    'WACKO',
    'ELDIN',
    'TICHY',
    'LENTO',
    'POMBE',
    'MERCH',
    'GYRES',
    'FATSO',
    'BALMS',
    'PROBS',
    'PHARE',
    'CODAS',
    'TONUS',
    'MARLS',
    'PODGY',
    'DUALS',
    'BYRES',
    'LEFTS',
    'ROMPS',
    'LATUS',
    'KANTS',
    'SURED',
    'TWERP',
    'GRISE',
    'BUNDS',
    'FRIST',
    'SOAVE',
    'PUDGE',
    'TINGS',
    'DOWSE',
    'YOGIN',
    'JURAL',
    'DUKAS',
    'BRAES',
    'MAIST',
    'SABIR',
    'GOYIM',
    'BASIJ',
    'CRONK',
    'PROSY',
    'FRACT',
    'CULMS',
    'YODEL',
    'PELAS',
    'BASON',
    'MIZEN',
    'QIBLA',
    'UNFED',
    'AMIRS',
    'DUPER',
    'DULSE',
    'FAROS',
    'DUROC',
    'HEXYL',
    'FLITE',
    'TYPIC',
    'PEAKY',
    'RESID',
    'BOULT',
    'CURST',
    'VLOGS',
    'GURDY',
    'CULTY',
    'FRACK',
    'COVIN',
    'DEIFY',
    'MILER',
    'MINAR',
    'KYNDE',
    'ENVOI',
    'FOGLE',
    'WOLDS',
    'COZEN',
    'DANIO',
    'FACER',
    'EMACS',
    'YOGAS',
    'BURPS',
    'COWLS',
    'HEROS',
    'CARSE',
    'ARISH',
    'NASHI',
    'CROME',
    'TOILE',
    'EIKON',
    'REGNA',
    'DRAYS',
    'STOPE',
    'FAYED',
    'KOPJE',
    'PRATS',
    'BESOM',
    'RANIS',
    'HIDER',
    'RECTI',
    'ZACKS',
    'FRISE',
    'PAISE',
    'SNAFU',
    'LUNGI',
    'AIGHT',
    'RUMPS',
    'FOREL',
    'GOLPE',
    'FICHE',
    'MACER',
    'GLUEY',
    'NUMBS',
    'ROUTS',
    'MARLE',
    'CHYLE',
    'DAMNS',
    'DUROY',
    'LIRAS',
    'KRONA',
    'LITHO',
    'PAVER',
    'BOLAS',
    'CADIE',
    'DOZES',
    'THUJA',
    'VEINY',
    'CESTA',
    'PALMY',
    'LAMER',
    'DAUBS',
    'OLDIE',
    'MEOWS',
    'CAULD',
    'MILOR',
    'TANGI',
    'DRABS',
    'HUMPY',
    'SPANG',
    'ROUST',
    'BEAUT',
    'OGIVE',
    'GOTCH',
    'REIST',
    'AMIDO',
    'CARDI',
    'SENTI',
    'TACHE',
    'PATEN',
    'HALSE',
    'MILPA',
    'UNICA',
    'HOUTS',
    'LOAMS',
    'COMIX',
    'CLAST',
    'MISCH',
    'BEAKY',
    'AXION',
    'WHAUR',
    'NAEVI',
    'INAPT',
    'LINUM',
    'KHOJA',
    'CARBY',
    'DOLCI',
    'MURTI',
    'MORAS',
    'TWINK',
    'CHUBS',
    'VAKIL',
    'SUCKY',
    'ICTUS',
    'TOKER',
    'KEMPT',
    'LEPRA',
    'RUBES',
    'SALOP',
    'HAWSE',
    'JIBED',
    'DONER',
    'LIMEY',
    'SOLDE',
    'HARDS',
    'GODET',
    'TYRAN',
    'TREWS',
    'TOKAY',
    'ECHOS',
    'CADGE',
    'LUNES',
    'JOBES',
    'HERMS',
    'KELTY',
    'BUNKO',
    'FUGAL',
    'LYNES',
    'STURE',
    'CLOMP',
    'FAUGH',
    'FITNA',
    'PATED',
    'JUTES',
    'RANDS',
    'CARPS',
    'PAIRE',
    'MELTY',
    'ADZES',
    'SNOEK',
    'DINOS',
    'MESTO',
    'WOLFS',
    'HOVED',
    'JOWLY',
    'AVION',
    'SYREN',
    'COEDS',
    'BUTEO',
    'BENTS',
    'OGHAM',
    'SHAKO',
    'WHELK',
    'GAMED',
    'AZIDO',
    'DITZY',
    'YULAN',
    'CAJON',
    'SOFAR',
    'GULAR',
    'DONGA',
    'CRITS',
    'PRANG',
    'SKALD',
    'SMOUT',
    'ORVAL',
    'PANTO',
    'GLUME',
    'CERTS',
    'BRAZE',
    'QUERN',
    'JOYED',
    'PUNKY',
    'BEAUS',
    'RHYNE',
    'REMAP',
    'MALIS',
    'APRES',
    'XRAYS',
    'WISED',
    'MOIRE',
    'WITAN',
    'FOXED',
    'LOPER',
    'RECUT',
    'DICOT',
    'DHOLE',
    'NABIS',
    'SPEAN',
    'AMENS',
    'CHUGS',
    'VIRTU',
    'COXAE',
    'COMPT',
    'CLEFS',
    'TROAD',
    'HEMIN',
    'FERNY',
    'BRISE',
    'DURES',
    'PLICA',
    'WHILK',
    'CANID',
    'ROTIS',
    'TYERS',
    'SHYER',
    'ABETS',
    'HALON',
    'TRONE',
    'FAYNE',
    'LIMEN',
    'SEGAR',
    'OLEUM',
    'SILER',
    'WRANG',
    'LAZED',
    'BIPOD',
    'VITEX',
    'LOGIA',
    'BLECH',
    'BRAME',
    'BETON',
    'BUIST',
    'PILCH',
    'HAYLE',
    'GOFER',
    'REPIN',
    'ZLOTY',
    'WADER',
    'THEWS',
    'TAPIS',
    'CIVES',
    'CHAVE',
    'FUERO',
    'LINGS',
    'SKINT',
    'STARN',
    'SHOPE',
    'CARNY',
    'BEANO',
    'DANKS',
    'AURIS',
    'KURIS',
    'STEIL',
    'IKONS',
    'APERT',
    'WILCO',
    'MUREX',
    'VITAS',
    'TRODE',
    'FICHU',
    'BALTI',
    'PLODS',
    'ORATE',
    'PITAS',
    'ROPEY',
    'ZYGON',
    'BIDES',
    'OATEN',
    'NATES',
    'CHAPT',
    'PARCH',
    'HOKUM',
    'NGOMA',
    'DIGHT',
    'MBIRA',
    'ALUMS',
    'DRUPE',
    'ROULE',
    'FRUMP',
    'HAINT',
    'XERIC',
    'AULOS',
    'COSEY',
    'DUNKS',
    'CARDY',
    'SOUGH',
    'THALI',
    'KALIF',
    'DOGES',
    'ECLAT',
    'SLUIT',
    'HINGS',
    'WAQFS',
    'SERIN',
    'DONAS',
    'ZANTE',
    'BLEAR',
    'GIMPY',
    'AVISO',
    'LOUPS',
    'WARBY',
    'DEVIS',
    'TABES',
    'GAMEY',
    'NATCH',
    'BRANS',
    'TABUN',
    'FORES',
    'DORES',
    'TICES',
    'PATES',
    'GUNDY',
    'SWIRE',
    'BUCKO',
    'PYXIS',
    'LAXER',
    'MELIK',
    'GOMPA',
    'ROTAS',
    'DARZI',
    'KORMA',
    'LIMBA',
    'HELOS',
    'HOURI',
    'COMAL',
    'BALUN',
    'HIVED',
    'BORNA',
    'WUXIA',
    'REAIS',
    'KERBS',
    'SPORK',
    'THOLE',
    'LIMED',
    'WITHY',
    'VULGO',
    'AMENT',
    'FUNDI',
    'GADES',
    'CRUET',
    'MURID',
    'PAVIN',
    'BHANG',
    'VILER',
    'MUSHA',
    'BLORE',
    'KOANS',
    'KALES',
    'LUCES',
    'SAPOR',
    'PYRAN',
    'WINGE',
    'SHIER',
    'TALUK',
    'VIRGA',
    'BOWNE',
    'BALKY',
    'TURFS',
    'HONGI',
    'OPING',
    'GLUTS',
    'BARDY',
    'PURES',
    'DECAN',
    'GIRDS',
    'MAILE',
    'RUGAE',
    'WINOS',
    'ROBLE',
    'MOERS',
    'ACING',
    'FELTY',
    'PATIN',
    'DEMIC',
    'HOLTS',
    'DOLTS',
    'GALOP',
    'KNOUT',
    'HELOT',
    'FOGEY',
    'ESTRO',
    'NUKED',
    'AGUES',
    'TAPUS',
    'ASPIE',
    'SAWER',
    'HOSEN',
    'HILUS',
    'DOPES',
    'FUDGY',
    'METIC',
    'STONG',
    'AFRIT',
    'SPRED',
    'GRAMP',
    'FAQIR',
    'PERVY',
    'KAYLE',
    'ZUPAN',
    'MULGA',
    'SLIPT',
    'DESHI',
    'NARIS',
    'KARNS',
    'ORBED',
    'COUDE',
    'FRAYS',
    'PRONK',
    'KNOPS',
    'LORIC',
    'GREIN',
    'MOLTS',
    'KARTS',
    'PORIN',
    'GARUM',
    'VARIX',
    'WHIPT',
    'LODEN',
    'ORACY',
    'SEXTO',
    'CANSO',
    'TUXES',
    'WEALS',
    'NAIRU',
    'KENTS',
    'OWLET',
    'BOSKY',
    'THROE',
    'BEVOR',
    'PIKER',
    'LODES',
    'LOTSA',
    'CREDS',
    'BENGA',
    'ENZYM',
    'KYLES',
    'PIKAS',
    'NOPAL',
    'POWRE',
    'PLATY',
    'DUMKA',
    'RIMED',
    'MENTO',
    'HYNDE',
    'PARVO',
    'ZINGY',
    'BRITH',
    'DUNGY',
    'MERIS',
    'TALKY',
    'RUNTS',
    'MAXIS',
    'RATHS',
    'NIKAH',
    'AEROS',
    'HYSON',
    'MUNIS',
    'DRIBS',
    'HYRAX',
    'WEANS',
    'DOPER',
    'UMRAH',
    'SOCLE',
    'AMIES',
    'PERVO',
    'YAWED',
    'SHOLA',
    'MOPEY',
    'EMPTS',
    'ENOKI',
    'KRAYS',
    'DOLMA',
    'GARIS',
    'TRANQ',
    'QADIS',
    'COPAY',
    'NORIS',
    'VISON',
    'HAINS',
    'HOSTA',
    'DOBRA',
    'SOWLE',
    'TANGS',
    'GEATS',
    'FIERS',
    'TOPER',
    'SPODE',
    'TRANK',
    'STOUP',
    'WORTS',
    'CETYL',
    'HINKY',
    'WAGYU',
    'KUTAS',
    'BRAYS',
    'QUOIN',
    'TOPHI',
    'LAMES',
    'SOREX',
    'GUSHY',
    'HANGI',
    'MEINS',
    'SUBER',
    'POLJE',
    'ASHED',
    'VODUN',
    'TRIAC',
    'FINKS',
    'TARNS',
    'OBITS',
    'RATHE',
    'SERON',
    'DINKS',
    'POULE',
    'HAZES',
    'OKAPI',
    'DENAR',
    'CHADS',
    'MICHT',
    'LATHI',
    'GIRON',
    'IFTAR',
    'MYNAH',
    'WITHE',
    'KOFTA',
    'DEMOI',
    'RICES',
    'UMBEL',
    'NEWSY',
    'BEGAD',
    'BUNCO',
    'RYOTS',
    'MAUND',
    'VISED',
    'FRATI',
    'WHOMP',
    'CRAMS',
    'SNECK',
    'THEGN',
    'JOWAR',
    'AURES',
    'CARLS',
    'WHETS',
    'CYMES',
    'DRUSE',
    'ZAMBO',
    'SCHUL',
    'QUATE',
    'QUINA',
    'PUJAS',
    'MONAS',
    'PHOCA',
    'RENGA',
    'PAVIS',
    'TARDO',
    'PIMAS',
    'KEROS',
    'COWRY',
    'ASDIC',
    'ALIST',
    'PARDS',
    'SIRUP',
    'CAPUL',
    'MAZEY',
    'LOSEN',
    'DEMAN',
    'FENDS',
    'PODIA',
    'BURET',
    'LENIS',
    'OZEKI',
    'MONIE',
    'MINAE',
    'COXAL',
    'CONED',
    'ENTIA',
    'TERGA',
    'BACHS',
    'LOURY',
    'MICHE',
    'BIERS',
    'FASCI',
    'REBID',
    'KORUS',
    'SPEIR',
    'TOWSE',
    'TIMBO',
    'DRECK',
    'FLOTA',
    'CIMEX',
    'COKED',
    'QUOAD',
    'NARKY',
    'SPROG',
    'IDLES',
    'YETIS',
    'PLOTZ',
    'TENIA',
    'NITER',
    'CANER',
    'MOPES',
    'GARBE',
    'NELIS',
    'PERMS',
    'BLITE',
    'HERMA',
    'THALE',
    'MAZED',
    'BULGY',
    'ROTCH',
    'PARDI',
    'TUBED',
    'QUOIT',
    'WHELM',
    'BERKO',
    'JOTUN',
    'NUDIE',
    'BOSIE',
    'SUBHA',
    'JAMBO',
    'GYRAL',
    'BEANY',
    'HOAGY',
    'MARID',
    'LIARD',
    'BHAJI',
    'APISH',
    'DORKS',
    'POTCH',
    'GARBS',
    'WARST',
    'MIAOW',
    'KYLIX',
    'GORIS',
    'LIERS',
    'FAINE',
    'DAVEN',
    'CAROM',
    'FUSIL',
    'BAWDS',
    'PILUM',
    'TYKES',
    'VERST',
    'POTES',
    'PRIGS',
    'BELON',
    'DERMA',
    'SCRAG',
    'BONGS',
    'DOUMA',
    'WONKS',
    'INVAR',
    'MAIRS',
    'SIGLA',
    'BINES',
    'WOMYN',
    'MOLAS',
    'OGLES',
    'STYLO',
    'PEAVY',
    'ROILS',
    'FUBAR',
    'SPILE',
    'GRENS',
    'KYLIN',
    'OCKER',
    'GRANS',
    'UKASE',
    'POLEY',
    'CRIOS',
    'BAKEN',
    'SIMAR',
    'MUTHA',
    'WHIRS',
    'WACKS',
    'LOTIC',
    'GUYED',
    'TARGE',
    'FIATS',
    'CAPLE',
    'CHIEL',
    'ROVES',
    'HODJA',
    'CORIA',
    'MORAT',
    'PRICY',
    'MANKY',
    'ZINKE',
    'KRAIT',
    'KADES',
    'CHIRO',
    'TYNES',
    'BRAST',
    'TILER',
    'ZOMBI',
    'BUNGS',
    'SMOLT',
    'CUNDY',
    'VOLET',
    'AITCH',
    'TYROS',
    'RAWLY',
    'GRIDE',
    'PAREN',
    'RIVED',
    'INKLE',
    'STIPA',
    'BOKEH',
    'ELAIN',
    'UHLAN',
    'TIROS',
    'MACKS',
    'INDOL',
    'DATER',
    'BAWLS',
    'KORAT',
    'DUNAM',
    'TELIA',
    'SHOED',
    'CRUDO',
    'QUEAN',
    'SAMEK',
    'STIRK',
    'MENTA',
    'DISHY',
    'NAMER',
    'INKER',
    'SHALY',
    'YOWLS',
    'DORSA',
    'AZOTE',
    'PLUMY',
    'DHOBI',
    'PUDOR',
    'RUDIS',
    'SPIRT',
    'GILET',
    'CHAVS',
    'PONGA',
    'WAINS',
    'TIMPS',
    'AUREI',
    'OUZEL',
    'SCURF',
    'LOGES',
    'GRIFT',
    'SONDE',
    'GIMEL',
    'TRAVE',
    'LETUP',
    'TRONA',
    'GHAST',
    'PUKES',
    'CROST',
    'BORAK',
    'MUSAR',
    'CURAT',
    'BELAH',
    'CHIRK',
    'BUNDE',
    'TUMID',
    'TENDU',
    'AULIC',
    'AMICE',
    'PILAU',
    'PLING',
    'WINEY',
    'CAPOS',
    'AVISE',
    'AXING',
    'NORIA',
    'LETCH',
    'BENIS',
    'VIRGE',
    'MICRA',
    'SOARE',
    'CRUFT',
    'IAMBS',
    'MEINT',
    'CUTIN',
    'PURIS',
    'BORTZ',
    'MAIKO',
    'MIXTE',
    'JARLS',
    'GENAS',
    'TECHY',
    'YUGAS',
    'FAYER',
    'VANTS',
    'POILU',
    'CADIS',
    'SCUDO',
    'SLOVE',
    'WAKER',
    'RATEL',
    'ZINGS',
    'WEFTS',
    'PRYSE',
    'BOKES',
    'TUBAS',
    'IMPRO',
    'CYDER',
    'AIRTH',
    'BUNTS',
    'PLACK',
    'FLYTE',
    'UREAS',
    'SKIRL',
    'COPER',
    'AFROS',
    'MICKS',
    'MILTY',
    'ORALS',
    'FORBY',
    'URMAN',
    'NOWAY',
    'JAGIR',
    'ELINT',
    'CABER',
    'UNBAR',
    'VIZOR',
    'AGRIN',
    'GELID',
    'LUNAS',
    'BOTAS',
    'JURAT',
    'FANES',
    'VASTY',
    'MENGS',
    'EQUID',
    'BRUME',
    'ARILS',
    'OMERS',
    'JAMBE',
    'WHENS',
    'SHAWM',
    'IMBED',
    'BAHUT',
    'JUGAL',
    'ALMES',
    'CHAMS',
    'ANTED',
    'MAULS',
    'DANTS',
    'SCUTA',
    'JUDGY',
    'TRIOL',
    'COPEN',
    'ZENDO',
    'KLONG',
    'RUCKS',
    'MIXUP',
    'CANTS',
    'HEFTS',
    'HEILS',
    'KINDY',
    'FUZES',
    'ANOLE',
    'BRADS',
    'KELIM',
    'KORAI',
    'NOMAS',
    'TOKES',
    'HACEK',
    'QUIDS',
    'AVENS',
    'TINED',
    'THOUS',
    'FANGO',
    'PRENT',
    'NGAIO',
    'FELCH',
    'HABLE',
    'SULFO',
    'RIYAL',
    'SWINK',
    'LINDS',
    'KLIEG',
    'STRAD',
    'RUSHY',
    'RECAL',
    'LIGER',
    'CEDIS',
    'TOLAR',
    'GLEBA',
    'MIREX',
    'STEND',
    'CINES',
    'FAVES',
    'GYOZA',
    'GYVES',
    'CYTES',
    'CURET',
    'KELPS',
    'PONZU',
    'FETOR',
    'FREMD',
    'TICKY',
    'ROWEL',
    'COBIA',
    'VENDU',
    'TOUSE',
    'ARTEL',
    'FLIED',
    'SAINE',
    'TAMIN',
    'RUNTY',
    'SIXTE',
    'LEUCO',
    'BEATH',
    'COIGN',
    'CAKEY',
    'CAVER',
    'MUHLY',
    'DEGUS',
    'PINGO',
    'MYOID',
    'JAPES',
    'GIBED',
    'TROGS',
    'TIANS',
    'APTED',
    'DEMOB',
    'PULAO',
    'WYLES',
    'HAZER',
    'MUCKS',
    'SCAUP',
    'TOING',
    'MOPSY',
    'BIRLE',
    'REBUY',
    'KILTY',
    'YEAHS',
    'RICED',
    'PYROS',
    'FRAGS',
    'BRIZE',
    'MUTER',
    'JEHAD',
    'KOHLS',
    'HUCKS',
    'SEWIN',
    'BURAN',
    'QUINO',
    'HAKES',
    'HEAST',
    'MEWLS',
    'ROWTH',
    'URENT',
    'FAZES',
    'HARED',
    'KUBIE',
    'ONCET',
    'LURGI',
    'NAMUS',
    'FAUVE',
    'TERAS',
    'JABOT',
    'NAPED',
    'FANKS',
    'MUSTH',
    'BURAS',
    'GAUDS',
    'GALUT',
    'HEMIC',
    'BOLAR',
    'VATIC',
    'RUING',
    'BOHEA',
    'NOELS',
    'LUCKS',
    'TOPES',
    'PLIER',
    'RUMBO',
    'RHUMB',
    'LIVOR',
    'COYER',
    'NOTUM',
    'RIANT',
    'GENUA',
    'BIMAH',
    'COVED',
    'FYLES',
    'GUQIN',
    'BASTO',
    'HOLMS',
    'BRAVI',
    'LIMAS',
    'TABID',
    'SCUTE',
    'HOPER',
    'WONGA',
    'FONES',
    'GOYLE',
    'SHERO',
    'FUSEL',
    'AWNED',
    'COQUI',
    'MERKS',
    'BARNY',
    'SERAL',
    'REGOS',
    'MAVIN',
    'GHAUT',
    'AGROS',
    'OLEIN',
    'COUTH',
    'KESAR',
    'CHEMS',
    'CHAPE',
    'TEINS',
    'GATER',
    'BARKY',
    'OINTS',
    'APERS',
    'HORSY',
    'EPACT',
    'ORGUE',
    'MORAE',
    'NARCS',
    'BARDE',
    'BONZE',
    'POYNT',
    'TRONC',
    'BIGHA',
    'IHRAM',
    'KELTS',
    'LUDES',
    'BUNIA',
    'RYALS',
    'SETAL',
    'COATI',
    'CHARE',
    'MIKED',
    'GORAL',
    'KEMPS',
    'FORZE',
    'AZUKI',
    'VINOS',
    'LINOS',
    'SLAID',
    'CULTI',
    'KULFI',
    'DONGS',
    'FAVUS',
    'CAINS',
    'LARIS',
    'EARNT',
    'WANGS',
    'REPOT',
    'KALIS',
    'MUDIR',
    'FELID',
    'FECHT',
    'ZINEB',
    'QUAIR',
    'RUDAS',
    'GUNKY',
    'ETICS',
    'HOSEY',
    'TURFY',
    'COLZA',
    'MULCT',
    'SWARF',
    'KOURA',
    'OFLAG',
    'MIRVS',
    'CHOWS',
    'ZAYIN',
    'KANES',
    'LINCH',
    'BUNGY',
    'VEZIR',
    'RUDIE',
    'KRANS',
    'DUROS',
    'SAUNT',
    'TINKS',
    'CRIMS',
    'ROSTI',
    'CLADS',
    'FOEHN',
    'POTIN',
    'CLOMB',
    'BOTES',
    'THENS',
    'KAONS',
    'TARED',
    'IMBAR',
    'POCKS',
    'LAZOS',
    'NOAHS',
    'TEALS',
    'JAMBU',
    'ANTRE',
    'FOMES',
    'INCOG',
    'NERAL',
    'BANDH',
    'BIROS',
    'GENTY',
    'MUTIS',
    'ROYNE',
    'TAWSE',
    'KEBAR',
    'UGALI',
    'CHOLI',
    'ICKLE',
    'SNOKE',
    'BLOWY',
    'GATCH',
    'POLYS',
    'ABLOW',
    'JOEYS',
    'JAVEL',
    'ZOWIE',
    'PARLY',
    'TASED',
    'BODGE',
    'BRUGH',
    'GANTS',
    'GNARL',
    'PULMO',
    'STAGY',
    'NODUS',
    'DYNEL',
    'SALUE',
    'WIFES',
    'PARKY',
    'ALGOR',
    'MIKRA',
    'SWOLN',
    'ROTAN',
    'DOTAL',
    'CLAPT',
    'SWANG',
    'JAMON',
    'TWERK',
    'SPACY',
    'DALIS',
    'BALUS',
    'HOGEN',
    'AZOTH',
    'SHIVE',
    'MOHEL',
    'SIXER',
    'BOCKS',
    'PARDY',
    'FIQUE',
    'GAWKS',
    'ABRIN',
    'RUCHE',
    'RECKS',
    'LUBES',
    'PERVS',
    'IMPOT',
    'RIDGY',
    'PURSY',
    'ADITS',
    'DERAY',
    'LEPTA',
    'GRAME',
    'PALIS',
    'TRONS',
    'SWAGE',
    'EXFIL',
    'FLANS',
    'AHINT',
    'GAUCH',
    'SEDGY',
    'TREMA',
    'USNEA',
    'LESBO',
    'RHODY',
    'TSUBO',
    'ABYSM',
    'CIDES',
    'KHAZI',
    'ABUNE',
    'UNCAP',
    'GRODY',
    'PROGS',
    'UNAPT',
    'LADES',
    'RINES',
    'BOVID',
    'MARDY',
    'SKIVE',
    'STYLI',
    'FICES',
    'FLUTY',
    'BLUID',
    'SHOGI',
    'SCULP',
    'RECIT',
    'DARIC',
    'PANIM',
    'SERAC',
    'BUNYA',
    'KIMBO',
    'NOTER',
    'CRUNK',
    'LUTER',
    'SHOAT',
    'FUNKS',
    'BORAS',
    'ISNAE',
    'PINKO',
    'BLUET',
    'DOMAL',
    'DAGOS',
    'FARCY',
    'LOZEN',
    'BEAMY',
    'FJELD',
    'AWING',
    'BIRSE',
    'COXES',
    'TAULD',
    'FURCA',
    'INULA',
    'HAYER',
    'MELIC',
    'TULES',
    'CAMOS',
    'LOAFS',
    'WASPY',
    'CRANS',
    'NOYAU',
    'DOLIA',
    'THAIM',
    'LEHUA',
    'MINGS',
    'MAGOT',
    'GLADY',
    'HONER',
    'PICUL',
    'TABUS',
    'BODLE',
    'SUTOR',
    'MINGE',
    'URSON',
    'ROTES',
    'IDYLS',
    'WECHT',
    'PONCY',
    'MAISE',
    'FLOGS',
    'SHULE',
    'ANOMY',
    'DOUAR',
    'BILED',
    'BORAL',
    'SHARN',
    'CRINE',
    'TURPS',
    'MARCS',
    'SCOPA',
    'CHIMO',
    'CLONK',
    'DICHT',
    'ALMUG',
    'FIKES',
    'WYNDS',
    'TORCS',
    'SIKER',
    'PENDU',
    'BURSE',
    'MIKVA',
    'WIZEN',
    'NUTSO',
    'KRAIS',
    'LIMNS',
    'ICERS',
    'RUTHS',
    'SHENT',
    'PSION',
    'ESTOP',
    'LYSIN',
    'GAMBE',
    'BRAIL',
    'MAKIS',
    'FOXIE',
    'ABERS',
    'SCAUR',
    'HEPAR',
    'DAIKO',
    'BOINK',
    'TONDI',
    'BAVIN',
    'CLITS',
    'BARIC',
    'NEIST',
    'CURLI',
    'DRENT',
    'FUGLE',
    'KWELA',
    'TYRED',
    'SAUGH',
    'HYPES',
    'WALER',
    'CORNI',
    'BURGS',
    'FRAUS',
    'KOTCH',
    'PRIMS',
    'FADGE',
    'CHOKY',
    'VOLTI',
    'KOBAN',
    'TICED',
    'KADIS',
    'RATUS',
    'WITHS',
    'AXILE',
    'URENA',
    'FRUSH',
    'LYTHE',
    'PRAHU',
    'TOLES',
    'NAPES',
    'VAILS',
    'ACROS',
    'DAKER',
    'KIERS',
    'LANTS',
    'BOITE',
    'SPUTA',
    'PARKI',
    'BESAT',
    'SALET',
    'BURLS',
    'MAUZY',
    'DORSE',
    'STROY',
    'SUBAH',
    'DARIS',
    'PENDS',
    'WAXER',
    'KINES',
    'UNSEX',
    'VIAND',
    'ANKUS',
    'SEPIC',
    'TACHO',
    'RHEAS',
    'BOUGE',
    'PICAS',
    'PROAS',
    'TULPA',
    'VINAS',
    'UNCIA',
    'LENTI',
    'BASEN',
    'THACK',
    'COIFS',
    'FLORS',
    'JORUM',
    'TOCKS',
    'DINTS',
    'PAEDO',
    'AZINE',
    'OKAYS',
    'FONDU',
    'DRAPS',
    'MAQUI',
    'CELOM',
    'RHOMB',
    'HAFTS',
    'ANCLE',
    'SILEN',
    'IDOLA',
    'FRENA',
    'COALY',
    'ABSIT',
    'PLEWS',
    'ELVAN',
    'CHIRU',
    'PELON',
    'WODGE',
    'MURES',
    'PIKEY',
    'HEXAD',
    'CRIPE',
    'BOYAU',
    'RAYLE',
    'GIVED',
    'OAKED',
    'BARFI',
    'TAMPS',
    'ESCOT',
    'PHYLE',
    'TOWIE',
    'CROZE',
    'GRYDE',
    'BIALY',
    'FRATS',
    'RENOS',
    'ASPRO',
    'RUDES',
    'CURDY',
    'INFOS',
    'DARNS',
    'BANTY',
    'FINOS',
    'TUINA',
    'BOWSE',
    'SPAHI',
    'BRANK',
    'KAING',
    'PAEON',
    'VLEIS',
    'NOCKS',
    'STYRE',
    'FLEXO',
    'ROUES',
    'SKOAL',
    'LEISH',
    'UNFIX',
    'MUXES',
    'MUIRS',
    'BUTES',
    'JETON',
    'FATLY',
    'YANGS',
    'KAPOW',
    'WIDES',
    'SPYRE',
    'ONIUM',
    'HONGS',
    'PULIS',
    'ORACH',
    'FLAYS',
    'WILED',
    'CAGER',
    'PRAUS',
    'SAROD',
    'WHEAR',
    'SCART',
    'NEAPS',
    'KIGHT',
    'NEROL',
    'PUCES',
    'BROND',
    'KONBU',
    'VENDS',
    'SOYLE',
    'LEDUM',
    'ROUPS',
    'PEKAN',
    'FIDGE',
    'SKELP',
    'HYPOS',
    'LOBUS',
    'SEROW',
    'HEMAL',
    'LARUM',
    'ROANS',
    'STUDE',
    'KYANG',
    'BOUSE',
    'CLIPT',
    'BONIE',
    'SAMEL',
    'NDUJA',
    'AIDOS',
    'GENRO',
    'YONKS',
    'FUGLY',
    'PIKED',
    'OUENS',
    'KNISH',
    'TEILS',
    'FANUM',
    'BANCS',
    'SUDOR',
    'VISNE',
    'BLUDE',
    'IXORA',
    'AMNIO',
    'MIXEN',
    'POCKY',
    'SPART',
    'PORAL',
    'EMBAR',
    'MACED',
    'LINTS',
    'NIVAL',
    'WALIS',
    'BOLDS',
    'METHO',
    'VANED',
    'CHANK',
    'KAMIS',
    'ROLFS',
    'LAMBY',
    'TRUES',
    'MANEB',
    'FUNGO',
    'LABIS',
    'FLUKY',
    'FOUET',
    'SLIVE',
    'SPRAG',
    'GIBEL',
    'OREAD',
    'HOYAS',
    'BINGS',
    'JUPON',
    'PONES',
    'PENGO',
    'NOLES',
    'GURLS',
    'LENOS',
    'GRONE',
    'GRITH',
    'CRAWS',
    'LOCHE',
    'DITSY',
    'RANGS',
    'BIGOS',
    'LUTED',
    'SAURY',
    'BELAR',
    'DELTS',
    'URSAE',
    'ADMEN',
    'MOTED',
    'LITAS',
    'CENTU',
    'BOMAS',
    'PLEON',
    'GLOAM',
    'CROUT',
    'KYATS',
    'HIZEN',
    'ROIDS',
    'WHINS',
    'MAXES',
    'PIROG',
    'ALGIN',
    'PONEY',
    'GERMY',
    'DICTS',
    'ROZET',
    'ORNIS',
    'PARVE',
    'GYNAE',
    'FILOS',
    'RAILE',
    'GOBAR',
    'VARES',
    'DRACK',
    'MOHUR',
    'BLUNK',
    'PERDY',
    'AZOIC',
    'VOZHD',
    'BLITS',
    'VIGAS',
    'YENTA',
    'CAMES',
    'EMICS',
    'TORES',
    'EPHOR',
    'NIXES',
    'POMES',
    'ROWIE',
    'TORSE',
    'CITER',
    'GANEV',
    'CAXON',
    'KAZIS',
    'TOUNS',
    'MORNS',
    'PUNJI',
    'TUILE',
    'TRONK',
    'KULAN',
    'SCATH',
    'LEADY',
    'SANKO',
    'RESIT',
    'MESAL',
    'GLOBI',
    'DORMY',
    'HALID',
    'BEINS',
    'JIVED',
    'VAMPY',
    'DOURA',
    'SKYER',
    'SEIZA',
    'GADIS',
    'BLAHS',
    'NUGAE',
    'CRUES',
    'OWLER',
    'THANS',
    'BLAYS',
    'LARKY',
    'SALEP',
    'GAMBO',
    'KENCH',
    'TAROS',
    'GREBO',
    'FUMER',
    'PAWLS',
    'NIKAU',
    'OUSEL',
    'AVIZE',
    'FAVER',
    'COYPU',
    'NERKA',
    'ADUST',
    'WADGE',
    'LAWER',
    'METHS',
    'LUNTS',
    'FLICS',
    'FOLKY',
    'OSMIC',
    'WAREZ',
    'GOATY',
    'PIKUL',
    'POTSY',
    'REALO',
    'PYNES',
    'VINAL',
    'BINER',
    'FEART',
    'MAYOS',
    'HAROS',
    'TROKE',
    'MONAL',
    'BESIT',
    'ACERS',
    'BELGA',
    'RIELS',
    'SIZAR',
    'NOSER',
    'FURLS',
    'PURLS',
    'DEROS',
    'UNBID',
    'MIENS',
    'YOWIE',
    'BIDON',
    'SITHE',
    'PILER',
    'PALET',
    'PALKI',
    'PELTA',
    'GOLES',
    'PURIN',
    'MUSER',
    'UMIAK',
    'ACRED',
    'KORES',
    'DOXIE',
    'JUKED',
    'BONCE',
    'TROWS',
    'DUNCH',
    'SWOLE',
    'ADMIX',
    'YOWZA',
    'CONKS',
    'TOLAS',
    'RETIA',
    'CEROS',
    'CLOPS',
    'FLANE',
    'GENAL',
    'BEGAR',
    'AGLEY',
    'KULAS',
    'FROES',
    'PUKEY',
    'SCHMO',
    'HORIS',
    'SARKY',
    'FUMET',
    'SOWAR',
    'URNED',
    'MANEH',
    'KAINS',
    'BLEYS',
    'PUNGA',
    'SMALT',
    'WAIDE',
    'HALFS',
    'CURSI',
    'LAUCH',
    'CONGE',
    'ULNAE',
    'CUITS',
    'STEAR',
    'ASCON',
    'VLIES',
    'TRUED',
    'DOSER',
    'YUANS',
    'MANTY',
    'CEORL',
    'WALED',
    'ROSET',
    'SPIRY',
    'PONGS',
    'FLUBS',
    'CHAIS',
    'GAZON',
    'RASED',
    'BIGLY',
    'FORKY',
    'KORUN',
    'CARNS',
    'AMBRY',
    'MACHS',
    'THUYA',
    'MAHOE',
    'SNARF',
    'WHITY',
    'WICKY',
    'MAKOS',
    'CAPOT',
    'VAIRE',
    'PAWKY',
    'SCRAN',
    'LATKE',
    'JOCKY',
    'LYTES',
    'CLOUS',
    'LUREX',
    'MUJIK',
    'COWAL',
    'FARCI',
    'THRIP',
    'TIGON',
    'BREDS',
    'NEALS',
    'AYONT',
    'LARNT',
    'SIDHA',
    'VIERS',
    'THANX',
    'ATRIP',
    'PREXY',
    'BALDS',
    'DACKS',
    'ORANT',
    'TAKHI',
    'OUTBY',
    'ONERS',
    'THRID',
    'SAPID',
    'CUKES',
    'SHOTE',
    'HOSER',
    'AXELS',
    'TOISE',
    'ANILE',
    'CLART',
    'RIADS',
    'ENOLS',
    'INCEL',
    'RONES',
    'YAWLS',
    'MINCY',
    'DOGIE',
    'LAUFS',
    'FAVEL',
    'KAROS',
    'OFTER',
    'UMPTY',
    'UNARM',
    'MYSID',
    'LEVAS',
    'PACOS',
    'CLAVI',
    'SLOYD',
    'GUIDS',
    'CESTI',
    'BURDS',
    'GLADS',
    'ODEUM',
    'RAZES',
    'BARYE',
    'POXED',
    'CAULS',
    'LOWND',
    'POKIE',
    'NITES',
    'CHAWS',
    'FILAR',
    'MOKES',
    'LIMPA',
    'DIYAS',
    'JILTS',
    'ADSUM',
    'CRAME',
    'NIPAS',
    'FISTY',
    'WILGA',
    'SHEAL',
    'URAEI',
    'HAULT',
    'RUGAL',
    'MYNAS',
    'TROCK',
    'CHODE',
    'LOSED',
    'LUBRA',
    'SPAYD',
    'VEALS',
    'ROVEN',
    'SABED',
    'BUSTI',
    'SAMEY',
    'GOSHT',
    'LIMAX',
    'RINDY',
    'STIME',
    'EDUCT',
    'OCTAN',
    'MILKO',
    'LIGAN',
    'CLOYS',
    'TAROK',
    'UNHIP',
    'MICOS',
    'BONZA',
    'HIEMS',
    'GARMS',
    'PHONS',
    'STRAK',
    'LAWKS',
    'LOWAN',
    'FLOTE',
    'MUNGA',
    'PSORA',
    'PEANS',
    'KOLAS',
    'STROW',
    'GISMO',
    'JIVES',
    'MONER',
    'LEHRS',
    'URIAL',
    'MILDS',
    'GLAUM',
    'CONKY',
    'SITUP',
    'LAIRY',
    'NICAD',
    'HUDNA',
    'SENGI',
    'GROTS',
    'CHARK',
    'SPROD',
    'AMOLE',
    'FLUMP',
    'KINOS',
    'HEJAB',
    'POLER',
    'DEMIT',
    'QUATS',
    'SLYER',
    'GIMPS',
    'PARGO',
    'HAULM',
    'RHYTA',
    'SPALT',
    'WHITS',
    'NATIS',
    'ALOIN',
    'SIVER',
    'POUFS',
    'ARGLE',
    'KEPIS',
    'DOVEN',
    'LACER',
    'JAXIE',
    'TOKED',
    'TREYS',
    'GOBAN',
    'REJIG',
    'GARES',
    'TUSKY',
    'WELKS',
    'DOBES',
    'METOL',
    'AXMEN',
    'CHUFA',
    'JEDIS',
    'CABRE',
    'HALER',
    'REDIA',
    'THRAW',
    'MILTZ',
    'DOATS',
    'GUIRO',
    'PAGOD',
    'BIDER',
    'PRINK',
    'MAERL',
    'DUMBS',
    'MINGY',
    'SKORT',
    'GADJE',
    'TRUGO',
    'SHOER',
    'OXLIP',
    'INARM',
    'ADUKI',
    'IRADE',
    'ARETS',
    'LINTY',
    'SORAL',
    'GIROS',
    'HAICK',
    'LURVE',
    'MONGS',
    'UNBOX',
    'ZOEAL',
    'BRUSK',
    'LATHY',
    'SCRAT',
    'PUTON',
    'ALGID',
    'BIELD',
    'SWIVE',
    'POLKS',
    'LAIGH',
    'RHIME',
    'AMORT',
    'PAVEN',
    'VELDS',
    'SOKEN',
    'CRIAS',
    'WISHA',
    'GIRTS',
    'SYTHE',
    'REMAN',
    'UREDO',
    'SLUED',
    'GONIA',
    'FRIZE',
    'DOWNA',
    'JASEY',
    'SHTUM',
    'UNLET',
    'STUPE',
    'ODIST',
    'PERTS',
    'NEATS',
    'TRODS',
    'SORED',
    'DRANT',
    'ZERDA',
    'SCEND',
    'TELOI',
    'LIEFS',
    'MILFS',
    'BREID',
    'LAZES',
    'JOBED',
    'TRAPE',
    'SORDA',
    'GOLFS',
    'RESAT',
    'HAJIS',
    'TRADS',
    'TROYS',
    'COAPT',
    'JUMAR',
    'SKEAN',
    'RIGOL',
    'VINED',
    'BLATE',
    'RANID',
    'WANKY',
    'ELSIN',
    'GUMPS',
    'ETYMA',
    'FLAMY',
    'GUSLE',
    'BONKS',
    'APORT',
    'OXTER',
    'ROJAK',
    'STEWY',
    'LAWIN',
    'MIHAS',
    'EGADS',
    'COMAE',
    'PRIAL',
    'RENAY',
    'BRENS',
    'DULIA',
    'GIBUS',
    'KAPUS',
    'UNMIX',
    'FRAPE',
    'MIROS',
    'PANCE',
    'TRABS',
    'SAYON',
    'WARKS',
    'COMBY',
    'LAICS',
    'LUMAS',
    'LASED',
    'ALKIE',
    'COHAB',
    'ESTOC',
    'COTED',
    'SCROD',
    'SOWNE',
    'ARGOL',
    'CAPIZ',
    'DOWLE',
    'JAPED',
    'ARUMS',
    'TORSI',
    'BURFI',
    'TSADE',
    'STOGY',
    'FURZY',
    'JEHUS',
    'CRAYS',
    'ABRIM',
    'TSUBA',
    'LIDOS',
    'PILEA',
    'BRIOS',
    'LINEY',
    'GAMIC',
    'FLISK',
    'DIKER',
    'GAJOS',
    'INDOW',
    'WAVEY',
    'WAYED',
    'TURMS',
    'STRAE',
    'GLARY',
    'BOXTY',
    'BLAES',
    'PLYER',
    'MUNTS',
    'BETID',
    'ACIDY',
    'RACON',
    'NARIC',
    'SICKY',
    'KRABS',
    'SIENT',
    'SAGUM',
    'GADJO',
    'CUBER',
    'KUMIS',
    'CHADO',
    'MOPUS',
    'HAULD',
    'DUARS',
    'LAWNY',
    'GUYSE',
    'TUSHY',
    'SEGOL',
    'ENORM',
    'PINAS',
    'SPANE',
    'PORTY',
    'PODAL',
    'SLANK',
    'SQUIT',
    'JATOS',
    'SWAIL',
    'DAZES',
    'ULPAN',
    'PIGHT',
    'QUYTE',
    'QUENA',
    'IMPED',
    'MUCRO',
    'OVELS',
    'TEPAL',
    'RUMPY',
    'PAREO',
    'COXED',
    'DELFS',
    'QUINS',
    'PAGRI',
    'TUBAE',
    'GOTHY',
    'SKELM',
    'HURDS',
    'BEFOG',
    'PERCS',
    'HYLES',
    'TIKES',
    'MERIL',
    'YIPES',
    'CUPEL',
    'FLEAM',
    'WIVED',
    'MARVY',
    'POXES',
    'RATOS',
    'LAEVO',
    'RAGUS',
    'FANOS',
    'ABRIS',
    'SPADO',
    'CHOUT',
    'ZEBUS',
    'ONCES',
    'LINKY',
    'ARMET',
    'OMRAH',
    'LARDS',
    'UPDOS',
    'CIRES',
    'GLODE',
    'RETOX',
    'FAULD',
    'GASPY',
    'HOING',
    'NUTSY',
    'FLAMS',
    'MOHUA',
    'STEAN',
    'ALMUD',
    'ZONDA',
    'RAKUS',
    'ORGIA',
    'LUDOS',
    'FESTY',
    'FLUYT',
    'PWNED',
    'SKITE',
    'RAHUI',
    'ONERY',
    'KNAUR',
    'STIVE',
    'BOETS',
    'MOTZA',
    'DANGS',
    'REAMY',
    'FLAKS',
    'CRWTH',
    'PISKY',
    'WINGY',
    'LOTES',
    'GLOZE',
    'JASPE',
    'PORNY',
    'MOTHY',
    'FUZED',
    'ZIRAM',
    'EXURB',
    'DRUSY',
    'KRANG',
    'GROMA',
    'ZOIST',
    'HAPUS',
    'DIVOS',
    'LOURS',
    'CUTES',
    'JUPES',
    'PESTY',
    'MURAS',
    'TREIF',
    'FARLE',
    'INDUE',
    'SOGER',
    'DOMIC',
    'GULAS',
    'THARS',
    'MANUL',
    'XERUS',
    'SKRAN',
    'HOAST',
    'CAGOT',
    'MUIDS',
    'CAMIS',
    'TEIND',
    'ATOMY',
    'ARSEY',
    'SHEND',
    'ALECS',
    'AROID',
    'DROLE',
    'BETHS',
    'KNURL',
    'VAPED',
    'WACKE',
    'LAWED',
    'MOTIS',
    'HYLIC',
    'FIENT',
    'CHIVY',
    'GAPER',
    'REAST',
    'FAKEY',
    'BITOU',
    'HERNS',
    'CAIDS',
    'ERICS',
    'OBIAS',
    'SOUCE',
    'BILKS',
    'CURFS',
    'ROILY',
    'ROWND',
    'HULKY',
    'BOTEL',
    'THURL',
    'SAYNE',
    'TAXER',
    'MANGS',
    'MASTY',
    'PUNKA',
    'RATCH',
    'NALED',
    'LOWSE',
    'HOWRE',
    'MYOPE',
    'ACNED',
    'BLASH',
    'ORPIN',
    'GINKS',
    'GAWPS',
    'ANKHS',
    'MASHY',
    'JODEL',
    'PUNGS',
    'TEPAS',
    'GRIKE',
    'SNOEP',
    'KORAS',
    'KNUTS',
    'TUFAS',
    'SWITH',
    'ZEINS',
    'NARKS',
    'DROWS',
    'HONDS',
    'GUDES',
    'GAMBS',
    'BLIST',
    'PUGIL',
    'SWACK',
    'KELPY',
    'KYTHE',
    'NIDES',
    'RUMPO',
    'FEMAL',
    'AGLET',
    'GALED',
    'AULOI',
    'HOICK',
    'DIRTS',
    'FLIMS',
    'KANZU',
    'LOKES',
    'GUNKS',
    'WHAMS',
    'FREIT',
    'HEAPY',
    'MOUST',
    'TOGAE',
    'SOFTA',
    'GITCH',
    'TANKY',
    'DAUBY',
    'KERFS',
    'TREYF',
    'YONIS',
    'COXIB',
    'BOXEN',
    'TYPAL',
    'BAHTS',
    'GLIMS',
    'DEFOG',
    'EMONG',
    'TOPIS',
    'OCREA',
    'HEIDS',
    'VAPES',
    'SKYED',
    'SMORE',
    'LIPOS',
    'PUERS',
    'RUNED',
    'KATIS',
    'LAICH',
    'CONIA',
    'KETOL',
    'BRAXY',
    'DRATS',
    'VAIRY',
    'UNJAM',
    'CODEN',
    'KEHUA',
    'BEDIM',
    'STAUN',
    'JOUAL',
    'MATLO',
    'KEMBO',
    'JERID',
    'POTAE',
    'DOSAI',
    'GORAS',
    'CUTEY',
    'OINKS',
    'GUANS',
    'YORES',
    'BIACH',
    'TOWNY',
    'ICKER',
    'RESTY',
    'UNDAM',
    'LAUND',
    'DEARN',
    'TZARS',
    'HULAS',
    'INCLE',
    'ESKAR',
    'HABUS',
    'DOTER',
    'GRIZE',
    'BRIKS',
    'PAIKS',
    'SHIUR',
    'WHAUP',
    'YEARD',
    'FOUTH',
    'CIMAR',
    'GEMOT',
    'EARST',
    'YOWES',
    'DAWEN',
    'TEGUS',
    'BUIKS',
    'STIRP',
    'TOUZE',
    'FRAIM',
    'CHAWK',
    'NOTAL',
    'MUNGE',
    'REFIX',
    'UMBRE',
    'MOUCH',
    'FARLS',
    'BIMAS',
    'DIZEN',
    'PAREU',
    'CALMY',
    'STOWN',
    'GILAS',
    'WANKS',
    'WEILS',
    'SWEIR',
    'PREMS',
    'URNAL',
    'GLAIR',
    'SKIEY',
    'FERLY',
    'CHIAS',
    'JOLTY',
    'AMINS',
    'BRUTS',
    'LOURE',
    'GLEIS',
    'GERAH',
    'FADOS',
    'HOVES',
    'OCTAD',
    'PUKER',
    'PONGY',
    'LANCH',
    'BLINY',
    'MOTEY',
    'DIRKE',
    'DUNGS',
    'OWLED',
    'BHUNA',
    'SERIC',
    'TORAS',
    'ERVIL',
    'KHORS',
    'RIVEL',
    'TAUON',
    'ZINCO',
    'CAHOW',
    'REDOS',
    'OGLER',
    'PECKY',
    'NAIFS',
    'CALOS',
    'PILAE',
    'KAIMS',
    'LUACH',
    'CALKS',
    'MOKIS',
    'BRIES',
    'LUXES',
    'RUMAL',
    'BHATS',
    'MIAOU',
    'KEVIL',
    'HUTIA',
    'PORKS',
    'DOWAR',
    'HAUNS',
    'IOTAS',
    'LURGY',
    'YINCE',
    'BLADY',
    'OKRAS',
    'DWALE',
    'BOART',
    'PARGE',
    'KITER',
    'GUSLI',
    'KNOSP',
    'TORSK',
    'ERGOS',
    'DEVOT',
    'PULKA',
    'GRUES',
    'LOUND',
    'LAXED',
    'AGUED',
    'IXNAY',
    'GONYS',
    'DOCHT',
    'MENSH',
    'HAYED',
    'DEILS',
    'TALCS',
    'POGEY',
    'HOKES',
    'BHAIS',
    'KIORE',
    'CALFS',
    'APIOL',
    'RABIC',
    'GALVO',
    'PIERT',
    'TACHS',
    'CIONS',
    'SATEM',
    'ORIXA',
    'HECKS',
    'CAVEL',
    'AIRTS',
    'FRUST',
    'TRIDE',
    'TINAS',
    'FIEST',
    'COURE',
    'SAMPI',
    'HEDGY',
    'DICTY',
    'BORTS',
    'POWNY',
    'SQUIZ',
    'URBEX',
    'PULED',
    'JUBES',
    'OMBER',
    'BUMPH',
    'DARBS',
    'FLEWS',
    'SUETY',
    'RAUPO',
    'CUNEI',
    'GURLY',
    'RAKIS',
    'MOHRS',
    'SOLAH',
    'LYMES',
    'AVINE',
    'SARGO',
    'PEWIT',
    'AHIND',
    'ZYMES',
    'WAKFS',
    'NETOP',
    'HYKES',
    'LEPID',
    'SLYPE',
    'HORME',
    'BLAWS',
    'WINZE',
    'BENTY',
    'QUAKY',
    'OATER',
    'TOGUE',
    'LEATS',
    'BARFS',
    'MURED',
    'INSPO',
    'NEXTS',
    'CLOTE',
    'GYVED',
    'ZILAS',
    'ABOIL',
    'ROSED',
    'DREYS',
    'GLAZY',
    'HAILY',
    'LUNET',
    'PRASE',
    'SADHE',
    'GAWDS',
    'KITED',
    'JUBAS',
    'GANCH',
    'ACMES',
    'BREIS',
    'ACERB',
    'BRINS',
    'YAIRD',
    'GETAS',
    'CREPY',
    'DOBLA',
    'BINGY',
    'FLUEY',
    'AGIST',
    'GOURA',
    'STRIM',
    'REJON',
    'BLART',
    'UNLAW',
    'LEIRS',
    'PELAU',
    'PUCKA',
    'AWORK',
    'TIKAS',
    'JOLES',
    'RUNCH',
    'HARNS',
    'DAULT',
    'DITAS',
    'FAWNY',
    'NOXAL',
    'DAHLS',
    'SPUED',
    'PORGE',
    'THRAE',
    'THYMI',
    'RABIS',
    'KUMYS',
    'ZONAE',
    'TIGES',
    'FUBSY',
    'GYBED',
    'BLIMY',
    'NAUCH',
    'NEWBS',
    'AWOLS',
    'YUCKS',
    'COZIE',
    'YURTA',
    'ARYLS',
    'GIUST',
    'ELOPS',
    'AHING',
    'SPAUL',
    'STRIG',
    'TERFS',
    'NUDER',
    'GULET',
    'CREPS',
    'BLAUD',
    'ETHAL',
    'BLAWN',
    'VUGHS',
    'ASWIM',
    'VAPER',
    'MEINY',
    'KBARS',
    'PODEX',
    'MUSET',
    'UPLIT',
    'JAKER',
    'SYCON',
    'WANTY',
    'AGONS',
    'LAKED',
    'NABES',
    'ELIAD',
    'GELDS',
    'TAISH',
    'DAWKS',
    'LUSHY',
    'BAUDS',
    'TRUGS',
    'FLUED',
    'MUTON',
    'GRIPT',
    'FIGOS',
    'POKAL',
    'CULET',
    'DOITS',
    'GINZO',
    'PUBCO',
    'FOINS',
    'TAWED',
    'DAINT',
    'GLISK',
    'GLUMS',
    'PYXES',
    'DERMS',
    'UNLED',
    'BAUKS',
    'ZINCS',
    'DISME',
    'JIRDS',
    'GAURS',
    'MAVIE',
    'AMOVE',
    'GUACO',
    'NUCHA',
    'UNPEG',
    'YULES',
    'PUZEL',
    'ACYLS',
    'FAKIE',
    'HAEMS',
    'PITHS',
    'ROWME',
    'YALES',
    'SAVEY',
    'ARKED',
    'RUMES',
    'GLOST',
    'SNATH',
    'LYCEA',
    'KANEH',
    'FRAPS',
    'STOLN',
    'ERUCT',
    'SURGY',
    'PADIS',
    'ILEAC',
    'CYTON',
    'ALCID',
    'UMIAQ',
    'CRITH',
    'SKYTE',
    'VADES',
    'SKART',
    'PICAL',
    'LAIKS',
    'SPIDE',
    'SAUCH',
    'SEPAD',
    'BRAWS',
    'KRENG',
    'PERAI',
    'KANGS',
    'BORMS',
    'GLOPS',
    'SOLEI',
    'STONK',
    'LOIDS',
    'GOUCH',
    'WONTS',
    'MARGS',
    'MACLE',
    'ULNAS',
    'CHALS',
    'FLAWN',
    'THIRL',
    'YONIC',
    'TACES',
    'FUROL',
    'TOLED',
    'LACET',
    'BROSY',
    'YAWPS',
    'ACOLD',
    'OLENT',
    'BESOT',
    'SPEAL',
    'DUING',
    'UNLAY',
    'GLEYS',
    'IRONE',
    'KENOS',
    'GYBES',
    'CLEPT',
    'ZONER',
    'BOURD',
    'SUMPH',
    'MOUES',
    'PLUOT',
    'HUMAS',
    'INBYE',
    'VANGS',
    'LANKS',
    'GONIF',
    'ROMAL',
    'MOILE',
    'THIGS',
    'KITHE',
    'RUPIA',
    'ELCHI',
    'TUPIK',
    'RIEMS',
    'DEFAT',
    'NAKER',
    'SURFY',
    'OWIES',
    'FLABS',
    'OPTER',
    'SHOWD',
    'SUGAN',
    'DROKE',
    'YELKS',
    'GIBER',
    'ARGIL',
    'PULES',
    'COTAN',
    'MAUBY',
    'ISLED',
    'GAMPS',
    'DIMPS',
    'JOTAS',
    'PENTS',
    'GITES',
    'LYART',
    'GINCH',
    'BINTS',
    'NAIKS',
    'WIFED',
    'ICHES',
    'SOWND',
    'CALID',
    'RICEY',
    'DENAY',
    'LUMBI',
    'BLATS',
    'RUBAI',
    'CURNS',
    'LUGES',
    'FIDOS',
    'PYGAL',
    'PEINS',
    'GIRSH',
    'AMIDS',
    'PUNAS',
    'DIPSO',
    'HAUDS',
    'GEBUR',
    'FUGIO',
    'UNWET',
    'SPELD',
    'NARDS',
    'TWAYS',
    'AGUTI',
    'SCAPI',
    'KYTES',
    'JONGS',
    'GONCH',
    'GLUER',
    'GHEST',
    'LEANY',
    'REIKS',
    'CRUDS',
    'RIPED',
    'PYRIC',
    'NAGOR',
    'GYRON',
    'RADGE',
    'HOSEL',
    'LEUCH',
    'GLENT',
    'WIELS',
    'WANEY',
    'DEWAX',
    'TOMIA',
    'ALEFT',
    'DECKO',
    'KNIVE',
    'KOELS',
    'JUMBY',
    'SEWAN',
    'RIPES',
    'TOPED',
    'TOWSY',
    'WRATE',
    'RAVEY',
    'SIROC',
    'GRYKE',
    'PIETS',
    'JOUGS',
    'RENIG',
    'LEDGY',
    'GLIME',
    'LITHS',
    'YEALM',
    'LIPES',
    'AZLON',
    'XENIC',
    'GLAMS',
    'BOYED',
    'COUTA',
    'PRATY',
    'BUNDH',
    'HOKAS',
    'KINAS',
    'CLAGS',
    'QUIMS',
    'SPEIL',
    'WOLVE',
    'RAITS',
    'HOISE',
    'RESOW',
    'DJINS',
    'SEHRI',
    'CLEGS',
    'KYLOE',
    'SPUMY',
    'OAKER',
    'AMPUL',
    'AGISM',
    'LUNKS',
    'PLONG',
    'DOXES',
    'GRAVS',
    'SCRAW',
    'TRIGS',
    'DERTH',
    'BISOM',
    'ASKOI',
    'PURED',
    'EYOTS',
    'YAMUN',
    'VICED',
    'HEMPS',
    'EXING',
    'CRENA',
    'DRUBS',
    'PERST',
    'FERMS',
    'HOTEN',
    'KETAS',
    'WEDGY',
    'TEUCH',
    'WOKER',
    'KIBES',
    'ARDEB',
    'HOARS',
    'PRADS',
    'WHUPS',
    'SPAIT',
    'STIRE',
    'NIXER',
    'LOTAS',
    'MOILS',
    'OWSEN',
    'KIEVS',
    'BESTI',
    'HOPAK',
    'ODYLE',
    'JUREL',
    'ELOIN',
    'BUTLE',
    'PUDIC',
    'DORPS',
    'KIBLA',
    'FENIS',
    'LARNS',
    'TRECK',
    'WRICK',
    'LIPAS',
    'ESCAR',
    'ABLET',
    'SLOPY',
    'BLUDY',
    'WETAS',
    'GLAUR',
    'REDUB',
    'RUBLI',
    'WIVER',
    'DASHY',
    'SUINT',
    'MOLED',
    'LOWNS',
    'FARSE',
    'MAZUT',
    'TUGRA',
    'SHLEP',
    'CORBE',
    'REAKS',
    'WHAPS',
    'UNRIP',
    'OLPAE',
    'AXLED',
    'TURME',
    'FAINS',
    'CLAME',
    'CROMB',
    'MIRKY',
    'SKELF',
    'APERY',
    'AUNES',
    'CRONS',
    'BOWET',
    'HYING',
    'NOILS',
    'LAIDS',
    'BINAL',
    'MYOPS',
    'BYKES',
    'TREMS',
    'PREON',
    'ERBIA',
    'PUNTY',
    'TAHRS',
    'BANED',
    'MURKS',
    'HORAL',
    'TEAKS',
    'MESHY',
    'WOXEN',
    'WARED',
    'SLIER',
    'MILTS',
    'DIKEY',
    'VIBEY',
    'CHONS',
    'NACHE',
    'CIELS',
    'WERSH',
    'JAPER',
    'ANILS',
    'PRAOS',
    'STAIG',
    'TAIGS',
    'NORKS',
    'PATLY',
    'VOWER',
    'TOYER',
    'SOILY',
    'NIDOR',
    'SPLOG',
    'BESAW',
    'QUAGS',
    'BAWNS',
    'PECHS',
    'GAPOS',
    'GLOMS',
    'MOBIE',
    'YOKER',
    'DWANG',
    'FECKS',
    'TUMPS',
    'ZEALS',
    'MULED',
    'UMPED',
    'GOWKS',
    'ROTAL',
    'UMBOS',
    'SCROG',
    'DUNTS',
    'COARB',
    'GAIRS',
    'FOGIE',
    'PIRNS',
    'GRAIP',
    'DONAH',
    'SPALE',
    'FROWS',
    'ZINKY',
    'GANEF',
    'HENDS',
    'KASME',
    'DERAT',
    'TWIRP',
    'MISDO',
    'SAICE',
    'GOPAK',
    'IKATS',
    'ZAIDY',
    'EPHAS',
    'PRIMY',
    'CLIES',
    'UNWIT',
    'MOXAS',
    'BUKES',
    'OCHES',
    'RESAW',
    'ZIGAN',
    'SOWTH',
    'WALTY',
    'URSID',
    'BAYTS',
    'OBANG',
    'SWELT',
    'SKEAR',
    'UNRIG',
    'DIVNA',
    'FUGIE',
    'BHUTS',
    'LOWNE',
    'RAXED',
    'EMBAY',
    'SLIPE',
    'GULPY',
    'DWINE',
    'NERTS',
    'OKTAS',
    'ALOWE',
    'HOERS',
    'SNEAP',
    'OBIED',
    'OFAYS',
    'BAHUS',
    'CLEMS',
    'UNGET',
    'INUST',
    'KLAPS',
    'OUCHT',
    'CONFS',
    'TUISM',
    'GEYAN',
    'MAWED',
    'PIANS',
    'DIOTA',
    'GRAPY',
    'CHAFT',
    'THESP',
    'YOURT',
    'BUNJE',
    'YERKS',
    'ROTED',
    'SINED',
    'CHOIL',
    'BANTS',
    'FLAXY',
    'LYARD',
    'CLOUR',
    'MOBLE',
    'THILK',
    'REGMA',
    'ONCER',
    'ABSEY',
    'UNKED',
    'TOPEK',
    'UNGOD',
    'SPAER',
    'NOYED',
    'AIRNS',
    'LOUMA',
    'ALCOS',
    'HIMBO',
    'RYBAT',
    'GREWS',
    'JURES',
    'IXTLE',
    'SNARY',
    'CLOAM',
    'SHALM',
    'YCLAD',
    'PASHM',
    'HAIKS',
    'CEILS',
    'UREAL',
    'DHALS',
    'PULKS',
    'BRAKS',
    'SONCE',
    'TABIS',
    'GYRED',
    'SPRAD',
    'GLOUT',
    'SCEAT',
    'YAGIS',
    'TAROC',
    'GRISY',
    'MENAD',
    'PLESH',
    'BOAKS',
    'TREFA',
    'LINGY',
    'REWON',
    'BRODS',
    'HEJRA',
    'WRIED',
    'URALI',
    'COGIE',
    'ORCIN',
    'NEMAS',
    'FLONG',
    'PILAO',
    'REPLA',
    'DAZER',
    'CAURI',
    'OBELI',
    'PILAW',
    'TUNGS',
    'VAIRS',
    'DOUTS',
    'POWAN',
    'YODLE',
    'PUKAS',
    'KOJIS',
    'MYTHI',
    'AYRIE',
    'EPRIS',
    'AXONE',
    'BUSKY',
    'GUYLE',
    'CYANS',
    'WHEYS',
    'DOABS',
    'CRAPY',
    'FETWA',
    'CLIPE',
    'RIZAS',
    'FOYNE',
    'RIMAE',
    'TWIRE',
    'KAIDS',
    'BAJUS',
    'BEMAS',
    'YAPOK',
    'RUKHS',
    'COLED',
    'POUKE',
    'SLART',
    'URITE',
    'MAUDS',
    'UNDOS',
    'TAVER',
    'OTARY',
    'FLIRS',
    'GORSY',
    'PURDA',
    'KIDEL',
    'KNAPS',
    'AREIC',
    'SHTIK',
    'THAGI',
    'WONGI',
    'POWND',
    'PORNS',
    'HERLS',
    'EUSOL',
    'HEMPY',
    'SHMOE',
    'DRICE',
    'WITES',
    'SMERK',
    'WENTS',
    'LIEUS',
    'SHTUP',
    'TAPEN',
    'ABORE',
    'KUTIS',
    'SCROB',
    'FEUAR',
    'CERTY',
    'SONLY',
    'SKAIL',
    'BAJRI',
    'KYARS',
    'HOKED',
    'BEIGY',
    'STYED',
    'REBOP',
    'SHULN',
    'TUANS',
    'JIMPY',
    'DEBUR',
    'DIMBO',
    'CYMAR',
    'RONTE',
    'GULFY',
    'ASHET',
    'FRIGS',
    'DHUTI',
    'THEOW',
    'BAELS',
    'WHIDS',
    'GLOBY',
    'STIED',
    'ROTLS',
    'ORLES',
    'FLYPE',
    'GADSO',
    'FENTS',
    'NERTZ',
    'PICRA',
    'WILJA',
    'VRAIC',
    'QAIDS',
    'VAREC',
    'CHIBS',
    'LEUGH',
    'TAJES',
    'WALIE',
    'MOPER',
    'FAUTS',
    'KNARS',
    'THARM',
    'DAURS',
    'RYKES',
    'LOTAH',
    'AIERY',
    'BUDAS',
    'TRAYF',
    'GONKS',
    'FYKES',
    'CLUEY',
    'WAMES',
    'ERUGO',
    'GURNS',
    'JUVES',
    'HARLS',
    'GRYPE',
    'INCUT',
    'YUCAS',
    'ZORIS',
    'LEAMS',
    'PHEON',
    'PANDS',
    'DOWLY',
    'MULIE',
    'LERPS',
    'OGAMS',
    'CHAYS',
    'KAYOS',
    'GRUME',
    'MAIKS',
    'DEFIS',
    'NIFES',
    'PIUMS',
    'REWAN',
    'PREDY',
    'GUSLA',
    'LIROT',
    'KEMPY',
    'URASE',
    'RAWIN',
    'CUSPY',
    'SMORG',
    'CLOWS',
    'OUMAS',
    'AXITE',
    'URBIA',
    'IDANT',
    'VIBEX',
    'STRAG',
    'MABES',
    'TOFUS',
    'BIRLS',
    'UPBOW',
    'TUMPY',
    'WHOPS',
    'ELANS',
    'RAJES',
    'OXERS',
    'GENIP',
    'FYRDS',
    'FARDS',
    'PIONY',
    'MAYED',
    'SKIMO',
    'MOULS',
    'FUJIS',
    'SEITY',
    'SWILE',
    'ISTLE',
    'UNTAX',
    'LITED',
    'DEGUM',
    'PEBAS',
    'SCROW',
    'QORMA',
    'PATUS',
    'YARTO',
    'DORTS',
    'ROKES',
    'OCTAS',
    'DERNY',
    'YOJAN',
    'YARCO',
    'BLAGS',
    'REANS',
    'CREMS',
    'CLAUT',
    'QUEYN',
    'OUPHE',
    'PAXES',
    'DACES',
    'CALPS',
    'VULNS',
    'POIND',
    'SINKY',
    'STOAI',
    'WANZE',
    'GEANS',
    'NEUMS',
    'THOLI',
    'MOBEY',
    'FIRNS',
    'KUFIS',
    'AIVER',
    'UPTAK',
    'PULAS',
    'BAGHS',
    'MEITH',
    'NOXES',
    'WHAMO',
    'ALIFS',
    'DURZI',
    'TOSHY',
    'REWIN',
    'DIKAS',
    'LOUNS',
    'TSADI',
    'OPAHS',
    'LIMBY',
    'OVIST',
    'AUMIL',
    'KNAWE',
    'SPAED',
    'SCRAY',
    'TRINS',
    'EYRAS',
    'WHORT',
    'CITAL',
    'RAGDE',
    'KITHS',
    'GUIMP',
    'RAGIS',
    'RIMUS',
    'ROULS',
    'AXOID',
    'DURNS',
    'DORTY',
    'SNIPY',
    'ALMEH',
    'COWPS',
    'DWAMS',
    'MODGE',
    'DUPLY',
    'ULANS',
    'GOJIS',
    'CHIRT',
    'PHOTS',
    'BEZIL',
    'YLIKE',
    'WAULK',
    'DHOLS',
    'TOUSY',
    'NITRY',
    'KIPES',
    'CHIVS',
    'PAREV',
    'ZERKS',
    'SNIRT',
    'ROUPY',
    'FICOS',
    'EORLS',
    'FUNGS',
    'KEMBS',
    'FIARS',
    'GROKS',
    'KARSY',
    'CUNIT',
    'WALDS',
    'OHING',
    'SPEWY',
    'KOHAS',
    'LOXES',
    'COSIE',
    'ELOGY',
    'PYRAL',
    'TUBAR',
    'BUFOS',
    'DECOS',
    'UMPHS',
    'YOICK',
    'SPULE',
    'CLYPE',
    'UNAIS',
    'FLEYS',
    'SYKER',
    'VIEWY',
    'ETNAS',
    'YUKES',
    'BIGAE',
    'HYLEG',
    'DWILE',
    'ARPEN',
    'GELTS',
    'WOMBY',
    'JIVEY',
    'SCRAB',
    'WEKAS',
    'ALEFS',
    'BLADS',
    'GYPOS',
    'BIOGS',
    'DARGS',
    'ALODS',
    'BERAY',
    'MVULE',
    'PIBAL',
    'CYLIX',
    'TYNDE',
    'AMYLS',
    'QUOIF',
    'ROHES',
    'SNIFT',
    'ROLAG',
    'JARKS',
    'PREMY',
    'HULES',
    'VROWS',
    'ALURE',
    'PAVID',
    'MEBOS',
    'JANTY',
    'PROKE',
    'GAVOT',
    'DRIPT',
    'JIVER',
    'NIMPS',
    'TOCKY',
    'TUPEK',
    'DERIG',
    'GIPON',
    'HINAU',
    'QUIPO',
    'BUDIS',
    'VIMEN',
    'KITUL',
    'MASED',
    'UPLAY',
    'SARED',
    'DIRAM',
    'DUXES',
    'DRONY',
    'SHLUB',
    'BUHRS',
    'SHROW',
    'TIZES',
    'YUCKO',
    'CRUDY',
    'DUMKY',
    'FENDY',
    'PRIEF',
    'HOVEA',
    'FETAS',
    'SUENT',
    'BAURS',
    'UNLID',
    'RUNDS',
    'ZYGAL',
    'SPARD',
    'SPAWL',
    'DOCUS',
    'UNSEW',
    'DOUPS',
    'LIART',
    'AWETO',
    'GOAFS',
    'ZORIL',
    'CAVIE',
    'VAUTE',
    'BLAER',
    'PAWER',
    'HALMS',
    'CHIKS',
    'MOSED',
    'LUSER',
    'TRAIK',
    'ATOKE',
    'REIFS',
    'BEWIG',
    'KAIFS',
    'VATUS',
    'STILB',
    'BLERT',
    'KHATS',
    'CLEIK',
    'UNPAY',
    'REFLY',
    'SCHAV',
    'YOUKS',
    'TALCY',
    'DULES',
    'PYXIE',
    'TAWER',
    'CHIRM',
    'IGAPO',
    'TIRLS',
    'AZYME',
    'BOUKS',
    'DEBAG',
    'SWEAL',
    'XYSTI',
    'RAXES',
    'OXIES',
    'RETAG',
    'TEADS',
    'MUCID',
    'TEUGH',
    'PERNS',
    'DORBA',
    'CYMOL',
    'UNCOS',
    'SCULK',
    'KNARL',
    'YEADS',
    'ZOEAS',
    'MUXED',
    'SPEAT',
    'MECKS',
    'EMBUS',
    'PYNED',
    'OWRIE',
    'FLIMP',
    'REDIP',
    'MOBES',
    'CARKS',
    'JARUL',
    'SLORM',
    'YBORE',
    'DOWPS',
    'PADLE',
    'COITS',
    'SIETH',
    'BUNJY',
    'COYED',
    'PLOYE',
    'ZAXES',
    'CNIDA',
    'ARIOT',
    'DIRLS',
    'ZONKS',
    'PROUL',
    'SLURB',
    'WOADS',
    'SHORL',
    'PULIK',
    'DROIL',
    'QUODS',
    'CHELP',
    'YACKS',
    'SIPED',
    'SWAPT',
    'STOUN',
    'KHOUM',
    'GOETY',
    'BLAMS',
    'BLINS',
    'PUJAH',
    'KHUDS',
    'TIFOS',
    'OURIE',
    'GORMS',
    'MUNGS',
    'GATHS',
    'CROGS',
    'LAXES',
    'BOWRS',
    'FIRKS',
    'WIFTY',
    'TOGED',
    'CASKY',
    'RESOD',
    'SOZIN',
    'FLARY',
    'KOGAL',
    'GLIFT',
    'AWNER',
    'POWNS',
    'PRUTA',
    'RONTS',
    'OYERS',
    'BORKS',
    'DRAIL',
    'MIRKS',
    'TRYPS',
    'GEUMS',
    'VUGHY',
    'HORKS',
    'SILED',
    'TWINY',
    'OJIME',
    'TEGUA',
    'SIZEL',
    'GECKS',
    'NOULD',
    'DOEKS',
    'PELMA',
    'UNCES',
    'THEWY',
    'MURVA',
    'TRYKE',
    'SHILY',
    'GIRNS',
    'DOPAS',
    'BUDOS',
    'ROATE',
    'BIONT',
    'SPELK',
    'LOMES',
    'QUONK',
    'YAULD',
    'GLITS',
    'LENGS',
    'TOLUS',
    'NIKAB',
    'NIGHS',
    'QUICH',
    'SCAUD',
    'NOWED',
    'SPRUG',
    'SEWAR',
    'APODS',
    'FONLY',
    'GLEDS',
    'ETUIS',
    'HIPLY',
    'DUANS',
    'ARMIL',
    'OHIAS',
    'GOWLS',
    'WRIES',
    'PYATS',
    'PLUES',
    'AHENT',
    'SWOUN',
    'LOAST',
    'NEUKS',
    'BITOS',
    'VINTS',
    'ARUHE',
    'ROIST',
    'BILGY',
    'BULSE',
    'DEASH',
    'YEANS',
    'UNRED',
    'MEYNT',
    'ARVOS',
    'KAGOS',
    'OWRES',
    'VOGIE',
    'HUERS',
    'SPIAL',
    'BUNAS',
    'PUNCE',
    'PUHAS',
    'THELF',
    'DAMPY',
    'REWTH',
    'MERLS',
    'DAWTS',
    'COZES',
    'MUSIT',
    'BARMS',
    'REINK',
    'NOWTS',
    'KIDGE',
    'TAXOR',
    'WOALD',
    'REFIS',
    'TAWIE',
    'SYVER',
    'HENTS',
    'FOUER',
    'GROUF',
    'LAERS',
    'UNGOT',
    'GYALS',
    'THEIC',
    'SKYRE',
    'PIXES',
    'COSED',
    'STOWP',
    'CLATS',
    'SANED',
    'YOCKS',
    'HOYED',
    'DOUCS',
    'REBIT',
    'SYMAR',
    'RESAY',
    'ULVAS',
    'SMAIK',
    'PAGLE',
    'GYNIE',
    'SAMFU',
    'BAWTY',
    'TWIER',
    'QURSH',
    'SPALD',
    'VAXES',
    'MOYLS',
    'TWANK',
    'APODE',
    'UREIC',
    'SWERF',
    'MPRET',
    'TOPHE',
    'DEAWY',
    'DREKS',
    'THOWL',
    'AWMRY',
    'BLUDS',
    'BOKED',
    'COGUE',
    'RIFTY',
    'LUXER',
    'WROKE',
    'OUPHS',
    'FLOBS',
    'VOUGE',
    'KIRNS',
    'GLIKE',
    'APISM',
    'DOWLS',
    'LOAVE',
    'POYSE',
    'KYBOS',
    'AZURY',
    'IGLUS',
    'BAFTS',
    'YMPES',
    'STOAE',
    'BUHLS',
    'URPED',
    'TOAZE',
    'MIDGY',
    'BEMAD',
    'STYME',
    'WRAST',
    'SYNED',
    'KEIRS',
    'COPSY',
    'FLOSH',
    'WAMED',
    'THAWY',
    'FANDS',
    'JALOP',
    'GOARY',
    'OUBIT',
    'GURSH',
    'AMOKS',
    'GLIBS',
    'ASTUN',
    'MOYAS',
    'GUCKY',
    'UNBAG',
    'SHMEK',
    'WIZES',
    'FUZIL',
    'SAJOU',
    'AYINS',
    'UPLED',
    'YERDS',
    'WOCKS',
    'NEIFS',
    'GUARS',
    'BROGS',
    'GORPS',
    'CHUTS',
    'ADOZE',
    'CEBID',
    'DITAL',
    'HOXES',
    'UNETH',
    'CUZES',
    'AIZLE',
    'AVELS',
    'DEAIR',
    'EHING',
    'BLETS',
    'NEMPT',
    'GROVY',
    'COBZA',
    'HOIKS',
    'WHIFT',
    'FAIKS',
    'JIGOT',
    'AITUS',
    'SLOJD',
    'BAWKS',
    'ZARIS',
    'GRIPY',
    'KAGUS',
    'KYNDS',
    'BRAKY',
    'CYMAE',
    'GLEBY',
    'KAILS',
    'GOBIS',
    'SCOUP',
    'ULMIN',
    'CURNY',
    'INERM',
    'UNHAT',
    'PULER',
    'WANLE',
    'SIELD',
    'VAWTE',
    'COURB',
    'ROJIS',
    'PLIMS',
    'PIKAU',
    'CADGY',
    'DIEBS',
    'OAVES',
    'HIANT',
    'PILOW',
    'LUGED',
    'NERKS',
    'WAMUS',
    'CLONS',
    'VOLED',
    'DIACT',
    'FLEGS',
    'TYNED',
    'NOULS',
    'JAUPS',
    'ERUVS',
    'ZOBUS',
    'FURAL',
    'HOWKS',
    'BORTY',
    'DURGY',
    'MAWKS',
    'DOUMS',
    'POLTS',
    'VEALY',
    'GORMY',
    'MULSE',
    'GNOWS',
    'TOGES',
    'UNKID',
    'YAUDS',
    'GOELS',
    'LOCIE',
    'UNMEW',
    'DEMPT',
    'CUISH',
    'TOSED',
    'NIMBS',
    'SCAIL',
    'YUPON',
    'UMPIE',
    'CAUPS',
    'CIRLS',
    'POWIN',
    'HOWBE',
    'NOILY',
    'VEGOS',
    'NAVEW',
    'WELKT',
    'ZIBET',
    'CHIMB',
    'MOWAS',
    'NIEFS',
    'BAGIE',
    'YIRTH',
    'HOLKS',
    'MIAUL',
    'EARDS',
    'AZURN',
    'PREIF',
    'ECADS',
    'OUPAS',
    'VOIPS',
    'SMAZE',
    'METIF',
    'PRUNT',
    'XYLIC',
    'HOKIS',
    'REWAX',
    'SPREW',
    'ROSIT',
    'OMLAH',
    'JIAOS',
    'SHAKT',
    'KHETS',
    'BOWAT',
    'PUSLE',
    'PSOAE',
    'YAPON',
    'ROGUY',
    'TOZIE',
    'OCHRY',
    'RUMLY',
    'HUIAS',
    'PHUTS',
    'LOIRS',
    'SLOID',
    'YOMPS',
    'DERNS',
    'FRIBS',
    'ZOUKS',
    'BOUSY',
    'STIVY',
    'BOYLA',
    'ZLOTE',
    'FEALS',
    'SCLIM',
    'RUSMA',
    'VAUCH',
    'FLAWY',
    'NURLS',
    'CARVY',
    'TWOER',
    'OXIDS',
    'SOWCE',
    'UNKET',
    'ODALS',
    'HAUFS',
    'ULZIE',
    'VEXIL',
    'WYTED',
    'FOWTH',
    'GOWDS',
    'TINDS',
    'MUIST',
    'TRILD',
    'DOSEH',
    'UPSEY',
    'ENSKY',
    'YARKS',
    'GAUCY',
    'VIRED',
    'ENLIT',
    'SKLIM',
    'DUOMI',
    'BICES',
    'ULNAD',
    'BOUNS',
    'DRUXY',
    'WITED',
    'GONEF',
    'VAUTS',
    'VOARS',
    'PUDSY',
    'PUTID',
    'OGMIC',
    'YOGHS',
    'FROWY',
    'GLIAS',
    'COYAU',
    'RIFTE',
    'TUYER',
    'WAUKS',
    'PYOTS',
    'MURLY',
    'NIRLY',
    'GAWSY',
    'MOWRA',
    'ABOHM',
    'TRYMA',
    'FAURD',
    'BROGH',
    'JIBER',
    'JEONS',
    'OMBUS',
    'KYPES',
    'DOUKS',
    'PUCER',
    'UPBYE',
    'STIMY',
    'WARBS',
    'JUDOS',
    'NOWTY',
    'NOWLS',
    'ROKED',
    'WOJUS',
    'QUEYS',
    'MISGO',
    'PLOAT',
    'GRUED',
    'CUIFS',
    'LUXED',
    'OUPED',
    'UPTER',
    'LOWTS',
    'LEUDS',
    'RETAX',
    'PROYN',
    'GYNOS',
    'WHEFT',
    'OUNDY',
    'VIFDA',
    'WAULS',
    'MAWKY',
    'BOXLA',
    'FRUGS',
    'RAWNS',
    'TWYER',
    'ONCUS',
    'POAKE',
    'REOIL',
    'COURD',
    'BUAZE',
    'NURDS',
    'KAIES',
    'KNAGS',
    'SNOWK',
    'ZARFS',
    'TROAK',
    'FILKS',
    'IZARS',
    'EMBOX',
    'ERHUS',
    'ROINS',
    'GAUMY',
    'OWCHE',
    'BYDES',
    'YRENT',
    'SCRAE',
    'LWEIS',
    'DYKON',
    'ENARM',
    'FENKS',
    'ROYST',
    'NEPIT',
    'WAIRS',
    'YUMPS',
    'WYTES',
    'ARLED',
    'COZEY',
    'LOMED',
    'YOKUL',
    'KARZY',
    'CLIED',
    'EMBOW',
    'SOKAH',
    'VEILY',
    'SCOUG',
    'AZONS',
    'YITES',
    'VOLAE',
    'FOIDS',
    'CHIRL',
    'KAURY',
    'KEDGY',
    'WYLED',
    'UNBED',
    'LOIPE',
    'ALOED',
    'GLAIK',
    'JUCOS',
    'CAPHS',
    'YAKOW',
    'ZINCY',
    'SPAIL',
    'CRUVE',
    'VRILS',
    'YSAME',
    'MURLS',
    'GYTES',
    'UPTIE',
    'RYNDS',
    'KNUBS',
    'CHOGS',
    'PUCAN',
    'ARNUT',
    'BAPUS',
    'MYXOS',
    'YODHS',
    'NOULE',
    'DROUK',
    'ZOISM',
    'SOHUR',
    'PUMIE',
    'GYANS',
    'CLOYE',
    'SWOPT',
    'UMRAS',
    'LAPJE',
    'JELAB',
    'YAGES',
    'TUNDS',
    'ENOWS',
    'FOUDS',
    'BUFTY',
    'GEALS',
    'PYETS',
    'ROUMS',
    'GOPIK',
    'UDALS',
    'ROWTS',
    'CIBOL',
    'KAUGH',
    'ORFES',
    'YCLED',
    'WAIFT',
    'PLOUK',
    'PONKS',
    'MIFTY',
    'SCUFT',
    'CINQS',
    'MOCHY',
    'ONKUS',
    'VIOLD',
    'UNSAW',
    'DWALM',
    'ADUNC',
    'YEUKS',
    'DWAUM',
    'YELTS',
    'TOWZE',
    'YCOND',
    'AGLUS',
    'VIRLS',
    'SIXMO',
    'TOUZY',
    'ATIMY',
    'KAPHS',
    'ZUPAS',
    'TYMPS',
    'INDEW',
    'CYMAS',
    'GILPY',
    'TOEAS',
    'GRYPT',
    'FIKED',
    'WEIDS',
    'DONSY',
    'QUAYD',
    'YIRKS',
    'COIRS',
    'ORGIC',
    'HYENS',
    'WEROS',
    'FOHNS',
    'AJIES',
    'COTHS',
    'DAYNT',
    'GAUMS',
    'YELMS',
    'ROZIT',
    'PIZES',
    'ULYIE',
    'YOWED',
    'GOUKS',
    'GAIDS',
    'FYKED',
    'JAUKS',
    'RAHED',
    'KUIAS',
    'KRUBI',
    'POTED',
    'HOXED',
    'WHIOS',
    'JOUKS',
    'OXIMS',
    'DHAKS',
    'MUILS',
    'ICHED',
    'KNURS',
    'CANGS',
    'MEOUS',
    'SPEUG',
    'PSOAI',
    'MOLYS',
    'SCOWP',
    'EUPAD',
    'EBONS',
    'MAUSY',
    'AREFY',
    'TRIPY',
    'TANHS',
    'TEPOY',
    'GAUJE',
    'YORPS',
    'SWALY',
    'UVEAS',
    'AMOWT',
    'VROUS',
    'OLPES',
    'HAJES',
    'AYELP',
    'SYBOW',
    'FIQHS',
    'OKEHS',
    'DALTS',
    'NUDZH',
    'PIEND',
    'SQUEG',
    'RYKED',
    'ADBOT',
    'SKODY',
    'YAUPS',
    'TWAES',
    'JARPS',
    'BEMUD',
    'MOITS',
    'ABMHO',
    'GUCKS',
    'LOXED',
    'URVAS',
    'CAUKS',
    'BIZES',
    'KILPS',
    'BOLIX',
    'BEPAT',
    'PAYSD',
    'NAZES',
    'FEODS',
    'MAWNS',
    'MOCHS',
    'SMEIK',
    'ODISM',
    'FYCES',
    'MIRLY',
    'KYDST',
    'AZYMS',
    'DORBS',
    'GANOF',
    'DAYCH',
    'YIRDS',
    'HAKUS',
    'YRAPT',
    'ABYES',
    'DOGEY',
    'OSHAC',
    'YIKED',
    'GNARS',
    'PIZED',
    'YRNEH',
    'SWAYL',
    'AYGRE',
    'MAUTS',
    'CRUSY',
    'UPDRY',
    'MULSH',
    'BUMFS',
    'HOWFS',
    'UNRID',
    'HAETS',
    'BOYFS',
    'SKIVY',
    'AMNIC',
    'ALKOS',
    'TOWZY',
    'MOUPS',
    'URAOS',
    'ZYMIC',
    'UNSOD',
    'KHAFS',
    'YECHS',
    'JEATS',
    'WHYDA',
    'GEITS',
    'KIEFS',
    'IMSHY',
    'BREYS',
    'COZED',
    'RAUNS',
    'SCODY',
    'LIRKS',
    'BLYPE',
    'KAWED',
    'DUNSH',
    'CANEH',
    'UPRAN',
    'TOPHS',
    'PELFS',
    'HOUFS',
    'BARPS',
    'RHIES',
    'PAWKS',
    'YUFTS',
    'BUATS',
    'HOIED',
    'LYAMS',
    'GOXES',
    'POUKS',
    'DOWTS',
    'PEROG',
    'GRUFE',
    'UNCOY',
    'PENKS',
    'UDONS',
    'BOYGS',
    'TIARS',
    'BEMIX',
    'ZATIS',
    'QUOPS',
    'EXULS',
    'ODAHS',
    'SMOWT',
    'WADTS',
    'EMYDS',
    'FRABS',
    'CHYND',
    'MOZED',
    'ENFIX',
    'NIRLS',
    'DAUTS',
    'POHED',
    'BOEPS',
    'BHELS',
    'BIRSY',
    'PORAE',
    'ECRUS',
    'WAURS',
    'DERVS',
    'SPYAL',
    'GOLPS',
    'EUGHS',
    'YUKED',
    'ATOKS',
    'ZURFS',
    'JOLED',
    'PEAGS',
    'GOIER',
    'TOUKS',
    'GAWCY',
    'YMOLT',
    'NURDY',
    'JOWED',
    'WEAMB',
    'DEAWS',
    'UMIAC',
    'PYOID',
    'OULKS',
    'BECAP',
    'FOUAT',
    'GAUPS',
    'VINEW',
    'ADVEW',
    'BAWRS',
    'STULM',
    'LYTED',
    'SPUER',
    'EMBOG',
    'COWKS',
    'IKANS',
    'CAUMS',
    'LOWPS',
    'YLEMS',
    'SAICK',
    'ATOCS',
    'TOZED',
    'EILDS',
    'PIOYE',
    'KOPHS',
    'GYMPS',
    'GYELD',
    'BWAZI',
    'INORB',
    'DOILT',
    'SYBOE',
    'RAIKS',
    'MAWRS',
    'SENVY',
    'YLKES',
    'TWALS',
    'WEMBS',
    'UPJET',
    'CAWKS',
    'ALEWS',
    'PIOYS',
    'SDEIN',
    'NOUPS',
    'TEHRS',
    'PYXED',
    'ZEDAS',
    'HAWMS',
    'PEGHS',
    'HOAED',
    'SOUCT',
    'TOZES',
    'ZIMBS',
    'YRIVD',
    'VOEMA',
    'TIYNS',
    'SYPED',
    'SDAYN',
    'QOPHS',
    'QAPIK',
    'PYINS',
    'ODYLS',
    'NABKS',
    'KOAPS',
    'HWYLS',
    'HUMFS',
    'GOWFS',
    'EGMAS',
    'DZHOS',
    'BYRLS',
    'BYKED',
    'AWDLS',
    'AVYZE',
    'WHICH',
    'THERE',
    'THESE',
    'WHERE',
    'STILL',
    'NEVER',
    'AGAIN',
    'THREE',
    'STATE',
    'GOING',
    'EVERY',
    'SMALL',
    'ORDER',
    'PRESS',
    'SHALL',
    'LEVEL',
    'KNOWN',
    'SENSE',
    'LOCAL',
    'BLOOD',
    'CLASS',
    'LEAVE',
    'CASES',
    'STOOD',
    'NEEDS',
    'START',
    'BIBLE',
    'JESUS',
    'TOTAL',
    'SEEMS',
    'TRUTH',
    'PAPER',
    'AREAS',
    'LEGAL',
    'BOOKS',
    'SHOWS',
    'GREEN',
    'FLOOR',
    'ISSUE',
    'ADDED',
    'CELLS',
    'CROSS',
    'HAPPY',
    'RIVER',
    'BASIS',
    'TRUST',
    'ALLOW',
    'SLEEP',
    'PEACE',
    'UNION',
    'OFFER',
    'STEPS',
    'SEVEN',
    'CIVIL',
    'EVENT',
    'INDIA',
    'WEEKS',
    'GLASS',
    'COSTS',
    'SORRY',
    'LOOKS',
    'STAFF',
    'SHOOK',
    'FULLY',
    'PETER',
    'CHECK',
    'VISIT',
    'PIECE',
    'SERVE',
    'TREES',
    'AWARE',
    'SCENE',
    'SPEED',
    'PRIOR',
    'COLOR',
    'OCCUR',
    'UPPER',
    'CARRY',
    'GOODS',
    'APPLY',
    'HENCE',
    'TITLE',
    'TOOLS',
    'ENTER',
    'WALLS',
    'AHEAD',
    'SWEET',
    'APART',
    'ENEMY',
    'CALLS',
    'GUESS',
    'SIGNS',
    'GREEK',
    'USUAL',
    'TESTS',
    'QUEEN',
    'DRESS',
    'ERROR',
    'SIDES',
    'JAPAN',
    'ENDED',
    'WORRY',
    'SALES',
    'SITES',
    'CYCLE',
    'TEETH',
    'INNER',
    'AGREE',
    'USERS',
    'LIMIT',
    'CATCH',
    'TEXTS',
    'RURAL',
    'TASTE',
    'STUFF',
    'DOORS',
    'CLICK',
    'REFER',
    'TASKS',
    'PROOF',
    'FIFTY',
    'RISKS',
    'TELLS',
    'STEEL',
    'TIGHT',
    'ROOMS',
    'TREAT',
    'MOTOR',
    'FEELS',
    'STARS',
    'KNEES',
    'SHEET',
    'SMELL',
    'HONOR',
    'GRASS',
    'PHOTO',
    'SKILL',
    'SHIPS',
    'HARRY',
    'MARRY',
    'NERVE',
    'FALLS',
    'FIFTH',
    'SHOES',
    'ROOTS',
    'THEME',
    'CHEEK',
    'LOOSE',
    'WOODS',
    'SONGS',
    'VERSE',
    'MOSES',
    'ESSAY',
    'GENES',
    'FOODS',
    'WHEEL',
    'HILLS',
    'ASSET',
    'MARIA',
    'FUNNY',
    'ARRAY',
    'GROSS',
    'APPLE',
    'SHELL',
    'FEVER',
    'CLOCK',
    'COACH',
    'FEWER',
    'SHOOT',
    'DRAMA',
    'SEEDS',
    'KEEPS',
    'SHEEP',
    'ELITE',
    'LABEL',
    'EBOOK',
    'BOOTS',
    'AWARD',
    'EDGES',
    'DRIED',
    'SOULS',
    'LISTS',
    'HELLO',
    'EAGER',
    'SEATS',
    'SORTS',
    'COUCH',
    'AWAKE',
    'HURRY',
    'CRACK',
    'CREEK',
    'LAURA',
    'ALARM',
    'ROGER',
    'FLOOD',
    'BILLY',
    'GONNA',
    'BELLY',
    'KNOCK',
    'FLEET',
    'ELDER',
    'SEEKS',
    'AGING',
    'ARROW',
    'KELLY',
    'NAVAL',
    'SPELL',
    'DADDY',
    'EATEN',
    'CANAL',
    'GENRE',
    'DATED',
    'STOPS',
    'SIZES',
    'HARSH',
    'BALLS',
    'PEERS',
    'BILLS',
    'ALTAR',
    'TRACT',
    'RIGID',
    'FENCE',
    'HEELS',
    'SHOPS',
    'FADED',
    'SILLY',
    'TENSE',
    'DENSE',
    'ALPHA',
    'JIMMY',
    'BASES',
    'MEETS',
    'FATAL',
    'NANCY',
    'CIVIC',
    'SPOTS',
    'WELLS',
    'VALVE',
    'QUEER',
    'SKULL',
    'SHOTS',
    'RULER',
    'STIFF',
    'ADAPT',
    'SHEER',
    'WIDOW',
    'MOLLY',
    'SALLY',
    'SALAD',
    'POSTS',
    'FUZZY',
    'RISES',
    'ROBOT',
    'PENNY',
    'STEEP',
    'LOYAL',
    'LEASE',
    'EXILE',
    'CLIFF',
    'DEEDS',
    'DONOR',
    'JENNY',
    'UTTER',
    'ARENA',
    'DARED',
    'MILLS',
    'DANNY',
    'FATTY',
    'TOOTH',
    'JERRY',
    'TOMMY',
    'BLESS',
    'HOSTS',
    'PULLS',
    'ROLLS',
    'CHILL',
    'PUSSY',
    'DOSES',
    'SUITS',
    'CEASE',
    'TWIST',
    'COMIC',
    'BARRY',
    'THIGH',
    'EAGLE',
    'WEBER',
    'ONION',
    'SOILS',
    'SENDS',
    'TERRY',
    'BOBBY',
    'LOBBY',
    'TENTH',
    'DWELL',
    'BRASS',
    'DREAD',
    'NINTH',
    'GASES',
    'BOOTH',
    'SWISS',
    'VIVID',
    'GAUGE',
    'THEFT',
    'JESSE',
    'PIZZA',
    'BETTY',
    'FISTS',
    'REBEL',
    'IDIOT',
    'HOLLY',
    'TRAIT',
    'STOOL',
    'MERRY',
    'BLOOM',
    'RADAR',
    'STEMS',
    'ROSES',
    'SPOON',
    'SWEEP',
    'RESTS',
    'CANON',
    'ARMOR',
    'VILLA',
    'ALLEY',
    'LIPID',
    'FREED',
    'MADAM',
    'SUNNY',
    'METER',
    'LINEN',
    'BOOST',
    'STAYS',
    'PERRY',
    'DRILL',
    'TOAST',
    'EASED',
    'AXIAL',
    'ASHES',
    'SIDED',
    'SIEGE',
    'PETTY',
    'BREED',
    'HEDGE',
    'NASAL',
    'PUPIL',
    'BELLS',
    'RIDER',
    'LOSES',
    'ABBEY',
    'PIPES',
    'BUDDY',
    'EXCEL',
    'BOMBS',
    'GREET',
    'KITTY',
    'SEIZE',
    'GOTTA',
    'CHEER',
    'FERRY',
    'BERRY',
    'BLISS',
    'AIDED',
    'POOLS',
    'HEATH',
    'POSES',
    'NIECE',
    'PILLS',
    'PAGAN',
    'COLON',
    'FOLLY',
    'HALLS',
    'NEWER',
    'BASAL',
    'TEENS',
    'BOSOM',
    'BELLE',
    'ALLOY',
    'EXERT',
    'TENTS',
    'GLOOM',
    'LOOPS',
    'CREEP',
    'BUSES',
    'ELECT',
    'FILLS',
    'ERECT',
    'ATLAS',
    'CODED',
    'STALL',
    'SCARS',
    'BROOK',
    'EDEMA',
    'TEDDY',
    'VENUE',
    'RABBI',
    'SKIES',
    'GAMMA',
    'DONNA',
    'SOCKS',
    'LEMMA',
    'STOUT',
    'SPILL',
    'PASTA',
    'HATCH',
    'CONGO',
    'IONIC',
    'EDGED',
    'ASSAY',
    'POLLY',
    'WILLS',
    'GREED',
    'SINUS',
    'MASKS',
    'CHUCK',
    'PUMPS',
    'CHESS',
    'WEEDS',
    'GOOSE',
    'SELLS',
    'SWELL',
    'SEALS',
    'ODDLY',
    'PLAZA',
    'KILLS',
    'PUPPY',
    'FOOLS',
    'TROUT',
    'MUDDY',
    'FEEDS',
    'SANDS',
    'ANNEX',
    'NOUNS',
    'VERGE',
    'CREED',
    'FANNY',
    'CUBIC',
    'PIPER',
    'BRILL',
    'MESSY',
    'JEWEL',
    'TROOP',
    'QUEUE',
    'GRILL',
    'SALTS',
    'RALLY',
    'STEER',
    'SKINS',
    'SPIES',
    'DIGIT',
    'TORSO',
    'GANGS',
    'MAMMA',
    'ATTIC',
    'WANNA',
    'MERGE',
    'CURRY',
    'WEDGE',
    'MOMMY',
    'COCOA',
    'LEVER',
    'POPPY',
    'SAILS',
    'JOLLY',
    'TUTOR',
    'DODGE',
    'GROOM',
    'SEXES',
    'ROOFS',
    'PEGGY',
    'WATTS',
    'AVAIL',
    'PAPAL',
    'ROTOR',
    'OZONE',
    'REUSE',
    'AWAIT',
    'AROMA',
    'DIZZY',
    'RENEW',
    'SLIPS',
    'MIMIC',
    'RAZOR',
    'MUMMY',
    'SCOTS',
    'ETHER',
    'LASTS',
    'AVANT',
    'CACHE',
    'TEASE',
    'LEDGE',
    'SIGHS',
    'OBESE',
    'SCANS',
    'DOLLY',
    'ABYSS',
    'HOOKS',
    'ABBOT',
    'NEEDY',
    'ALGAE',
    'BULLY',
    'BEERS',
    'SINGS',
    'SAVES',
    'MOODS',
    'SEINE',
    'EVOKE',
    'CASTS',
    'PATTY',
    'DUMMY',
    'ARBOR',
    'LOGOS',
    'TACIT',
    'MOODY',
    'POLLS',
    'BLUFF',
    'TERRA',
    'TIMID',
    'PARAS',
    'JELLY',
    'KARMA',
    'DETER',
    'RUMOR',
    'WEAVE',
    'LEONE',
    'SAMMY',
    'PLUMP',
    'CHICK',
    'RESET',
    'DOLLS',
    'GENET',
    'MAXIM',
    'UNDUE',
    'ERASE',
    'WOODY',
    'BLEED',
    'DAZED',
    'NOSES',
    'MOTTO',
    'PRATT',
    'AORTA',
    'CHILI',
    'NANNY',
    'ROMEO',
    'SCOOP',
    'CROOK',
    'SACKS',
    'SINKS',
    'SMASH',
    'COOKS',
    'KERRY',
    'HOBBY',
    'NESTS',
    'BENNY',
    'ABACK',
    'ISLES',
    'SLEEK',
    'GYPSY',
    'GORGE',
    'PADDY',
    'KICKS',
    'TABOO',
    'DOPED',
    'TASTY',
    'CYSTS',
    'MENGE',
    'GEMMA',
    'GLOSS',
    'PROTO',
    'DICED',
    'BROOM',
    'EERIE',
    'SHEDS',
    'BUNNY',
    'REVUE',
    'BULLS',
    'SECTS',
    'METRE',
    'SPANS',
    'ROVER',
    'ABRAM',
    'FAUNA',
    'ESTER',
    'MAFIA',
    'STENT',
    'STATS',
    'WILLY',
    'DESKS',
    'MOMMA',
    'KNEEL',
    'PESTS',
    'PAOLO',
    'PETIT',
    'TILLY',
    'SLASH',
    'WITTY',
    'YELLS',
    'DIODE',
    'LOWLY',
    'EVADE',
    'SONNY',
    'DISKS',
    'BRIBE',
    'MECCA',
    'SPINS',
    'PROPS',
    'OASIS',
    'ELVES',
    'DINED',
    'BULBS',
    'CUFFS',
    'LUPUS',
    'MOONS',
    'SLOTS',
    'NATAL',
    'SACRA',
    'MOOSE',
    'SEMEN',
    'CIRCA',
    'VEXED',
    'MANIA',
    'SNIFF',
    'IDIOM',
    'HOMME',
    'SAVVY',
    'BROOD',
    'BUGGY',
    'SUCKS',
    'REEFS',
    'TEMPT',
    'PARRY',
    'SPURS',
    'SLABS',
    'GEESE',
    'HITCH',
    'SOLES',
    'GASPS',
    'ICING',
    'GIDDY',
    'RIGOR',
    'SLOWS',
    'SNAPS',
    'ALOOF',
    'MOORS',
    'CONDO',
    'SNEER',
    'STARR',
    'SAGES',
    'MUCUS',
    'BOOZE',
    'SHEEN',
    'MISSY',
    'SEWER',
    'DISCS',
    'DEFER',
    'ANION',
    'REEDS',
    'DONNE',
    'STOOP',
    'FOLIO',
    'TALLY',
    'SEAMS',
    'OLLIE',
    'SONNE',
    'DRYLY',
    'AMISS',
    'NYLON',
    'FRIAR',
    'ODOUR',
    'SIEVE',
    'DIDST',
    'HEAVE',
    'BESET',
    'SALSA',
    'ALIAS',
    'DIVED',
    'FOSSA',
    'AVIAN',
    'TAMMY',
    'ASSES',
    'SLUMS',
    'GINNY',
    'SPASM',
    'GABBY',
    'ILIAC',
    'COMMA',
    'PASHA',
    'TWEET',
    'DRYER',
    'BORON',
    'APNEA',
    'REDDY',
    'RUDDY',
    'CISCO',
    'BEECH',
    'BABEL',
    'GRUFF',
    'LIBEL',
    'ILIAD',
    'TITAN',
    'FECES',
    'SHYLY',
    'BOOTY',
    'PENCE',
    'FEMME',
    'VISAS',
    'PIPED',
    'ALIBI',
    'BEIGE',
    'FURRY',
    'WHIFF',
    'VIGIL',
    'WALLY',
    'DUNNO',
    'ALKYL',
    'EXPEL',
    'RODEO',
    'STUNT',
    'EMERY',
    'SEARS',
    'STEED',
    'ABBAS',
    'LORRY',
    'HUNCH',
    'TUMMY',
    'VASES',
    'TROLL',
    'SLITS',
    'DELVE',
    'SERGE',
    'PUFFY',
    'SODOM',
    'COCKS',
    'EMBER',
    'EMERG',
    'SHUTS',
    'DIXIE',
    'SNUFF',
    'BUTTS',
    'OTTER',
    'MISTS',
    'PUFFS',
    'MUSES',
    'FANON',
    'TIBIA',
    'LOOMS',
    'FOGGY',
    'ANNOY',
    'POPES',
    'UNDID',
    'FREER',
    'QUILL',
    'STINT',
    'COCKY',
    'LIVID',
    'KNACK',
    'ASSAM',
    'RECUR',
    'REPEL',
    'EMBED',
    'SOUPS',
    'KHAKI',
    'SYKES',
    'TWEED',
    'WRYLY',
    'DANDY',
    'ODORS',
    'ALGAL',
    'SULLY',
    'AMMON',
    'EATER',
    'SUMMA',
    'GULLY',
    'TENET',
    'FELLA',
    'POLIO',
    'STASH',
    'MALLS',
    'DEEMS',
    'LEBEN',
    'ENSUE',
    'TUFTS',
    'GAUSS',
    'MASSA',
    'SORES',
    'NOOSE',
    'MASTS',
    'BANAL',
    'QUELL',
    'SEVER',
    'NELLY',
    'OUTTA',
    'THETA',
    'LILAC',
    'ROPER',
    'DOZED',
    'SUSHI',
    'TAINT',
    'MAGMA',
    'SWAPS',
    'GILLS',
    'POSSE',
    'STIRS',
    'MASSE',
    'AURAL',
    'REVEL',
    'HOOFS',
    'JUROR',
    'MANNA',
    'SWANS',
    'SCALA',
    'TORTS',
    'RADII',
    'GULLS',
    'SLAMS',
    'CARER',
    'REEVE',
    'PLATT',
    'MODEM',
    'SWOOP',
    'HARAM',
    'ERODE',
    'BAGGY',
    'KAPPA',
    'WADED',
    'CARTA',
    'SISSY',
    'AGAPE',
    'MERLE',
    'RETRO',
    'KNOLL',
    'STUDS',
    'BUFFY',
    'LEECH',
    'TRUER',
    'HILLY',
    'KEYED',
    'BEETS',
    'JETTY',
    'EAVES',
    'TOTEM',
    'GRIFF',
    'BABES',
    'TRUSS',
    'SILKS',
    'SOFAS',
    'POTTS',
    'TAROT',
    'MAYAN',
    'RORTY',
    'TAUNT',
    'WASPS',
    'ANIMA',
    'ROARS',
    'FREES',
    'AFOOT',
    'NULLA',
    'GENIE',
    'DRIER',
    'BOOBS',
    'CRICK',
    'CEDED',
    'SLAPS',
    'HIGHS',
    'ADAGE',
    'TITHE',
    'AGGIE',
    'CACAO',
    'STRUT',
    'ELEGY',
    'HOOPS',
    'ERRED',
    'BRITT',
    'DEUCE',
    'RARER',
    'HASTA',
    'LYSIS',
    'SAKES',
    'PESOS',
    'PANDA',
    'INDIE',
    'CHAFF',
    'PASTS',
    'CAUSA',
    'MANGA',
    'WISPS',
    'FORGO',
    'SWISH',
    'SOGGY',
    'DERRY',
    'TARRY',
    'SNOWS',
    'CELLO',
    'FUSES',
    'LARVA',
    'MEMOS',
    'COMBO',
    'TERSE',
    'TANTO',
    'MAMMY',
    'GUSTS',
    'COOLS',
    'TILTS',
    'CASAS',
    'SLOOP',
    'BOSSY',
    'ARIAS',
    'LEPER',
    'SERRA',
    'SERFS',
    'SPREE',
    'NINJA',
    'GLIAL',
    'DOMED',
    'SILOS',
    'PIXIE',
    'SKUNK',
    'DOLOR',
    'BOOMS',
    'VESTS',
    'MOSSY',
    'SABHA',
    'TRIER',
    'TABBY',
    'COLIC',
    'ELUDE',
    'FUSSY',
    'EASEL',
    'FLUFF',
    'USURY',
    'AWASH',
    'RIGGS',
    'BIDDY',
    'SALLE',
    'OOZED',
    'ABATE',
    'KAYAK',
    'SEWED',
    'TOLLS',
    'SPECS',
    'HALAL',
    'GOOFY',
    'SPITS',
    'DROOP',
    'AGORA',
    'ROOST',
    'LADLE',
    'LUSTS',
    'HOODS',
    'TUTTI',
    'ARDOR',
    'WHOOP',
    'GOODY',
    'SNELL',
    'PUREE',
    'PURER',
    'SWOON',
    'DONNY',
    'HUMPH',
    'DITTO',
    'BRIAR',
    'HIPPO',
    'CERES',
    'PARMA',
    'CHICO',
    'LASSO',
    'LATTE',
    'BONNY',
    'BUTTE',
    'BARRE',
    'SOAPS',
    'CODON',
    'KIOSK',
    'SLYLY',
    'MISES',
    'RENIN',
    'JADED',
    'PEPSI',
    'VULVA',
    'COOED',
    'MUMPS',
    'HOSES',
    'SKIFF',
    'ADDER',
    'EARED',
    'BUSTS',
    'DERES',
    'MORON',
    'HOUGH',
    'SLUGS',
    'FRYER',
    'YAHOO',
    'ALLAY',
    'EASES',
    'LABIA',
    'SASSY',
    'DUPED',
    'REELS',
    'DRUID',
    'LAVAL',
    'BIGGS',
    'TWEEN',
    'AMAZE',
    'FLOSS',
    'HULLS',
    'SAUNA',
    'SWIMS',
    'MILLE',
    'TARTS',
    'CREWE',
    'CRORE',
    'TUSKS',
    'NUTTY',
    'PLAYA',
    'KINKY',
    'SOLON',
    'GURUS',
    'LIBRI',
    'TINTS',
    'DIXIT',
    'CASKS',
    'DILDO',
    'SLEET',
    'MELEE',
    'TOPOS',
    'DROOL',
    'SPEER',
    'LEGGE',
    'PEELS',
    'TWILL',
    'HELLS',
    'DULLY',
    'COTTA',
    'AMMAN',
    'ATRIA',
    'SEERS',
    'YUMMY',
    'LEEKS',
    'REIKI',
    'TAPAS',
    'CILIA',
    'SLATS',
    'RISER',
    'PAYEE',
    'CADDY',
    'PUTTY',
    'SEEDY',
    'CANNY',
    'HECHT',
    'ULAMA',
    'MEMES',
    'LEVEE',
    'DUDES',
    'JAFFA',
    'MATTE',
    'MAMIE',
    'NOMOS',
    'VAGAL',
    'RAJAH',
    'FLEES',
    'CRASS',
    'ARRAS',
    'SWEDE',
    'ORTHO',
    'SHINS',
    'EBBED',
    'MONDO',
    'NANCE',
    'BOOBY',
    'TONNE',
    'SPOOK',
    'TIARA',
    'FOSSE',
    'POTTY',
    'HALLO',
    'HULLO',
    'MYRRH',
    'CYNIC',
    'METED',
    'SPOOL',
    'GIMME',
    'RATER',
    'FUGUE',
    'LIEGE',
    'ALAMO',
    'DROLL',
    'BOSON',
    'AREAL',
    'SLUSH',
    'HUTCH',
    'SKIPS',
    'GOONS',
    'LAPEL',
    'PASSE',
    'SCOFF',
    'CORSO',
    'PEASE',
    'AGAVE',
    'WEEPS',
    'PIGGY',
    'CLACK',
    'GULAG',
    'STEEN',
    'TATAR',
    'BANDA',
    'RACER',
    'LAZAR',
    'BONNE',
    'DYADS',
    'SAMBA',
    'USURP',
    'POLYP',
    'CROCK',
    'AFFIX',
    'TRITE',
    'SOOTY',
    'SCOOT',
    'HEARE',
    'RISUS',
    'BEGET',
    'HUSKS',
    'KINKS',
    'DOTTY',
    'STELE',
    'RUNNY',
    'APACE',
    'CANNA',
    'XEROX',
    'SUEDE',
    'SAKAI',
    'STABS',
    'JEUNE',
    'STEWS',
    'ZAMAN',
    'NOOKS',
    'GOOEY',
    'IMAMS',
    'GARDA',
    'ANNAS',
    'RUPEE',
    'TELLY',
    'SAGAS',
    'SCAMS',
    'ENEMA',
    'STOTT',
    'CONCH',
    'SOOTH',
    'ATOLL',
    'KIDDO',
    'BUBBA',
    'BEVEL',
    'DODGY',
    'DUOMO',
    'FLAIL',
    'DINNA',
    'AURAS',
    'EJECT',
    'BERET',
    'SWABS',
    'CHACO',
    'RATTY',
    'PERES',
    'KNELL',
    'COMMS',
    'SHUSH',
    'AMASS',
    'UNCUT',
    'DAYAN',
    'BARBS',
    'SOLOS',
    'IDYLL',
    'ELVEN',
    'ENNUI',
    'SIKES',
    'APPEL',
    'PARKA',
    'TAFFY',
    'SEEPS',
    'WHOSO',
    'TASSO',
    'DOGGY',
    'KONDO',
    'TITER',
    'MEUSE',
    'SILLS',
    'LISLE',
    'SODAS',
    'LLAMA',
    'INANE',
    'FEDEX',
    'BEEFY',
    'CISSY',
    'AGATE',
    'FILLE',
    'SNOOP',
    'SURER',
    'SLURS',
    'TRYST',
    'VILLI',
    'SHAMS',
    'CABAL',
    'LOTTA',
    'BLOBS',
    'TETRA',
    'LOESS',
    'PERSE',
    'ROOMY',
    'GRAFF',
    'BASSO',
    'STUBS',
    'BUSBY',
    'SMUTS',
    'PYGMY',
    'FEARE',
    'HUMUS',
    'DOSED',
    'SOARS',
    'OUTDO',
    'EMMET',
    'NYSSA',
    'AEDES',
    'NIHIL',
    'SPARS',
    'LOTTE',
    'CLEVE',
    'OVOID',
    'COYLY',
    'REEDY',
    'ROOKS',
    'WOOED',
    'MEZZO',
    'XENON',
    'CREPE',
    'WEEDY',
    'BEEPS',
    'UPPED',
    'JESTS',
    'GOUGE',
    'SEFER',
    'PEEKS',
    'GILLY',
    'JEEPS',
    'HAMZA',
    'TRILL',
    'DEBYE',
    'NAPPY',
    'LIANA',
    'PRANA',
    'CALLA',
    'DOTED',
    'PAPPY',
    'TEENY',
    'FATWA',
    'NATTY',
    'CACTI',
    'WOOZY',
    'PIMPS',
    'FUROR',
    'TROTH',
    'BARRA',
    'DEERE',
    'FASTS',
    'DROSS',
    'BORER',
    'DEEPS',
    'SWAYS',
    'BATTY',
    'RISHI',
    'BETEL',
    'TESTA',
    'ANNUL',
    'SCABS',
    'CHOCK',
    'HUBBY',
    'CONIC',
    'DONEE',
    'OXBOW',
    'LEMME',
    'FILLY',
    'TINNY',
    'GUMMY',
    'ATMAN',
    'MOTTE',
    'DILLY',
    'SUNNA',
    'RABAT',
    'ILEAL',
    'TOOTS',
    'GEEKS',
    'SEXED',
    'BELIE',
    'PADMA',
    'YUCCA',
    'NINES',
    'CRESS',
    'TWIXT',
    'LAMAS',
    'KRILL',
    'EXUDE',
    'SEDGE',
    'WALLA',
    'NANNA',
    'OFFAL',
    'GUNNY',
    'LOLLY',
    'GUPPY',
    'CUSPS',
    'DJINN',
    'LEGER',
    'CRIER',
    'WIKIS',
    'ALOHA',
    'OASES',
    'FIZZY',
    'SCREE',
    'ILIUM',
    'PSOAS',
    'CREEL',
    'CINCH',
    'NAWAB',
    'HIPPY',
    'SETAE',
    'REBAR',
    'SLEDS',
    'TOPOI',
    'GOLLY',
    'LOSSY',
    'RERUN',
    'ALLYL',
    'TERES',
    'BEARE',
    'HENNA',
    'KNEED',
    'VERVE',
    'LEERY',
    'NONCE',
    'OCTET',
    'JEERS',
    'GAYLY',
    'EPHAH',
    'BLURB',
    'GEYER',
    'ZAKAT',
    'ALANG',
    'OZZIE',
    'JEMMY',
    'TESTY',
    'BAMBI',
    'GUAVA',
    'ZOOMS',
    'SNAGS',
    'KELLS',
    'SENNA',
    'DROID',
    'REARS',
    'UMMAH',
    'ALWAY',
    'BOGGY',
    'PARRA',
    'VARNA',
    'DITTY',
    'PREEN',
    'MOLTO',
    'BREVE',
    'CECUM',
    'MIMEO',
    'DOWDY',
    'PITTA',
    'NOMEN',
    'CARAT',
    'DUSTS',
    'JAZZY',
    'AMICI',
    'KALAM',
    'TULLE',
    'HOOTS',
    'POPPA',
    'LAMIA',
    'SEGUE',
    'CAUDA',
    'PINNA',
    'NEVES',
    'WEEMS',
    'CLEEK',
    'SUKUK',
    'ICILY',
    'MUGGY',
    'SHITS',
    'HUSSY',
    'DALLY',
    'ENDER',
    'BRIER',
    'PEEPS',
    'AUGUR',
    'BUFFS',
    'ASURA',
    'ZULUS',
    'VIVES',
    'KRAAL',
    'FRERE',
    'USQUE',
    'FELLS',
    'SELLA',
    'SPOOF',
    'DEVEL',
    'GEEST',
    'SEDER',
    'DOLED',
    'DIENE',
    'VEERS',
    'RONIN',
    'CUBBY',
    'EVERT',
    'PERCE',
    'KEBAB',
    'BENET',
    'TELEX',
    'ETUDE',
    'JIFFY',
    'SKIDS',
    'MITTS',
    'SIGIL',
    'TODDY',
    'EXOME',
    'WEISE',
    'LICIT',
    'SHEWS',
    'NISEI',
    'REBBE',
    'SARIS',
    'CHICA',
    'SOAKS',
    'BARCA',
    'LOONY',
    'STAGS',
    'UMAMI',
    'MURRY',
    'DEBBY',
    'MENSE',
    'TIPPY',
    'ALVAR',
    'TUBBY',
    'MANAS',
    'WARRE',
    'BARRO',
    'UDDER',
    'BALLY',
    'ELOPE',
    'ALLOT',
    'LOGON',
    'TARAS',
    'CUPPA',
    'MIMED',
    'SABRA',
    'TALAR',
    'SAPPY',
    'SIXES',
    'DAMME',
    'CUDDY',
    'SMITS',
    'PROMO',
    'EGGER',
    'PAEAN',
    'TATTY',
    'JEBEL',
    'IDLED',
    'REEKS',
    'ALDOL',
    'NOOIT',
    'GOSSE',
    'MASSY',
    'FINIS',
    'BIMBO',
    'BITTY',
    'BROMO',
    'MALAR',
    'GREVE',
    'SAFES',
    'APGAR',
    'SKEET',
    'FIEFS',
    'HEWED',
    'BULLA',
    'MANTA',
    'GENII',
    'VARIA',
    'KIPPS',
    'SCULL',
    'SOKOL',
    'IGLOO',
    'WHIZZ',
    'BLATT',
    'VODOU',
    'BAZAR',
    'EGGED',
    'POOJA',
    'FOOTY',
    'HUFFS',
    'BONGO',
    'DRYAD',
    'LYSSA',
    'SISAL',
    'LOTTO',
    'NITTY',
    'TAIGA',
    'SITUS',
    'RUSSE',
    'SPOOR',
    'SUTTA',
    'HIGHT',
    'SNOBS',
    'MAMBO',
    'PORNO',
    'BOONS',
    'CLUCK',
    'MAMAS',
    'TROTS',
    'RIFFS',
    'BANNS',
    'BURRO',
    'TRESS',
    'RONDO',
    'LOOPY',
    'LAVAS',
    'ASANA',
    'OCCAM',
    'WHIRR',
    'KOALA',
    'IMINE',
    'LETHE',
    'BORGO',
    'DURUM',
    'HENNY',
    'SARAN',
    'EYRIE',
    'DALLE',
    'BOOED',
    'CATTY',
    'POGGE',
    'MISSA',
    'VERRA',
    'DACHA',
    'FRILL',
    'SHERE',
    'CELLA',
    'RAJAS',
    'HOOCH',
    'PROSS',
    'OOZES',
    'VEENA',
    'GUTTA',
    'SLAYS',
    'OUTRO',
    'WICCA',
    'SKITS',
    'TEPEE',
    'GONGS',
    'CODEC',
    'MORRO',
    'TEATS',
    'NAGAS',
    'TRIST',
    'BILBO',
    'BASSE',
    'GEEKY',
    'ALBEE',
    'SATIS',
    'ARENE',
    'GESTE',
    'BURRS',
    'NONES',
    'PENNE',
    'GALEA',
    'COCOS',
    'WEEPY',
    'STURT',
    'HANSA',
    'AERIE',
    'COCCI',
    'BEBOP',
    'DOONA',
    'VROOM',
    'ZORRO',
    'ELIDE',
    'PENNA',
    'PETRE',
    'MAKAR',
    'TITRE',
    'COONS',
    'SMOOT',
    'TOUTS',
    'NOBBY',
    'MOTET',
    'ATTAR',
    'PRIMI',
    'GALLS',
    'WELKE',
    'PULPS',
    'LEGES',
    'SLAGS',
    'BALOO',
    'PUPAE',
    'SIRES',
    'LEESE',
    'SCUFF',
    'MARRA',
    'SWILL',
    'ABUZZ',
    'SLUTS',
    'ASSEZ',
    'CHACE',
    'MAGGS',
    'BODED',
    'SKENE',
    'MIMES',
    'FILII',
    'NABOB',
    'BASTA',
    'ALLIS',
    'RIPER',
    'PURRS',
    'SHUNS',
    'COOPS',
    'BOCCA',
    'ALAND',
    'SNOOK',
    'POOCH',
    'GAGES',
    'PAPAS',
    'EGRET',
    'DAFFY',
    'FETED',
    'SERRE',
    'LULLS',
    'ALLEE',
    'GONZO',
    'BITTE',
    'TENON',
    'BOOZY',
    'LEGGY',
    'ALACK',
    'TSARS',
    'BUZZY',
    'PULPY',
    'RASTA',
    'PAMPA',
    'UVULA',
    'SALAT',
    'MESAS',
    'SPATS',
    'DREAR',
    'HATHA',
    'BASSI',
    'FACTA',
    'LOONS',
    'RUMMY',
    'GLEBE',
    'SLOSH',
    'MULLA',
    'HAZAN',
    'LLANO',
    'RICIN',
    'TEREK',
    'ODEON',
    'SEELY',
    'FARRO',
    'KAROO',
    'RUDER',
    'CHANA',
    'MARAE',
    'SINES',
    'PRESE',
    'KEELS',
    'EVENS',
    'NINNY',
    'MONGO',
    'AIOLI',
    'LOBOS',
    'OOMPH',
    'SOLAS',
    'EMCEE',
    'TATER',
    'ROWER',
    'CYCLO',
    'HOPPY',
    'LOGOI',
    'MINIM',
    'TANNA',
    'ALIYA',
    'ODDER',
    'STILT',
    'SUNUP',
    'BIDED',
    'MARAH',
    'SCAPA',
    'SAREE',
    'FITTS',
    'PITOT',
    'AMIGA',
    'BARBE',
    'RETRY',
    'BRAVA',
    'AKITA',
    'NAIRA',
    'MAYAS',
    'PISSY',
    'GREBE',
    'RECCE',
    'PACHA',
    'EXECS',
    'EMMER',
    'SURES',
    'GOOLD',
    'MACAW',
    'HAJJI',
    'HOOKY',
    'STUMM',
    'CASUS',
    'SLOPS',
    'TIZZY',
    'TABLA',
    'GAMBA',
    'SHAYS',
    'EIDER',
    'VANDA',
    'SWATS',
    'AURUM',
    'TILLS',
    'GRANA',
    'DAMAN',
    'PAVAN',
    'RILLS',
    'PLOPS',
    'KIWIS',
    'ETATS',
    'ARSES',
    'COMPO',
    'MIGGS',
    'ZIPPO',
    'DELES',
    'SAGGY',
    'SKIMS',
    'CROON',
    'PEPPY',
    'MAMBA',
    'CABBY',
    'WOOLY',
    'PONGO',
    'RUSES',
    'SKINK',
    'SOLUS',
    'TORTE',
    'SWASH',
    'SNEED',
    'CROCS',
    'ZAZEN',
    'AKELA',
    'CRYER',
    'SPUDS',
    'CULLY',
    'BINDI',
    'BYWAY',
    'BLEEP',
    'TOLLY',
    'GAFFE',
    'MEWED',
    'SKULK',
    'DOODY',
    'GANJA',
    'SNIPS',
    'TAIRA',
    'THANA',
    'BALSA',
    'KUDZU',
    'DOOMS',
    'BEERY',
    'LANAI',
    'GENNY',
    'KASHA',
    'SANGA',
    'NUMEN',
    'RUBUS',
    'CREME',
    'WEDEL',
    'UHURU',
    'TREED',
    'CECAL',
    'BIFID',
    'MILIA',
    'STOPT',
    'GIGAS',
    'SKEWS',
    'HUFFY',
    'HEEDS',
    'DELLS',
    'CUTTY',
    'NODDY',
    'TEEMS',
    'CREES',
    'TIKKA',
    'KROON',
    'MIRIN',
    'ADOBO',
    'PEREA',
    'GISTS',
    'COBBS',
    'RATAN',
    'KLETT',
    'BREDE',
    'ANIMI',
    'MERDE',
    'MEANE',
    'TOTES',
    'SAMAN',
    'SILTS',
    'LOCOS',
    'DOORN',
    'RASPS',
    'FLYBY',
    'FIFER',
    'CRURA',
    'OLOGY',
    'CHAYA',
    'ACINI',
    'BWANA',
    'ARETE',
    'PALLA',
    'ISSEI',
    'WAGGA',
    'KEECH',
    'NAIAD',
    'PUPAL',
    'NULLS',
    'RANGA',
    'MATZA',
    'NEWEL',
    'HERES',
    'ARGAN',
    'STETS',
    'TANKA',
    'DULLS',
    'EWERS',
    'ZIPPY',
    'NOHOW',
    'BENES',
    'MINIS',
    'ELUTE',
    'REDES',
    'SOURS',
    'SERES',
    'CASCO',
    'IMIDE',
    'MESES',
    'SOPPY',
    'GALAS',
    'ABAFT',
    'NAVVY',
    'CHARA',
    'GRAAL',
    'HEIGH',
    'KULAK',
    'NANOS',
    'YUCKY',
    'WOWED',
    'MINNY',
    'HIRER',
    'LOOKY',
    'KISSY',
    'ARROZ',
    'BAALS',
    'TANGA',
    'TATES',
    'JNANA',
    'SULKS',
    'PACTA',
    'INNIT',
    'ESSES',
    'DEARE',
    'HOLON',
    'NEDDY',
    'SELFS',
    'REARM',
    'VIVAS',
    'BETTA',
    'PANAX',
    'ARECA',
    'SABES',
    'SHAMA',
    'INGAN',
    'KARAT',
    'SATAY',
    'SETTS',
    'MORRA',
    'AQUAE',
    'SEMIS',
    'SASSE',
    'METES',
    'BENNE',
    'TOTED',
    'BALAS',
    'JELLO',
    'AARTI',
    'RATHA',
    'TORII',
    'TRANT',
    'CHOCO',
    'HOLLA',
    'HENCH',
    'NIXIE',
    'HAUGH',
    'EMEND',
    'RAPER',
    'SHIES',
    'BEVER',
    'KREWE',
    'RORIE',
    'HYTHE',
    'WOOLS',
    'DOOZY',
    'VEALE',
    'PRISS',
    'TITTY',
    'LEERS',
    'CHOOK',
    'MUTTS',
    'RUSTS',
    'SKANK',
    'MALAM',
    'SELLE',
    'SCUSE',
    'TALAQ',
    'HISSY',
    'KANGA',
    'NINER',
    'KOOKY',
    'BEZEL',
    'DEMES',
    'SIPPY',
    'AMEER',
    'SECHS',
    'ALMAS',
    'FETES',
    'HALFA',
    'JOCKO',
    'CUSUM',
    'AWAYS',
    'STELL',
    'RUFFS',
    'MOOCH',
    'BANYA',
    'HONAN',
    'TOROS',
    'JEFFS',
    'TOTTY',
    'ZILLA',
    'VEXES',
    'ANENT',
    'ABASE',
    'STOAT',
    'LIEVE',
    'STUNS',
    'DIDDY',
    'NIPPY',
    'MERES',
    'ROOSE',
    'TESTE',
    'JINNI',
    'CEDES',
    'PUTTS',
    'LASSI',
    'MARAS',
    'INFIX',
    'HENGE',
    'CHERE',
    'WAHOO',
    'GRRRL',
    'ABELE',
    'WOOER',
    'OLLER',
    'GESSO',
    'ANTAR',
    'ACARI',
    'VARAS',
    'HAPAX',
    'WUSHU',
    'AGGER',
    'GRAMA',
    'AGAMA',
    'SWIGS',
    'MOONY',
    'LAIKA',
    'TUNNY',
    'HYGGE',
    'QUAFF',
    'ABEAM',
    'DADOS',
    'STEDE',
    'OBOES',
    'ORRIS',
    'BASAN',
    'CAMAS',
    'SAULS',
    'PERPS',
    'TALMA',
    'SPEWS',
    'NEBEL',
    'DUDDY',
    'VOULU',
    'MUSTS',
    'STEEK',
    'MUFFS',
    'SISTA',
    'MALWA',
    'FINNY',
    'SURAS',
    'APPRO',
    'FRIZZ',
    'BRAAI',
    'LINNY',
    'SHISH',
    'SHIMS',
    'DIVVY',
    'TITCH',
    'GASSY',
    'KACHA',
    'KARAS',
    'ABAYA',
    'HEWER',
    'GAGER',
    'NIEVE',
    'BACCA',
    'RAITA',
    'COOCH',
    'SIFTS',
    'DESSE',
    'TELES',
    'PUTTI',
    'FUCUS',
    'SATES',
    'SAINS',
    'PINUP',
    'SESSA',
    'SHAWS',
    'TENNE',
    'MALAS',
    'GREGO',
    'AMAIN',
    'ANYON',
    'AROHA',
    'TORTA',
    'MOLLA',
    'TONDO',
    'SWAGS',
    'ALDEA',
    'BACHA',
    'SNUBS',
    'COOTS',
    'PAPAW',
    'REPRO',
    'PLEBE',
    'LOTOS',
    'SKOOL',
    'HOBOS',
    'NETTY',
    'BATTS',
    'VERRY',
    'PREPS',
    'FARAD',
    'CONTO',
    'ARHAT',
    'WINNA',
    'NISUS',
    'RIMER',
    'PEDES',
    'SPALL',
    'CELEB',
    'RAVER',
    'PAPPI',
    'PEEVE',
    'HUDUD',
    'SPEEL',
    'ARABA',
    'VIZIR',
    'PLAAS',
    'STULL',
    'BLEBS',
    'BESTS',
    'SENSI',
    'ZOOEY',
    'HEVEA',
    'PIPIT',
    'TALAS',
    'MOMUS',
    'DENES',
    'COLLS',
    'ANNAL',
    'MIDIS',
    'KAPOK',
    'LAGAN',
    'HOLLO',
    'PHISH',
    'FLAVA',
    'SODDY',
    'ALANS',
    'SUDSY',
    'ASSAI',
    'TANTI',
    'FLEER',
    'JAMMY',
    'MUZZY',
    'TUFFS',
    'REEDE',
    'KIDDY',
    'LIPPY',
    'NAHAL',
    'PIPET',
    'OOHED',
    'MARKA',
    'POLOS',
    'IMINO',
    'SHILL',
    'KENTE',
    'GERNE',
    'BARBY',
    'DIPPY',
    'JOMON',
    'FRIER',
    'ELATE',
    'BUFFA',
    'DEBES',
    'DERED',
    'TARGA',
    'RHEME',
    'TRULL',
    'RAGAS',
    'NONNY',
    'ARRAH',
    'SANSA',
    'REGES',
    'BOMBE',
    'NAPPE',
    'WADDY',
    'MEDII',
    'FIFES',
    'ARIKI',
    'CHUFF',
    'POORT',
    'CIRRI',
    'YESES',
    'GADDI',
    'RENNE',
    'HUZZA',
    'DOBBY',
    'POMPS',
    'KLOOF',
    'HAMMY',
    'BILBY',
    'GOOKS',
    'NINON',
    'MENES',
    'CHOON',
    'HOMOS',
    'KALPA',
    'OTTAR',
    'TIPIS',
    'PANNE',
    'BOTTS',
    'COOKY',
    'STEPT',
    'BIBBS',
    'DELLY',
    'BOORS',
    'EMOTE',
    'CHEEP',
    'WESTS',
    'BURRY',
    'AVAST',
    'FLAMM',
    'BUBBE',
    'POOKA',
    'REGIE',
    'DUNNY',
    'RAKER',
    'IZZAT',
    'SENTE',
    'CHOLO',
    'VENAE',
    'FARER',
    'BRISS',
    'TAPPA',
    'JINNS',
    'JANNY',
    'GUSSY',
    'PALPS',
    'GOBBO',
    'TUFTY',
    'CELLI',
    'WEENY',
    'KURUS',
    'REDID',
    'PALLY',
    'PATTE',
    'ADDLE',
    'ORDOS',
    'EEJIT',
    'CORNO',
    'LYSOL',
    'WHEEN',
    'FOOTS',
    'LAVRA',
    'BOLLS',
    'ARMER',
    'SECCO',
    'CULLS',
    'PINNY',
    'TILTH',
    'EALES',
    'PINON',
    'VELES',
    'SHAHS',
    'OFFED',
    'HOODY',
    'ETHNE',
    'SENTS',
    'GALLY',
    'TUTUS',
    'HEXES',
    'RANEE',
    'EMMYS',
    'MARRI',
    'SIRIS',
    'ACHAR',
    'WHISH',
    'EDGER',
    'SCADS',
    'PAISA',
    'COLLY',
    'PETTO',
    'UNSEE',
    'BASKS',
    'KEDGE',
    'CRAIC',
    'TATOU',
    'TOFFS',
    'MALVA',
    'RAMEE',
    'MATAI',
    'TENNY',
    'BUTTY',
    'SEDES',
    'GAITA',
    'ADDIO',
    'WELLY',
    'BEDAD',
    'REVIE',
    'BECKE',
    'APSES',
    'MITIS',
    'RASSE',
    'LEGGO',
    'PANGA',
    'BURBS',
    'TASSE',
    'PREOP',
    'SCATS',
    'BARER',
    'POOPS',
    'RENTE',
    'ILLER',
    'BACCY',
    'FUSEE',
    'RESUS',
    'QUIFF',
    'SOUKS',
    'SAIGA',
    'SHOTT',
    'FELLY',
    'PEECE',
    'AGGRO',
    'SOUSE',
    'GEODE',
    'ZAIDA',
    'SLOBS',
    'KARRI',
    'MONOS',
    'CESSE',
    'SANTS',
    'KVASS',
    'DREES',
    'MYOMA',
    'BOCCE',
    'MOSSO',
    'FUDDY',
    'APPAL',
    'PUKKA',
    'SONES',
    'PRIER',
    'HAKAM',
    'GHYLL',
    'GAMMY',
    'HOLOS',
    'SHISO',
    'WEEKE',
    'KAZOO',
    'EPODE',
    'PENED',
    'MULLS',
    'FIERE',
    'RUSKS',
    'ARRIS',
    'ROKER',
    'APPUI',
    'SHOON',
    'MOLAL',
    'GAMAY',
    'GABBA',
    'TENUE',
    'GOBBI',
    'HYPHA',
    'KAIKA',
    'SYNCS',
    'CYCAD',
    'TOMOS',
    'UNCUS',
    'LADDY',
    'THEES',
    'WEBBY',
    'MIDDY',
    'BABAS',
    'LOLLS',
    'LAHAR',
    'RIATA',
    'SHOOS',
    'DOBRO',
    'GOOBY',
    'DROOG',
    'BOTTE',
    'SKRIK',
    'SLOOT',
    'ZEBUB',
    'GLEDE',
    'TWEEL',
    'GOMBO',
    'ASCUS',
    'MYALL',
    'LIKIN',
    'COCCO',
    'MEERS',
    'COOPT',
    'KADAI',
    'PALEA',
    'SCOWS',
    'TERCE',
    'SEMES',
    'LAKSA',
    'COMMO',
    'COPPY',
    'VACUA',
    'NUBBY',
    'VIVAT',
    'UNPIN',
    'THILL',
    'ROOSA',
    'YAPPY',
    'MIMSY',
    'REAME',
    'CAECA',
    'NISSE',
    'SLILY',
    'BABOO',
    'SURFS',
    'SKEEN',
    'KLICK',
    'SILES',
    'DEETS',
    'PALLS',
    'MESNE',
    'QANAT',
    'KININ',
    'BENNI',
    'NOMOI',
    'IVIED',
    'BOLOS',
    'BOZOS',
    'GESTS',
    'SLIMS',
    'POOPY',
    'SCALL',
    'SAROS',
    'PETTI',
    'SUMPS',
    'GAPPY',
    'AAHED',
    'GUMMI',
    'UNMAN',
    'DWEEB',
    'BACCO',
    'FIRER',
    'AMIAS',
    'SCUDS',
    'PHONO',
    'BAJRA',
    'PALAS',
    'CONVO',
    'MURRA',
    'VARAN',
    'GLOOP',
    'BUBBY',
    'RARES',
    'MOGGY',
    'NEESE',
    'SIREE',
    'FIXIT',
    'FESTS',
    'SENSA',
    'HERRY',
    'ESKER',
    'HURRA',
    'SHAGS',
    'SIPES',
    'OUTGO',
    'EYRES',
    'SHAYA',
    'IDEES',
    'RAGER',
    'SKUAS',
    'TIFFS',
    'FIGGY',
    'SNOOD',
    'HEXED',
    'CORER',
    'HALVA',
    'ABACA',
    'CISTS',
    'TUTEE',
    'CYCAS',
    'BANIA',
    'SORER',
    'PSYOP',
    'BATTA',
    'KOROS',
    'BOOSE',
    'BITTS',
    'DUBBO',
    'EQUES',
    'KAHAL',
    'SERED',
    'MOONG',
    'KUKRI',
    'ALULA',
    'MEZZE',
    'RETIE',
    'DEERS',
    'SABAL',
    'BAJAN',
    'MAHUA',
    'NOGGS',
    'HALWA',
    'GLEES',
    'LORAL',
    'KIBBE',
    'VENGE',
    'HAMAL',
    'PELLS',
    'DEELY',
    'CERNE',
    'HOOEY',
    'AMENE',
    'CENSE',
    'CEDER',
    'HEFTE',
    'FENNY',
    'COOLY',
    'ANNAT',
    'BABKA',
    'SORDO',
    'THEBE',
    'PEERY',
    'IMARI',
    'LOOTS',
    'HERSE',
    'LUSUS',
    'RUTTY',
    'RAPPE',
    'KOOKS',
    'GOOPY',
    'SNOOT',
    'NOOBS',
    'JEFES',
    'HEDER',
    'KATTI',
    'TOPPY',
    'MERED',
    'GINGE',
    'RAWER',
    'GRECE',
    'DOSAS',
    'OBOLS',
    'PUTTO',
    'ANURA',
    'STIES',
    'IVIES',
    'TAWAS',
    'ADMAN',
    'MEKKA',
    'HOTCH',
    'TINCT',
    'BREES',
    'LOOBY',
    'ACKEE',
    'MOOED',
    'AWEEL',
    'SIMAS',
    'FRASS',
    'DHABA',
    'BABUS',
    'CIVVY',
    'QUIPU',
    'AQUAS',
    'ABBES',
    'GAFFS',
    'SLOES',
    'PRIMP',
    'LUFFA',
    'TWITS',
    'NOONS',
    'AARGH',
    'SANES',
    'AMEBA',
    'DOGGO',
    'BERES',
    'ALANE',
    'ACHOO',
    'ASPIS',
    'MOOTS',
    'SAYST',
    'TOFTS',
    'NYALA',
    'JHALA',
    'BEEFS',
    'SCOPS',
    'TASSA',
    'DAWAH',
    'MATTS',
    'KOORI',
    'SLUFF',
    'TOLYL',
    'HUGGY',
    'DAMAR',
    'LENSE',
    'VIVER',
    'BOCCI',
    'BEEDI',
    'TENNO',
    'LIGGE',
    'DEENS',
    'ANGAS',
    'MURRE',
    'NAPPA',
    'LABRA',
    'PRYER',
    'DODOS',
    'HEMES',
    'MANAT',
    'MEASE',
    'WOOSH',
    'BUFFO',
    'KIRKS',
    'ROTTE',
    'DOOLY',
    'HEUGH',
    'HINNY',
    'DILLI',
    'MOLLS',
    'DIBBS',
    'PENNI',
    'COFFS',
    'CUTCH',
    'SYNES',
    'STOWS',
    'CHARR',
    'CERIC',
    'INION',
    'ZUPPA',
    'GAGED',
    'COBBY',
    'GUMMA',
    'MURRI',
    'PALPI',
    'STOSS',
    'PAPES',
    'EXINE',
    'SHOJO',
    'AMATE',
    'SANGS',
    'SISTS',
    'POOFY',
    'PARER',
    'PEWEE',
    'NANDU',
    'ADHAN',
    'PEKOE',
    'DISCI',
    'BATTU',
    'ANATA',
    'SALAL',
    'ORLOP',
    'CRUOR',
    'VISES',
    'KEENS',
    'BIKIE',
    'FERES',
    'RAZER',
    'ABACI',
    'MASAS',
    'HAITH',
    'RICER',
    'TREEN',
    'DAGGA',
    'LYSES',
    'GIGUE',
    'COTTS',
    'EXEAT',
    'TENGE',
    'SHANS',
    'WIGGY',
    'BROOS',
    'TIDED',
    'CAPAS',
    'BEDEL',
    'PIPPY',
    'EZINE',
    'SAKIS',
    'CROCI',
    'GURRY',
    'TWATS',
    'JAWAN',
    'PANNI',
    'BLINI',
    'GOGOS',
    'CIDED',
    'PROSO',
    'EDUCE',
    'ROODS',
    'KABOB',
    'JACAL',
    'PIPAL',
    'KOPEK',
    'KAWAS',
    'MUGGS',
    'LOREL',
    'DESIS',
    'LAMMY',
    'PIANI',
    'OSSIA',
    'TECTA',
    'MOOLA',
    'SORRA',
    'RONNE',
    'SKATT',
    'BLOOP',
    'WHATA',
    'COOEE',
    'MUMSY',
    'ROOTY',
    'RANAS',
    'DREER',
    'GALAX',
    'IROKO',
    'WEENS',
    'CURER',
    'KANAE',
    'PENES',
    'HELVE',
    'AYAHS',
    'NALLA',
    'DECAD',
    'GIGOT',
    'SOLDO',
    'GOBBY',
    'NABLA',
    'TOONS',
    'BOFFO',
    'CARRS',
    'ABASH',
    'RECCO',
    'BREER',
    'GOOFS',
    'KATAS',
    'MUSKS',
    'DIVIS',
    'WAKAS',
    'FOODY',
    'POOFS',
    'CERCI',
    'OUSTS',
    'SORBS',
    'ARTAL',
    'ABUNA',
    'SUCCI',
    'ABOON',
    'TIDDY',
    'REGAR',
    'LADED',
    'INTIL',
    'LINNS',
    'SAMAS',
    'TEMES',
    'PALAY',
    'GELLY',
    'SERER',
    'NEEPS',
    'FACIA',
    'REATE',
    'MUSSY',
    'ICIER',
    'TAZZA',
    'CHACK',
    'SEPTS',
    'WUSSY',
    'ELVER',
    'LISPS',
    'MUNTU',
    'SEWEL',
    'ARAME',
    'MAIMS',
    'PRILL',
    'RIBBY',
    'KOKUM',
    'RERAN',
    'TATUS',
    'TUATH',
    'TACAN',
    'APIAN',
    'TARTY',
    'HOOTY',
    'HADAL',
    'ORLON',
    'ELOGE',
    'WAZOO',
    'EGGAR',
    'SURRA',
    'REBEC',
    'LEVES',
    'BIVVY',
    'JEEZE',
    'DILLS',
    'CONNE',
    'MEREL',
    'TALPA',
    'AMBAN',
    'LAZZI',
    'ANCON',
    'EYERS',
    'VOLVA',
    'HALMA',
    'BABUL',
    'KOKER',
    'SUPES',
    'ARRET',
    'SCAFF',
    'QUOLL',
    'ZAMIA',
    'POODS',
    'KILIM',
    'NONET',
    'DOREE',
    'REMEN',
    'BOORD',
    'POOTS',
    'SPIFF',
    'DEWED',
    'GALAH',
    'GLEED',
    'TAMAL',
    'LATAH',
    'JIGGY',
    'LUMME',
    'RAMAL',
    'SIRRA',
    'HEBEN',
    'ACOCK',
    'BOMBO',
    'LEFTE',
    'SAWAH',
    'ANEAR',
    'INDRI',
    'AGOOD',
    'POMMY',
    'KANAS',
    'THORO',
    'DADAS',
    'DOLOS',
    'YEESH',
    'BIGGY',
    'TASAR',
    'SURDS',
    'PUDDY',
    'SELES',
    'DUPPY',
    'OLLAS',
    'TOITS',
    'KEEMA',
    'DURRA',
    'ALMAH',
    'WIDDY',
    'CUPPY',
    'SPICS',
    'TALEA',
    'LAVVY',
    'BOBOS',
    'COOMB',
    'ZOOID',
    'DEXIE',
    'SMOKO',
    'RASER',
    'HAPPI',
    'BUCHU',
    'KIBEI',
    'SKELL',
    'BUNDU',
    'WHOOF',
    'KABAR',
    'ZOPPO',
    'ANANA',
    'FADDY',
    'AJUGA',
    'REORG',
    'OBIIT',
    'ERVEN',
    'WEEST',
    'KAVAL',
    'NANAS',
    'NEVEL',
    'SHEEL',
    'MOJOS',
    'HILLO',
    'HELED',
    'FAVAS',
    'KHAYA',
    'PHENE',
    'HOGGS',
    'TOFFY',
    'ARVAL',
    'TATTS',
    'ETTIN',
    'JILLS',
    'STYES',
    'MIZZY',
    'REATA',
    'SARUS',
    'FILMI',
    'TURNT',
    'ENDUE',
    'IMIDO',
    'HASPS',
    'SPAZA',
    'SWEER',
    'AGARS',
    'AGITA',
    'RAGGY',
    'JOLLS',
    'KIKES',
    'MAMEY',
    'BIDIS',
    'RAYAS',
    'DEADS',
    'LULUS',
    'KAKAS',
    'SKEER',
    'TACET',
    'WIFIE',
    'FALAJ',
    'TUTTY',
    'SAMES',
    'BIFFY',
    'TENES',
    'FAENA',
    'SENES',
    'WENGE',
    'DABBA',
    'BOODY',
    'DIKED',
    'JALAP',
    'PELES',
    'HOOSH',
    'SIENS',
    'GUNGE',
    'VUGGY',
    'CHOCS',
    'SOMAS',
    'MOZOS',
    'VASAL',
    'SORBO',
    'TOPEE',
    'NEELE',
    'ALLEL',
    'FEYER',
    'ABAND',
    'NONYL',
    'TUQUE',
    'MEZES',
    'SALPS',
    'NAMMA',
    'SHADS',
    'ARVEE',
    'DODDY',
    'GARRE',
    'ORMER',
    'ALARY',
    'HOKKU',
    'KUDUS',
    'SEISM',
    'DAGGY',
    'STERE',
    'DARGA',
    'VILLS',
    'GEMMY',
    'HAOMA',
    'PULLY',
    'SEXTS',
    'MOTTS',
    'STOAS',
    'EXODE',
    'ADDAX',
    'ANTRA',
    'DOFFS',
    'PUFFA',
    'HAKEA',
    'AXMAN',
    'DUSKS',
    'BEDES',
    'WOOFS',
    'POPSY',
    'MOOLI',
    'VENIN',
    'DIRER',
    'ZIMBI',
    'PUGGY',
    'SPAMS',
    'BOBAK',
    'LAXLY',
    'HOOLY',
    'AVGAS',
    'AGRIA',
    'SOTOL',
    'SAXES',
    'WISES',
    'VEERY',
    'LYCEE',
    'TUART',
    'GLUGS',
    'NEELD',
    'STOOK',
    'ADAYS',
    'ANTAS',
    'PULLI',
    'HULLY',
    'TREST',
    'PREES',
    'REKEY',
    'MIFFY',
    'FULLS',
    'BETES',
    'SMAAK',
    'LOSEL',
    'IMPIS',
    'TACTS',
    'ABEAR',
    'KERNE',
    'JAGGS',
    'BEDEW',
    'THEEK',
    'EVITE',
    'SLOGS',
    'STIMS',
    'TWITE',
    'NAPAS',
    'ZOOKS',
    'EASTS',
    'BIZZY',
    'PATKA',
    'LOOED',
    'PODDY',
    'SAOLA',
    'POTTO',
    'ALATE',
    'ARSIS',
    'BEVVY',
    'NAVAR',
    'TEMED',
    'PISOS',
    'VEGIE',
    'COSEC',
    'MNEME',
    'SOPHS',
    'HAMBA',
    'RAREE',
    'LITAI',
    'CHICH',
    'RITTS',
    'MIMER',
    'SAPAN',
    'HIDED',
    'SLEWS',
    'TEXES',
    'RAKIA',
    'BADDY',
    'CUTUP',
    'GREES',
    'MERSE',
    'DOWDS',
    'AULAS',
    'SHASH',
    'TOYON',
    'BAISA',
    'WAACS',
    'KOLOS',
    'MOTTY',
    'BLABS',
    'BASSY',
    'LOOEY',
    'FICIN',
    'IAMBI',
    'RAGGA',
    'LIPIN',
    'TOOMS',
    'SARKS',
    'KREEP',
    'OVOLO',
    'REAVE',
    'REVET',
    'MELLS',
    'APSIS',
    'GOBOS',
    'SPIVS',
    'ORIBI',
    'USURE',
    'GESSE',
    'WOLLY',
    'MAARS',
    'CRUCK',
    'REXES',
    'NAAMS',
    'VITTA',
    'HEBES',
    'CIGGY',
    'FRITT',
    'SMUSH',
    'ZESTS',
    'PUNNY',
    'MODII',
    'ROTON',
    'ZANJA',
    'KATAL',
    'SADZA',
    'CHOKO',
    'EIGNE',
    'AREPA',
    'CAVAS',
    'DISAS',
    'KABAB',
    'TEAZE',
    'POOED',
    'RELLO',
    'TALAK',
    'AGHAS',
    'ROOKY',
    'VOLVE',
    'DOOCE',
    'TALLS',
    'RATAS',
    'OTTOS',
    'RILLE',
    'NAEVE',
    'PAKKA',
    'GAMME',
    'NEONS',
    'RUFFE',
    'STOOR',
    'OXEYE',
    'TERNE',
    'FUGGY',
    'GRIGS',
    'DWAAL',
    'IRING',
    'GRESE',
    'ENURE',
    'MACAS',
    'EFFED',
    'GERBE',
    'AGAMI',
    'LANAS',
    'LININ',
    'FLEEK',
    'FITTE',
    'BAKRA',
    'CHURR',
    'DEEDY',
    'YAKKA',
    'GAZAL',
    'PEARE',
    'SKYEY',
    'LILTS',
    'SAIDS',
    'AMMOS',
    'BUBAS',
    'FESSE',
    'EISEL',
    'TITIS',
    'ETAPE',
    'SWOTS',
    'KICKY',
    'KEEVE',
    'SNUGS',
    'FEEBS',
    'NYING',
    'CUBEB',
    'WILIS',
    'PARRS',
    'XEBEC',
    'EMMAS',
    'WEELS',
    'SMEES',
    'CHOTT',
    'RAYAH',
    'ALBAS',
    'DIFFS',
    'THEED',
    'DOOLE',
    'EAVED',
    'POORI',
    'SORUS',
    'DRAFF',
    'ISHES',
    'OFFIE',
    'SKEEF',
    'GERLE',
    'LEETS',
    'CONIN',
    'DUFFS',
    'MUSSE',
    'SMOGS',
    'SKEES',
    'VARVE',
    'GADGE',
    'LAREE',
    'PILIS',
    'VIGIA',
    'PACAS',
    'YOLKY',
    'MIASM',
    'TOTER',
    'CROOL',
    'YIPPY',
    'PREVE',
    'GUANA',
    'ELEMI',
    'RUBBY',
    'SHOOL',
    'AMAHS',
    'BREME',
    'LEEZE',
    'SOFTS',
    'SERRY',
    'NADAS',
    'NITON',
    'OSMOL',
    'DIDIE',
    'RORIC',
    'SIDAS',
    'KAMAS',
    'SEASE',
    'ROTOS',
    'TYTHE',
    'LOOFA',
    'YABBA',
    'NOOKY',
    'ANTAE',
    'YEVEN',
    'SCUMS',
    'SMARM',
    'REDDS',
    'PASKA',
    'MOOKS',
    'OPPOS',
    'SKEGG',
    'LIMMA',
    'FAGGY',
    'GROOF',
    'AGOGE',
    'IMIDS',
    'TAKAS',
    'SKEPS',
    'YABBY',
    'CHETH',
    'SINDS',
    'HEXER',
    'BOYOS',
    'TAFIA',
    'ZOONS',
    'TAGMA',
    'WIRRA',
    'MUCIC',
    'INWIT',
    'SCUZZ',
    'TANTY',
    'AFLAJ',
    'SEEPY',
    'PENIE',
    'SHIVS',
    'JAGGY',
    'SEISE',
    'SAKIA',
    'EASER',
    'CIPPI',
    'MAROR',
    'SNOTS',
    'REEFY',
    'RELIE',
    'SUIDS',
    'FETTA',
    'SOWLS',
    'DOJOS',
    'JUGUM',
    'WYNNS',
    'BUMBO',
    'BANAK',
    'DEKKO',
    'LOOFS',
    'WHOOT',
    'DUETT',
    'NEUME',
    'COOEY',
    'BHOOT',
    'RIPPS',
    'IPPON',
    'DARER',
    'IMAUM',
    'FANAL',
    'PERVE',
    'ENEWS',
    'AURAE',
    'SENAS',
    'RAGGS',
    'KIPPA',
    'MUSOS',
    'SWIZZ',
    'DURRY',
    'AFARS',
    'LUMMY',
    'WOOPS',
    'TETES',
    'MEARE',
    'ROARY',
    'STOBS',
    'TATIE',
    'BEZES',
    'CIRCS',
    'SICKS',
    'COGON',
    'RAMMY',
    'LEMES',
    'JUSTS',
    'RELET',
    'NALAS',
    'CHIRR',
    'DUKKA',
    'NONAS',
    'BOOKY',
    'SOPOR',
    'GEARE',
    'MEDLE',
    'SUDDS',
    'MEEDS',
    'ATTAP',
    'SERRS',
    'XYLOL',
    'FILLO',
    'ILIAL',
    'LASSY',
    'WOWEE',
    'AGILA',
    'SIMIS',
    'PROLL',
    'RIEVE',
    'SOBAS',
    'QUASS',
    'HOTTY',
    'ANELE',
    'CLEPE',
    'SLAWS',
    'STEEM',
    'ARNAS',
    'SARDS',
    'ZUZIM',
    'HAARS',
    'MIRID',
    'ATILT',
    'POULP',
    'NAANS',
    'REMET',
    'GUTTY',
    'TEERS',
    'SADES',
    'GLEEK',
    'NONIS',
    'CLACH',
    'COOMS',
    'ARGAL',
    'GLEET',
    'TIKIS',
    'CEILI',
    'WOOTZ',
    'KIEVE',
    'SYCES',
    'BUNNS',
    'STENS',
    'ENATE',
    'HAGGS',
    'TAZZE',
    'DITED',
    'KEYER',
    'BRAZA',
    'PARPS',
    'POONS',
    'BUSKS',
    'HUZZY',
    'SHIRR',
    'NARAS',
    'KAPAS',
    'BOOLS',
    'ETAGE',
    'DOOMY',
    'POOHS',
    'TRASS',
    'ALFAS',
    'DUKED',
    'ETTLE',
    'ERNED',
    'COSES',
    'FRORE',
    'SORAS',
    'BOOMY',
    'BREEM',
    'BAFFY',
    'KEVEL',
    'PIKIS',
    'SORGO',
    'LEDES',
    'CEPES',
    'EROSE',
    'TOKOS',
    'PLUFF',
    'GYPPO',
    'VENEY',
    'ASKOS',
    'ADEEM',
    'FREET',
    'LUAUS',
    'DUFUS',
    'AIRER',
    'FANGA',
    'SHULS',
    'TAVAS',
    'FORDO',
    'TETRI',
    'BOTTY',
    'LOOIE',
    'SCATT',
    'KAIAK',
    'AGAST',
    'AHIGH',
    'VISIE',
    'REECH',
    'MOPPY',
    'APEAK',
    'HITHE',
    'JEMBE',
    'MISOS',
    'SALPA',
    'COOZE',
    'RIDIC',
    'THYMY',
    'TARRE',
    'NEPER',
    'SEARE',
    'SEELS',
    'GOFFS',
    'BIFFO',
    'PASES',
    'SOCKO',
    'REWET',
    'EMEER',
    'SONSY',
    'MESEL',
    'YARAK',
    'KAWAU',
    'LUFFS',
    'ZABRA',
    'NIMBI',
    'FEZES',
    'ALANT',
    'THOFT',
    'LIMBI',
    'GROGS',
    'IRIDS',
    'ALGAS',
    'WHEEP',
    'NILLS',
    'ARARS',
    'SEILS',
    'SUMOS',
    'YEGGS',
    'LYTTA',
    'BIBES',
    'HETES',
    'SEANS',
    'MOOVE',
    'KECKS',
    'BUFFE',
    'NAKFA',
    'SHAPS',
    'UMMED',
    'YOBBO',
    'SORNS',
    'SIMPS',
    'NAGGY',
    'DATTO',
    'BOONG',
    'SPAZZ',
    'TORRS',
    'FEMES',
    'YENTE',
    'COMMY',
    'YUPPY',
    'PARAE',
    'LICHI',
    'SUBBY',
    'GAMAS',
    'NEWED',
    'SICES',
    'URGER',
    'RODED',
    'IMSHI',
    'SEIRS',
    'CHOOM',
    'WENNY',
    'PIPAS',
    'GREGE',
    'PUSES',
    'ARAKS',
    'JELLS',
    'XYLYL',
    'STAPS',
    'POSHO',
    'EWEST',
    'CULCH',
    'DREED',
    'TANAS',
    'IODIC',
    'REEKY',
    'CUVEE',
    'LEMEL',
    'HOONS',
    'EMOVE',
    'MEVES',
    'LILOS',
    'SADDO',
    'SMEEK',
    'BOPPY',
    'GELEE',
    'EENSY',
    'PIPIS',
    'CUMEC',
    'NAPOO',
    'SOOTS',
    'LAUAN',
    'HOWFF',
    'SCUTS',
    'SOOKY',
    'NEIVE',
    'DERRO',
    'ELFED',
    'NENES',
    'RUANA',
    'DOOKS',
    'BLEES',
    'AFARA',
    'WOOLD',
    'DEFFO',
    'SADIS',
    'DUDED',
    'SUBAS',
    'DAFFS',
    'AKKAS',
    'SIRIH',
    'POOKS',
    'DYKED',
    'SASIN',
    'GNARR',
    'LENES',
    'SEAME',
    'GERES',
    'TAATA',
    'WROOT',
    'BOBOL',
    'SHCHI',
    'PALSA',
    'LOPPY',
    'SOOLE',
    'KOBOS',
    'SYSOP',
    'ASYLA',
    'GOONY',
    'TRIFF',
    'MASES',
    'AREAE',
    'BIALI',
    'DEICE',
    'UNWON',
    'KAVAS',
    'FERER',
    'CABAS',
    'KOPPA',
    'PAANS',
    'SWEED',
    'HELES',
    'AIGAS',
    'KEENO',
    'HOORS',
    'DARRE',
    'SALSE',
    'SOOTE',
    'TAITS',
    'KOKAS',
    'LEAZE',
    'FURRS',
    'REFED',
    'DIDOS',
    'SALOL',
    'SYLIS',
    'ZOEAE',
    'ATAXY',
    'SULUS',
    'PEEPE',
    'KLIKS',
    'RARED',
    'LAZZO',
    'SOCAS',
    'NUNNY',
    'KISTS',
    'GOOSY',
    'GOOPS',
    'ABAKA',
    'NOINT',
    'SLUSE',
    'POMOS',
    'GRRLS',
    'XOANA',
    'REGUR',
    'TASES',
    'JUJUS',
    'NARRE',
    'KAAMA',
    'BINIT',
    'BASTS',
    'KEETS',
    'KEREL',
    'AGENE',
    'ADZED',
    'SMOOR',
    'TICCA',
    'ZOCCO',
    'OBOLI',
    'UMMAS',
    'FYTTE',
    'OMASA',
    'GAZAR',
    'DEAVE',
    'ALLOD',
    'TRATT',
    'LABDA',
    'ALAAP',
    'ERNES',
    'RAZOO',
    'ERSES',
    'ZAPPY',
    'BESES',
    'YOGEE',
    'YUKKY',
    'GNAWN',
    'WEETS',
    'REENS',
    'SOUMS',
    'LASES',
    'BUFFI',
    'CLOOT',
    'CHICS',
    'CILLS',
    'OASTS',
    'YETTS',
    'STYMY',
    'CIVIE',
    'FEENS',
    'TOLTS',
    'BOREE',
    'KEBOB',
    'SPAYS',
    'SNOGS',
    'BAAED',
    'CETES',
    'SNITS',
    'LURER',
    'RESEE',
    'CWTCH',
    'UNDUG',
    'SUETE',
    'SKOFF',
    'GAYAL',
    'NUMMY',
    'TRYER',
    'JAVAS',
    'PECKE',
    'KIRRI',
    'SPEOS',
    'DOXED',
    'HOORD',
    'TEENE',
    'HESTS',
    'SUERS',
    'CADEE',
    'RONEO',
    'FIRIE',
    'HAKAS',
    'POUFF',
    'WOOFY',
    'KOKAM',
    'MUGGA',
    'AWAVE',
    'VEGES',
    'POTOO',
    'MOSTS',
    'DURED',
    'TERTS',
    'NGANA',
    'DEKED',
    'SHETS',
    'CONNS',
    'APAGE',
    'ELMEN',
    'LOGGY',
    'BAZOO',
    'POUPE',
    'CACAS',
    'TODDE',
    'WINNS',
    'ROOPS',
    'RAFFS',
    'SEYEN',
    'DEBEL',
    'SKETS',
    'TAWAI',
    'SLUBS',
    'PUPAS',
    'SLISH',
    'IODIN',
    'HOWSO',
    'AVALE',
    'AJIVA',
    'DOYLY',
    'JUTTY',
    'MOORY',
    'BUBUS',
    'PRAAM',
    'HEUCH',
    'MAILL',
    'VEXER',
    'MERER',
    'SKOSH',
    'VELLS',
    'SATAI',
    'BRIKI',
    'GLIFF',
    'BOHOS',
    'MOOBS',
    'AGAZE',
    'SHEAS',
    'FUZEE',
    'MOKOS',
    'SYCEE',
    'DEKES',
    'NEEMS',
    'RAZEE',
    'SAUTS',
    'KAKIS',
    'WEIZE',
    'AIDAS',
    'BISES',
    'SLOMO',
    'SPETS',
    'ADYTA',
    'SEXER',
    'FISKS',
    'EALED',
    'SAIST',
    'KVELL',
    'PEPLA',
    'ARBAS',
    'SAZES',
    'GYPPY',
    'CERED',
    'SHIAI',
    'VIRID',
    'TEWED',
    'FIRRY',
    'ARPAS',
    'REIVE',
    'OBOLE',
    'HIKOI',
    'DYKEY',
    'JINNE',
    'HANAP',
    'MARMS',
    'MOFOS',
    'STOTS',
    'KEEKS',
    'JEELY',
    'POBOY',
    'SKIRR',
    'DENET',
    'GIPPY',
    'ABRAY',
    'ILLTH',
    'WAWAS',
    'DOOLS',
    'BOOFY',
    'APAID',
    'URUBU',
    'HOOKA',
    'TWEEP',
    'JIBBA',
    'DONKO',
    'BUSSU',
    'RESES',
    'CAMAN',
    'AECIA',
    'LUVVY',
    'APPAY',
    'PUPUS',
    'BIZZO',
    'HIREE',
    'PEENS',
    'RASES',
    'AREAD',
    'TAYRA',
    'CUSEC',
    'NUDDY',
    'SUHUR',
    'BIFFS',
    'DALED',
    'SLEER',
    'BRERE',
    'KAMIK',
    'ZEBEC',
    'MAMEE',
    'SKEGS',
    'PEKES',
    'BAIZA',
    'NETES',
    'LEARE',
    'APSOS',
    'DOWED',
    'SMUGS',
    'GEMEL',
    'KRUNK',
    'AIYEE',
    'VINIC',
    'WAWES',
    'COHOE',
    'COACT',
    'ESNES',
    'REDYE',
    'PLAPS',
    'DELED',
    'VADED',
    'EATHE',
    'AHEAP',
    'JAGAS',
    'STOIT',
    'GAZOO',
    'COHOS',
    'IBRIK',
    'BROOL',
    'CLOOP',
    'WEETE',
    'BOOGY',
    'SEKOS',
    'GURGE',
    'WOONS',
    'CURCH',
    'EDILE',
    'PILEI',
    'SHIST',
    'BIVIA',
    'GIPPO',
    'HORAH',
    'SAMPS',
    'AHULL',
    'SOKES',
    'SOOKS',
    'AFEAR',
    'HAIKA',
    'SUSUS',
    'MOOLS',
    'DADAH',
    'OIDIA',
    'BLUBS',
    'MALMS',
    'COOST',
    'GLOGG',
    'MOOLY',
    'TOSSY',
    'NIFFY',
    'GEEPS',
    'SKOGS',
    'RORTS',
    'KIBBI',
    'TENTY',
    'ZANZE',
    'ARERE',
    'LEZZY',
    'DATAL',
    'TRAPT',
    'REMEX',
    'LALLS',
    'UNBAN',
    'SNIES',
    'LERES',
    'JEWED',
    'BERME',
    'EMULE',
    'TRETS',
    'LURRY',
    'HYPHY',
    'VASTS',
    'DINIC',
    'ADRAD',
    'KOTOW',
    'CUTTO',
    'QUEME',
    'KYACK',
    'CERGE',
    'ANSAE',
    'REHEM',
    'MOOPS',
    'TOROT',
    'AYAYA',
    'SOOEY',
    'SEWEN',
    'EVETS',
    'SKAGS',
    'AGUNA',
    'KURRE',
    'AREAR',
    'RUSAS',
    'TROAT',
    'GIBLI',
    'HADED',
    'BOKOS',
    'PEISE',
    'MOHOS',
    'SLAES',
    'SLUES',
    'FOGOU',
    'KOTOS',
    'DEDAL',
    'EAGRE',
    'ICTIC',
    'SKEDS',
    'TEELS',
    'VEEPS',
    'KIKOI',
    'TEMSE',
    'POAKA',
    'GADID',
    'REFFO',
    'SCURS',
    'YESTY',
    'SOJAS',
    'MIFFS',
    'THETE',
    'SMIRR',
    'UNTIN',
    'LECCY',
    'OLIOS',
    'LERED',
    'LEZZA',
    'RESEW',
    'CHOOF',
    'REWED',
    'MASUS',
    'KNURR',
    'RUERS',
    'OHONE',
    'COCAS',
    'CLECK',
    'RYPER',
    'DURRS',
    'RETEM',
    'PIPUL',
    'CAFFS',
    'STONN',
    'FEMMY',
    'POGOS',
    'NETTS',
    'HODAD',
    'INTIS',
    'SWOPS',
    'TWILT',
    'NOUNY',
    'NOOPS',
    'ALAPA',
    'RECCY',
    'HOUFF',
    'EEVEN',
    'ARDRI',
    'OOTID',
    'EXIES',
    'ABBED',
    'MAARE',
    'AREDE',
    'SPODS',
    'FIFIS',
    'HOOVE',
    'SCOGS',
    'FLITT',
    'KAURU',
    'CURRS',
    'GOOLS',
    'ROONS',
    'DOOBS',
    'DEEVS',
    'EPOPT',
    'FEESE',
    'SERKS',
    'DOHYO',
    'FABBY',
    'UNGAG',
    'KAMME',
    'INNED',
    'NITID',
    'SASER',
    'YECCH',
    'RIFER',
    'RUGGY',
    'DESEX',
    'EGERS',
    'CINCT',
    'YAWNY',
    'WEXED',
    'KUKUS',
    'OGEES',
    'CHIZZ',
    'NGWEE',
    'IODID',
    'GUNGY',
    'LEXES',
    'MURRS',
    'REFRY',
    'WISTS',
    'BLAFF',
    'ABASK',
    'ACETA',
    'SUNIS',
    'AHURU',
    'EYASS',
    'JIRRE',
    'BLOOK',
    'ADAWS',
    'OLLAV',
    'HANCH',
    'OLEOS',
    'REEST',
    'PORER',
    'WIGGA',
    'ASWAY',
    'LEEAR',
    'YACCA',
    'TITUP',
    'SISES',
    'ZOPPA',
    'WHISS',
    'EGEST',
    'WASES',
    'ISBAS',
    'ESILE',
    'TAPET',
    'MADID',
    'HEEZE',
    'COALA',
    'HETHS',
    'DEXES',
    'RUDDS',
    'JANNS',
    'LAARI',
    'DAALS',
    'RORES',
    'EKKAS',
    'AURAR',
    'NOLLS',
    'FEUED',
    'GOGGA',
    'JIBBS',
    'ZOWEE',
    'CEZVE',
    'AGLEE',
    'SCUGS',
    'FRORN',
    'REPPS',
    'UGGED',
    'AMNIA',
    'HAHAS',
    'YARTA',
    'NEWIE',
    'GOOLY',
    'LEEPS',
    'JOTTY',
    'TEFFS',
    'ATAPS',
    'PAWAS',
    'CALPA',
    'NEEZE',
    'VEHME',
    'BELEE',
    'POZZY',
    'DROOK',
    'RENEY',
    'FEOFF',
    'WASTS',
    'EVOHE',
    'JOOKS',
    'IXIAS',
    'OGGIN',
    'CANNS',
    'SEIFS',
    'TRIOR',
    'SPAGS',
    'ROOPY',
    'OPEPE',
    'HISTS',
    'WIRER',
    'PEAGE',
    'YAFFS',
    'SIBBS',
    'YFERE',
    'READD',
    'SWITS',
    'SOREE',
    'BIRRS',
    'TUKTU',
    'PHIZZ',
    'SNIGS',
    'WOOSE',
    'JIFFS',
    'SPIKS',
    'CUSSO',
    'FEZZY',
    'DOCOS',
    'VODDY',
    'SLOOM',
    'LILLS',
    'SOLDS',
    'HAYEY',
    'SPAES',
    'SUMIS',
    'REDRY',
    'TEIID',
    'DUADS',
    'YUMMO',
    'ZANZA',
    'FEERS',
    'CACKS',
    'ZILLS',
    'MAHWA',
    'GINGS',
    'SOOPS',
    'TAALS',
    'TOSES',
    'LAHAL',
    'AMLAS',
    'EMEUS',
    'GUGAS',
    'DHOLL',
    'NAUNT',
    'PICCY',
    'ATIGI',
    'TAGGY',
    'ECHES',
    'ROOFY',
    'WRIER',
    'SNARS',
    'EPEES',
    'PRORE',
    'QAJAQ',
    'EMURE',
    'BOFFS',
    'SCAGS',
    'APAYD',
    'VAKAS',
    'GOOGS',
    'KARKS',
    'SOYAS',
    'PREED',
    'AINEE',
    'CLEEP',
    'BOYSY',
    'NEBEK',
    'TELAE',
    'UNDEE',
    'UPSEE',
    'CABOB',
    'JOCOS',
    'SINHS',
    'STEDS',
    'BUBAL',
    'TOYOS',
    'CACKY',
    'MZEES',
    'UNPEN',
    'OVOLI',
    'BOSKS',
    'ZIZIT',
    'FEAZE',
    'MOSKS',
    'RORID',
    'WOKKA',
    'KIAAT',
    'AROBA',
    'TAVAH',
    'TOCOS',
    'SOOLS',
    'JETES',
    'SEAZE',
    'HASHY',
    'ANLAS',
    'BEGEM',
    'BEZZY',
    'ECHED',
    'WUDDY',
    'SEMIE',
    'LOORD',
    'SKUGS',
    'ATUAS',
    'TYPEY',
    'MOBBY',
    'GHEES',
    'ABOMA',
    'RATAL',
    'WASMS',
    'YEWEN',
    'ALAYS',
    'LUSKS',
    'MUMMS',
    'EBBET',
    'NYAFF',
    'CRARE',
    'BUTUT',
    'INRUN',
    'CEAZE',
    'PEAZE',
    'STEME',
    'MENED',
    'FEEZE',
    'WADDS',
    'PIRAI',
    'SPOOT',
    'BICCY',
    'BOABS',
    'CLOFF',
    'TOSAS',
    'LALDY',
    'IMMIX',
    'TAHAS',
    'SCUPS',
    'HEAME',
    'MOMES',
    'DAWED',
    'ZOOTY',
    'EREVS',
    'TEWIT',
    'FUFFY',
    'PEIZE',
    'SAIRS',
    'SYNDS',
    'PLOOK',
    'SPOOM',
    'FISCS',
    'LEMED',
    'SIKAS',
    'URARI',
    'CEROC',
    'FAFFY',
    'EYRIR',
    'SPUES',
    'OONTS',
    'SNOOL',
    'SEMEE',
    'MYTHY',
    'SNASH',
    'MUMUS',
    'WRYER',
    'SLEBS',
    'OUZOS',
    'AZANS',
    'SWEES',
    'MHORR',
    'ADRED',
    'ROSTS',
    'PEPOS',
    'RAGEE',
    'NANUA',
    'YEDES',
    'DRERE',
    'MALAX',
    'SNAWS',
    'AGGRY',
    'TEWEL',
    'SAICS',
    'TEGGS',
    'WATAP',
    'REFEL',
    'ZITIS',
    'GOOKY',
    'HUSHY',
    'JUKUS',
    'TUFFE',
    'NONGS',
    'PEYSE',
    'FEHME',
    'BEWET',
    'RERIG',
    'JOKOL',
    'TAUTS',
    'YACKA',
    'TIYIN',
    'SORDS',
    'ACCAS',
    'MEVED',
    'FLEME',
    'KERVE',
    'DEEVE',
    'KYAKS',
    'FAFFS',
    'GASTS',
    'BUPPY',
    'LASSU',
    'BOBAS',
    'COLOG',
    'JAGRA',
    'TIFTS',
    'YOBBY',
    'SOJUS',
    'RAIAS',
    'PZAZZ',
    'OOPED',
    'INURN',
    'SOWSE',
    'SUSED',
    'ATMAS',
    'FIFED',
    'TWEER',
    'SWADS',
    'NAFFS',
    'AJWAN',
    'YAARS',
    'KSARS',
    'PUKUS',
    'FLAFF',
    'LESES',
    'SAUBA',
    'YOOPS',
    'TYEES',
    'HEEDY',
    'GUFFS',
    'COOMY',
    'SKATS',
    'TROOZ',
    'LESTS',
    'SMEWS',
    'SUSES',
    'SAGOS',
    'AMAUT',
    'FETTS',
    'SEKTS',
    'NUFFS',
    'EMMEW',
    'COOER',
    'SIALS',
    'LOLOG',
    'ARETT',
    'RISPS',
    'FEASE',
    'STYTE',
    'UNGUM',
    'RORAL',
    'SUNNS',
    'BESEE',
    'AKENE',
    'BUROO',
    'PISES',
    'DORRS',
    'YABAS',
    'JARTA',
    'SWEEL',
    'PULUS',
    'APPUY',
    'HEWGH',
    'SPIFS',
    'JEELS',
    'SPEKS',
    'SKOLS',
    'REDED',
    'AINGA',
    'GIGHE',
    'YOMIM',
    'SMEKE',
    'KONKS',
    'JAFAS',
    'PHEER',
    'SUJEE',
    'ENSEW',
    'YEVES',
    'ZOAEA',
    'POOVE',
    'WOOPY',
    'RAKEE',
    'HUSOS',
    'KUTUS',
    'HILCH',
    'TEADE',
    'SPAWS',
    'SONSE',
    'HAFFS',
    'SPIMS',
    'GODSO',
    'BOBAC',
    'SNEDS',
    'SCULS',
    'CABOC',
    'REGGO',
    'IGGED',
    'SLEYS',
    'PIING',
    'EANED',
    'WEXES',
    'TRATS',
    'CARAP',
    'BISKS',
    'KHETH',
    'ALAPS',
    'PAALS',
    'ACMIC',
    'GYNNY',
    'TAKKY',
    'SADOS',
    'DOVED',
    'SWOBS',
    'DORAD',
    'TYIYN',
    'DEIDS',
    'SOTHS',
    'OOBIT',
    'SPOSH',
    'TINTY',
    'SNIBS',
    'KOSES',
    'COOFS',
    'DROOB',
    'SAIMS',
    'OOSES',
    'KOKRA',
    'SNUSH',
    'AWARN',
    'GISMS',
    'URARE',
    'KHAPH',
    'SUETS',
    'ZIFFS',
    'YUCCH',
    'YARFA',
    'SHOGS',
    'AGGRI',
    'KELEP',
    'ETWEE',
    'SHIRS',
    'FUGUS',
    'SKIOS',
    'SHRIS',
    'ONNED',
    'CTENE',
    'KUSSO',
    'SOOMS',
    'WHEWS',
    'RURPS',
    'IMMIT',
    'ANOAS',
    'YDRAD',
    'PUDUS',
    'BRERS',
    'BOOHS',
    'FEYLY',
    'BYSSI',
    'NIFFS',
    'WAFFS',
    'SHWAS',
    'KEXES',
    'BEVUE',
    'DITTS',
    'SPUGS',
    'STEDD',
    'KACKS',
    'TERFE',
    'TEEND',
    'DAUDS',
    'KETES',
    'HEYED',
    'FUSTS',
    'YAWEY',
    'ALOOS',
    'REKES',
    'POYOU',
    'OORIE',
    'ASSOT',
    'TIRRS',
    'KAIKS',
    'SOWPS',
    'ABACS',
    'SMIRS',
    'SWIES',
    'AGMAS',
    'STEYS',
    'TURRS',
    'SYBBE',
    'EXEME',
    'PAWAW',
    'DARAF',
    'AALII',
    'RATOO',
    'SNODS',
    'TEAED',
    'GONOF',
    'FLURR',
    'LISKS',
    'WULLS',
    'CRAAL',
    'DAWDS',
    'MIHIS',
    'REZES',
    'RURUS',
    'GIRRS',
    'YUZUS',
    'REPEG',
    'ACAIS',
    'SYPES',
    'MIEVE',
    'FEYED',
    'SEGOS',
    'CAESE',
    'EWHOW',
    'MALMY',
    'JAAPS',
    'YAMPY',
    'WHOWS',
    'YAPPS',
    'REIRD',
    'GOORS',
    'EASLE',
    'BUCKU',
    'OGEED',
    'MYOPY',
    'TATHS',
    'AKEES',
    'SEELD',
    'KOFFS',
    'JEWIE',
    'SKEED',
    'SYENS',
    'SUNKS',
    'TETHS',
    'APEEK',
    'MAPAU',
    'STUMS',
    'MEFFS',
    'SNYES',
    'SCAWS',
    'AFALD',
    'ZIZEL',
    'GAITT',
    'ACCOY',
    'HUHUS',
    'STAWS',
    'UNAUS',
    'SKEOS',
    'NEAFE',
    'FUBBY',
    'BAFFS',
    'WRAWL',
    'SKERS',
    'ALEYE',
    'JOMOS',
    'HASKS',
    'SIJOS',
    'AREDD',
    'ZOBOS',
    'ORZOS',
    'WAWLS',
    'ETENS',
    'ENDEW',
    'YILLS',
    'PHESE',
    'AGLOO',
    'YOOFS',
    'EIKED',
    'ELPEE',
    'SKENS',
    'YIRRS',
    'SCOOG',
    'REKED',
    'CAAED',
    'AUDAD',
    'PURPY',
    'SOUTS',
    'BETED',
    'VUGGS',
    'CUFFO',
    'SNEES',
    'TAWTS',
    'NOLOS',
    'HAAFS',
    'WUSES',
    'LEZES',
    'HERYE',
    'ZEZES',
    'POOVY',
    'APAYS',
    'ENMEW',
    'ABAMP',
    'POEPS',
    'AIDOI',
    'COHOG',
    'DEBUD',
    'SESEY',
    'SUGHS',
    'SMALM',
    'ZOOEA',
    'JISMS',
    'FRORY',
    'WEFTE',
    'BOOAI',
    'KEEFS',
    'YECHY',
    'SAAGS',
    'YEUKY',
    'SWEYS',
    'TYPTO',
    'SUGOS',
    'KIACK',
    'CUSKS',
    'ABCEE',
    'YARER',
    'UPRUN',
    'YEXES',
    'SOCES',
    'HESPS',
    'ENURN',
    'VIVDA',
    'EMYDE',
    'RYMME',
    'KERKY',
    'RARKS',
    'URDEE',
    'PAUAS',
    'GOORY',
    'SCYES',
    'YTOST',
    'YESTS',
    'BOOAY',
    'YDRED',
    'AWATO',
    'KESTS',
    'TYPPS',
    'SOWMS',
    'IMMEW',
    'SMURS',
    'NEEMB',
    'FUFFS',
    'SLUBB',
    'EXEEM',
    'SNABS',
    'MAAED',
    'TOHOS',
    'JASPS',
    'YARRS',
    'TOWTS',
    'SKYRS',
    'SYPHS',
    'FUSKS',
    'BEROB',
    'HOHED',
    'ZHOMO',
    'SUKHS',
    'YEXED',
    'DSOMO',
    'HOGHS',
    'SOWFF',
    'YEEDS',
    'SILDS',
    'WUDUS',
    'RAIRD',
    'SKAWS',
    'NURRS',
    'WAUFF',
    'BEDYE',
    'PEEOY',
    'APOOP',
    'NIDED',
    'BYDED',
    'YITIE',
    'PASPY',
    'NEMNS',
    'ZEXES',
    'YESKS',
    'XYSTS',
    'VUTTY',
    'VIFFS',
    'SOWFS',
    'SNEBS',
    'SKYFS',
    'POUPT',
    'PHPHT',
    'OMOVS',
    'KUZUS',
    'HIOIS',
    'EWKED',
    'EVHOE',
    'EUKED',
    'ENNOG',
    'EEVNS',
    'DSOBO',
    'AZYGY'
];
const $09b17a1eda282565$export$3f5f326c8ed77e93 = [
    'THEIR',
    'WOULD',
    'ABOUT',
    'COULD',
    'OTHER',
    'FIRST',
    'AFTER',
    'THOSE',
    'BEING',
    'WHILE',
    'RIGHT',
    'WORLD',
    'YEARS',
    'THINK',
    'MIGHT',
    'UNDER',
    'PLACE',
    'FOUND',
    'GREAT',
    'SINCE',
    'POWER',
    'ASKED',
    'HUMAN',
    'WATER',
    'HOUSE',
    'BASED',
    'WOMEN',
    'OFTEN',
    'POINT',
    'GIVEN',
    'UNTIL',
    'USING',
    'TABLE',
    'GROUP',
    'LARGE',
    'LATER',
    'WORDS',
    'NIGHT',
    'STUDY',
    'AMONG',
    'YOUNG',
    'EARLY',
    'THING',
    'WOMAN',
    'TIMES',
    'LIGHT',
    'HEART',
    'WHITE',
    'HANDS',
    'LEAST',
    'VALUE',
    'MODEL',
    'BLACK',
    'MEANS',
    'ALONG',
    'WHOLE',
    'CHILD',
    'VOICE',
    'DEATH',
    'ABOVE',
    'TAKEN',
    'BEGAN',
    'HEARD',
    'DOING',
    'FRONT',
    'MONEY',
    'CLOSE',
    'COURT',
    'PARTY',
    'SPACE',
    'TERMS',
    'SHORT',
    'QUITE',
    'CLEAR',
    'STORY',
    'FIELD',
    'THIRD',
    'TODAY',
    'SOUTH',
    'MAJOR',
    'FORCE',
    'MAKES',
    'ALONE',
    'WHOSE',
    'MAYBE',
    'SHOWN',
    'CAUSE',
    'NORTH',
    'HOURS',
    'SOUND',
    'TRIED',
    'EARTH',
    'BRING',
    'LOWER',
    'MUSIC',
    'FOCUS',
    'MOUTH',
    'IMAGE',
    'RANGE',
    'MOVED',
    'BELOW',
    'WORKS',
    'TRADE',
    'MEDIA',
    'READY',
    'COMES',
    'LIVES',
    'FORMS',
    'WRONG',
    'SPEAK',
    'CHINA',
    'SMILE',
    'STAGE',
    'BASIC',
    'JAMES',
    'FINAL',
    'TYPES',
    'RULES',
    'SHARE',
    'PHONE',
    'ROUND',
    'MEANT',
    'PRICE',
    'IDEAS',
    'PARTS',
    'TAKES',
    'BRAIN',
    'LEARN',
    'STAND',
    'FAITH',
    'LINES',
    'MARCH',
    'BOARD',
    'SCALE',
    'THANK',
    'WRITE',
    'WROTE',
    'BROWN',
    'DAILY',
    'LIVED',
    'MORAL',
    'NOTES',
    'BUILT',
    'SPOKE',
    'PHASE',
    'REACH',
    'WATCH',
    'GIRLS',
    'DOUBT',
    'GIVES',
    'BEGIN',
    'COVER',
    'CLAIM',
    'HEAVY',
    'LOVED',
    'BREAK',
    'OLDER',
    'SPENT',
    'CHAIR',
    'CHEST',
    'EIGHT',
    'AVOID',
    'FIGHT',
    'NOTED',
    'EQUAL',
    'DRIVE',
    'LABOR',
    'STONE',
    'URBAN',
    'PLANT',
    'KNOWS',
    'MILES',
    'CHIEF',
    'STYLE',
    'TOUCH',
    'SHAPE',
    'SIGHT',
    'WORTH',
    'RATES',
    'MONTH',
    'NAMES',
    'CRIME',
    'BUILD',
    'FIXED',
    'HORSE',
    'SMITH',
    'PARIS',
    'HENRY',
    'TRIAL',
    'WANTS',
    'PLANS',
    'DRINK',
    'TEARS',
    'INDEX',
    'QUIET',
    'FRESH',
    'QUICK',
    'GUIDE',
    'BIRTH',
    'STOCK',
    'DREAM',
    'FORTH',
    'AGENT',
    'YOUTH',
    'EMPTY',
    'EXIST',
    'GOALS',
    'NAMED',
    'METAL',
    'JUDGE',
    'NOVEL',
    'ROYAL',
    'WORSE',
    'VIEWS',
    'CLEAN',
    'GRACE',
    'STORE',
    'CRIED',
    'TRAIN',
    'TRULY',
    'UNITS',
    'HOTEL',
    'SHIFT',
    'JOINT',
    'ADULT',
    'ROMAN',
    'DRAWN',
    'BROAD',
    'ITEMS',
    'LEADS',
    'BLOCK',
    'FALSE',
    'BRIEF',
    'BOUND',
    'SOLID',
    'LAYER',
    'THICK',
    'NOISE',
    'CHAIN',
    'ANGER',
    'ALIVE',
    'RATIO',
    'FACTS',
    'DRUGS',
    'BROKE',
    'SPEND',
    'LIKED',
    'COUNT',
    'GRAND',
    'ASIDE',
    'DANCE',
    'FRAME',
    'ENJOY',
    'WASTE',
    'INPUT',
    'CROWD',
    'LYING',
    'MIXED',
    'KINDS',
    'GAMES',
    'PROVE',
    'ANGRY',
    'GUARD',
    'SHARP',
    'VIDEO',
    'LAUGH',
    'TURNS',
    'TRACK',
    'UNCLE',
    'PLANE',
    'EXTRA',
    'IDEAL',
    'PLATE',
    'OUGHT',
    'HEADS',
    'SHIRT',
    'GROWN',
    'TWICE',
    'RADIO',
    'GRANT',
    'FACES',
    'FACED',
    'BANKS',
    'ARGUE',
    'SUGAR',
    'FRANK',
    'HOPED',
    'PAGES',
    'LOGIC',
    'ENTRY',
    'OWNER',
    'FORTY',
    'DEPTH',
    'FLUID',
    'SHOCK',
    'COAST',
    'FUNDS',
    'ROLES',
    'FRUIT',
    'CLOUD',
    'RAISE',
    'ABUSE',
    'TEACH',
    'TIRED',
    'TOPIC',
    'MAGIC',
    'MATCH',
    'FIRMS',
    'HELPS',
    'FLESH',
    'SCOPE',
    'BREAD',
    'SWORD',
    'RAPID',
    'THREW',
    'BEACH',
    'WAVES',
    'ROUTE',
    'ACUTE',
    'SMOKE',
    'OCEAN',
    'DROVE',
    'SMART',
    'PLAYS',
    'JONES',
    'ARMED',
    'ANGLE',
    'PLAIN',
    'SCORE',
    'HOLDS',
    'WORST',
    'BIRDS',
    'PRIME',
    'FAULT',
    'TRANS',
    'PRINT',
    'FILMS',
    'LOUIS',
    'SAVED',
    'NURSE',
    'LUNCH',
    'CURVE',
    'GRADE',
    'BRAND',
    'MINOR',
    'OWNED',
    'SPAIN',
    'THROW',
    'PRIDE',
    'REPLY',
    'YIELD',
    'ADMIT',
    'STORM',
    'YOURS',
    'SLAVE',
    'STICK',
    'GLORY',
    'LINKS',
    'MOVES',
    'TRAIL',
    'BLIND',
    'FAVOR',
    'WOUND',
    'PROUD',
    'BEGUN',
    'CRAZY',
    'FINDS',
    'STUCK',
    'MINDS',
    'MARKS',
    'CHOSE',
    'TRUCK',
    'TEXAS',
    'SPLIT',
    'KNIFE',
    'WIDER',
    'PANEL',
    'DYING',
    'KINGS',
    'ROUGH',
    'SAINT',
    'MOVIE',
    'EXACT',
    'BONES',
    'SPORT',
    'HOMES',
    'VITAL',
    'TEAMS',
    'FILES',
    'DUTCH',
    'LIVER',
    'DEVIL',
    'SOLVE',
    'CREAM',
    'NORMS',
    'CROWN',
    'SHAME',
    'TAXES',
    'UNITY',
    'ANGEL',
    'DELAY',
    'CITED',
    'BURST',
    'LANDS',
    'BLAME',
    'GRAVE',
    'TOWER',
    'LUCKY',
    'NEWLY',
    'SPITE',
    'FLOWS',
    'OUTER',
    'ARISE',
    'NAKED',
    'ROCKS',
    'DOZEN',
    'CARDS',
    'TRACE',
    'LEWIS',
    'GIANT',
    'BONDS',
    'VALID',
    'SHORE',
    'AIMED',
    'NOBLE',
    'SHAKE',
    'SOLAR',
    'GRAPH',
    'MERCY',
    'REALM',
    'TUMOR',
    'GRAIN',
    'TREND',
    'GUILT',
    'HATED',
    'WINGS',
    'GRIEF',
    'PILOT',
    'HABIT',
    'TOWNS',
    'VIRUS',
    'MODES',
    'PULSE',
    'MOUNT',
    'FIRED',
    'GHOST',
    'UPSET',
    'ROADS',
    'HONEY',
    'GIFTS',
    'WAIST',
    'EMAIL',
    'DIRTY',
    'HOPES',
    'FLASH',
    'PAUSE',
    'SLEPT',
    'PANIC',
    'PAINT',
    'NODES',
    'WAVED',
    'GUEST',
    'CABIN',
    'BLANK',
    'INTER',
    'FEARS',
    'BADLY',
    'FANCY',
    'ADOPT',
    'DRAFT',
    'WAGES',
    'LOVES',
    'ACTOR',
    'GATES',
    'SUPER',
    'ACTED',
    'CHART',
    'LOVER',
    'POEMS',
    'TOUGH',
    'BEAST',
    'DRUNK',
    'USAGE',
    'CLOTH',
    'CODES',
    'YARDS',
    'SIXTY',
    'OPENS',
    'JUICE',
    'MIDST',
    'STEAM',
    'SWEPT',
    'BOXES',
    'ACIDS',
    'BLADE',
    'DATES',
    'FAINT',
    'ORGAN',
    'MALES',
    'SLOPE',
    'FIBER',
    'RENAL',
    'PATHS',
    'SWEAT',
    'GRASP',
    'STARE',
    'CHASE',
    'SIXTH',
    'LASER',
    'PITCH',
    'OLIVE',
    'AWFUL',
    'TENDS',
    'SPINE',
    'GAINS',
    'CORPS',
    'BRAVE',
    'PAIRS',
    'LIKES',
    'SPARE',
    'LOANS',
    'HOLES',
    'WALKS',
    'BENCH',
    'CRAFT',
    'ONSET',
    'CLIMB',
    'CARED',
    'HIRED',
    'SLIDE',
    'SAUCE',
    'PANTS',
    'BRUSH',
    'FLAME',
    'THUMB',
    'CROPS',
    'DEALT',
    'WIDTH',
    'MOUSE',
    'WIVES',
    'SCENT',
    'PRIZE',
    'SWUNG',
    'ALIKE',
    'TALES',
    'RULED',
    'CRUEL',
    'WHEAT',
    'AUDIT',
    'CHEAP',
    'SHADE',
    'TRIBE',
    'FORUM',
    'JEANS',
    'BOATS',
    'FAILS',
    'FLOUR',
    'REIGN',
    'CHAOS',
    'AROSE',
    'LINED',
    'WALES',
    'ALERT',
    'WEIRD',
    'TRUMP',
    'BAKER',
    'TRIES',
    'DROPS',
    'RINGS',
    'MAYOR',
    'WRIST',
    'ALTER',
    'DRAWS',
    'STRIP',
    'POUND',
    'TALKS',
    'LUNGS',
    'DIARY',
    'RELAX',
    'ATOMS',
    'REACT',
    'BEARS',
    'MEALS',
    'BANDS',
    'FILED',
    'CABLE',
    'PORCH',
    'ALIEN',
    'DEALS',
    'READS',
    'SIZED',
    'MICRO',
    'TRUNK',
    'FOLKS',
    'QUEST',
    'WIPED',
    'BUNCH',
    'RIFLE',
    'TOXIC',
    'URGED',
    'CURSE',
    'STERN',
    'VAGUE',
    'CRASH',
    'GLOBE',
    'BASIN',
    'BRICK',
    'ZONES',
    'OPERA',
    'RANKS',
    'DRANK',
    'ELBOW',
    'TRICK',
    'DEMON',
    'SERUM',
    'FRAUD',
    'RIDGE',
    'MASON',
    'HUMOR',
    'SWING',
    'HAVEN',
    'BRIDE',
    'SWEAR',
    'SWIFT',
    'GROWS',
    'BOWED',
    'COHEN',
    'ALOUD',
    'PIANO',
    'AMINO',
    'LEMON',
    'PATCH',
    'GAZED',
    'BEANS',
    'OXIDE',
    'STAKE',
    'IMPLY',
    'RANCH',
    'CLERK',
    'SHELF',
    'SNAKE',
    'FEAST',
    'LIMBS',
    'SANDY',
    'WINDS',
    'CLUBS',
    'BURNS',
    'BEARD',
    'WITCH',
    'FIRES',
    'CAMPS',
    'VEINS',
    'TRIPS',
    'URINE',
    'ANGLO',
    'ROBIN',
    'BACON',
    'SUITE',
    'SHEAR',
    'QUOTE',
    'BUYER',
    'RACES',
    'RALPH',
    'PURSE',
    'FAIRY',
    'STEAL',
    'CHARM',
    'CRIES',
    'STACK',
    'QUERY',
    'PARKS',
    'AUDIO',
    'VOTES',
    'BORNE',
    'ROCKY',
    'POSED',
    'POETS',
    'FARMS',
    'PEARL',
    'SKIRT',
    'DRAIN',
    'MERIT',
    'SHAFT',
    'RIVAL',
    'SHOUT',
    'MAKER',
    'TANKS',
    'LORDS',
    'BURNT',
    'PUNCH',
    'WEARY',
    'SPRAY',
    'DECAY',
    'TWINS',
    'SADLY',
    'LODGE',
    'TOWEL',
    'PSALM',
    'WAGON',
    'VIRAL',
    'PALMS',
    'FLUNG',
    'CARGO',
    'BLAST',
    'STRAW',
    'LOGAN',
    'DRIFT',
    'ACRES',
    'RISEN',
    'PRONE',
    'LOADS',
    'SHALT',
    'BLOWN',
    'FETAL',
    'TYLER',
    'CAROL',
    'CRUDE',
    'LAKES',
    'PORTS',
    'FOCAL',
    'CRAIG',
    'SLICE',
    'NAILS',
    'SUPRA',
    'MINES',
    'COLIN',
    'BACKS',
    'VOCAL',
    'BLEND',
    'WRATH',
    'POLES',
    'ANKLE',
    'TIGER',
    'PROBE',
    'STOLE',
    'POLAR',
    'RUINS',
    'PEAKS',
    'BORED',
    'FLIES',
    'PLOTS',
    'COINS',
    'DELTA',
    'QUASI',
    'STARK',
    'SPARK',
    'SHONE',
    'ALBUM',
    'DEBTS',
    'TONES',
    'RACED',
    'BARON',
    'AMBER',
    'VERBS',
    'CLOAK',
    'PROSE',
    'CHIPS',
    'PAINS',
    'SETUP',
    'CREPT',
    'TUBES',
    'RILEY',
    'BLOND',
    'SCREW',
    'CANDY',
    'IRONY',
    'ORBIT',
    'MACRO',
    'BEAMS',
    'SHINE',
    'CHILE',
    'DAISY',
    'MYTHS',
    'DOUGH',
    'BURKE',
    'DAIRY',
    'GROVE',
    'AGONY',
    'CARES',
    'TOURS',
    'SAITH',
    'STOVE',
    'SAFER',
    'FROST',
    'COUGH',
    'BOWEL',
    'FROWN',
    'HERBS',
    'BLOWS',
    'CYBER',
    'THIEF',
    'GLARE',
    'BATCH',
    'CRUSH',
    'INTRA',
    'KNELT',
    'LACKS',
    'OSCAR',
    'MONKS',
    'HINTS',
    'VOTED',
    'FETCH',
    'SPEAR',
    'FROZE',
    'RISKY',
    'TRASH',
    'NASTY',
    'FLORA',
    'SWORE',
    'CHANG',
    'VAPOR',
    'THINE',
    'LADEN',
    'AMPLE',
    'FLOAT',
    'FLUSH',
    'SURGE',
    'FRIED',
    'RATED',
    'PASTE',
    'TOKEN',
    'SHINY',
    'GLAND',
    'BAKED',
    'BASIL',
    'DUSTY',
    'JOKES',
    'CLUNG',
    'BROWS',
    'HEARS',
    'CRISP',
    'FUELS',
    'DRAKE',
    'CLUES',
    'BLUES',
    'MATER',
    'CASTE',
    'HASTE',
    'LAMPS',
    'HARDY',
    'FLOCK',
    'WELSH',
    'STAMP',
    'MARSH',
    'SQUAD',
    'WIRES',
    'FOLDS',
    'SOBER',
    'LOCKS',
    'NOISY',
    'PINCH',
    'YEAST',
    'BEADS',
    'LANCE',
    'SWORN',
    'HORNS',
    'HURTS',
    'SCARY',
    'HOMER',
    'DEITY',
    'BEATS',
    'VENUS',
    'BLUNT',
    'SCARE',
    'FIERY',
    'RAVEN',
    'BONUS',
    'WHALE',
    'WEIGH',
    'CORAL',
    'PILED',
    'GROAN',
    'CAKES',
    'TORCH',
    'CREST',
    'ALIGN',
    'MINUS',
    'CURLS',
    'HANDY',
    'CRUST',
    'STAIN',
    'AWOKE',
    'FUNGI',
    'FIBRE',
    'ROPES',
    'PICKS',
    'SHRUG',
    'CLAWS',
    'WOVEN',
    'FLAGS',
    'LOCUS',
    'GOATS',
    'AISLE',
    'IVORY',
    'ULTRA',
    'PACED',
    'PILES',
    'CRAWL',
    'COATS',
    'MOIST',
    'OUNCE',
    'CENTS',
    'OPTIC',
    'ROAST',
    'LIONS',
    'PROXY',
    'OVERT',
    'SYRUP',
    'WEARS',
    'NICHE',
    'BLUSH',
    'MANOR',
    'MOUND',
    'LEAPT',
    'DITCH',
    'BLINK',
    'CAVES',
    'WINES',
    'CRANE',
    'CLASH',
    'SLAIN',
    'HAZEL',
    'STRAY',
    'PIETY',
    'SCOUT',
    'WRECK',
    'HAIRS',
    'GRAMS',
    'CURED',
    'BOWLS',
    'MATES',
    'LOFTY',
    'KNOTS',
    'CIGAR',
    'LIFTS',
    'BRAKE',
    'ROBES',
    'FLANK',
    'UNITE',
    'LYNCH',
    'ACHED',
    'TAILS',
    'MODAL',
    'CHOIR',
    'SNEAK',
    'MEDAL',
    'MOTIF',
    'BINDS',
    'CANOE',
    'ABIDE',
    'REINS',
    'CREWS',
    'MAPLE',
    'SCRAP',
    'SPIKE',
    'TRAPS',
    'ETHIC',
    'ETHOS',
    'RUSTY',
    'STING',
    'PAVED',
    'RIOTS',
    'DRUMS',
    'SPOIL',
    'BITES',
    'RIDES',
    'SCARF',
    'BRUTE',
    'FLOWN',
    'TIDAL',
    'LEANS',
    'FLINT',
    'FORGE',
    'INFER',
    'BROTH',
    'CITES',
    'STEAK',
    'TILES',
    'WORMS',
    'EXAMS',
    'SCALP',
    'VOTER',
    'PIXEL',
    'VINES',
    'APRON',
    'DIETS',
    'DRONE',
    'GUILD',
    'SLICK',
    'BRACE',
    'VAULT',
    'RESIN',
    'GLOVE',
    'SPICE',
    'SNACK',
    'RELAY',
    'BLAZE',
    'CURLY',
    'SLACK',
    'HATES',
    'BADGE',
    'GRABS',
    'EVILS',
    'TUNED',
    'OPTED',
    'GROWL',
    'INLET',
    'TIRES',
    'POKED',
    'SHAKY',
    'RANDY',
    'SWAMP',
    'AGILE',
    'STRAP',
    'JUMPS',
    'SALON',
    'REPAY',
    'YACHT',
    'WAITS',
    'HYPER',
    'SWARM',
    'FINER',
    'PACES',
    'HEIRS',
    'DWARF',
    'SCORN',
    'CHORD',
    'SHARK',
    'NOTCH',
    'CEDAR',
    'NAIVE',
    'FLAWS',
    'JOINS',
    'DOWNS',
    'HANGS',
    'LEVIN',
    'ROGUE',
    'BOLTS',
    'VOWEL',
    'TREAD',
    'JUDAS',
    'METRO',
    'TYPED',
    'SHOVE',
    'HASTY',
    'GRAPE',
    'TEMPO',
    'RAINS',
    'RENTS',
    'TOMBS',
    'GLEAM',
    'OPIUM',
    'WIRED',
    'SLATE',
    'BOAST',
    'RAIDS',
    'TYING',
    'OMEGA',
    'HIDES',
    'FREAK',
    'LANES',
    'CAMEL',
    'BLEAK',
    'POUCH',
    'POKER',
    'FRAIL',
    'MOTEL',
    'PACKS',
    'BRINK',
    'FUSED',
    'WISER',
    'THORN',
    'STUNG',
    'DWELT',
    'CLING',
    'URGES',
    'IDOLS',
    'PEACH',
    'RAILS',
    'PLEAD',
    'FINES',
    'CHALK',
    'ENACT',
    'EPOCH',
    'DROWN',
    'RAINY',
    'SPAKE',
    'AZURE',
    'VOWED',
    'LUNAR',
    'PATIO',
    'SMIRK',
    'ICONS',
    'PORES',
    'FLARE',
    'PINES',
    'BLOGS',
    'BATHS',
    'BIRCH',
    'DEPOT',
    'QUOTA',
    'DIMLY',
    'RHYME',
    'CHEAT',
    'DUCKS',
    'HYMNS',
    'SCRUB',
    'FLATS',
    'HAIRY',
    'DOVER',
    'SPICY',
    'BATES',
    'CHANT',
    'MANLY',
    'MISTY',
    'CUBES',
    'ROUGE',
    'WHISK',
    'MOLAR',
    'TOXIN',
    'CORDS',
    'JOKED',
    'DINER',
    'GODLY',
    'LACED',
    'LYRIC',
    'QUILT',
    'LOTUS',
    'BELTS',
    'BLAND',
    'GRIND',
    'STUMP',
    'CHUNK',
    'DOCKS',
    'TONIC',
    'HAUNT',
    'FOYER',
    'LAPSE',
    'SLUNG',
    'FLASK',
    'CHOKE',
    'VODKA',
    'MAIDS',
    'VICES',
    'FLICK',
    'BRISK',
    'SALTY',
    'BUCKS',
    'INERT',
    'NECKS',
    'TAXED',
    'STONY',
    'RUGBY',
    'FLUTE',
    'PLANK',
    'DEBUT',
    'HERDS',
    'WARNS',
    'HARMS',
    'VINYL',
    'CORES',
    'CLIPS',
    'GEARS',
    'SHALE',
    'CARTS',
    'WARDS',
    'WOKEN',
    'SILKY',
    'TIMED',
    'FROGS',
    'KINDA',
    'STALE',
    'PIVOT',
    'INTEL',
    'PRICK',
    'TUNIC',
    'TIMER',
    'RHINE',
    'LATCH',
    'SIGMA',
    'WRAPS',
    'SNOWY',
    'SMOKY',
    'LACEY',
    'CIDER',
    'GRUNT',
    'AMEND',
    'PONDS',
    'MUTED',
    'EXITS',
    'CLOWN',
    'ANODE',
    'MOURN',
    'BIKES',
    'MINER',
    'ADEPT',
    'MEATS',
    'TAPES',
    'PERCH',
    'GRIPS',
    'MORSE',
    'CLANS',
    'FRIES',
    'GLUED',
    'WAKES',
    'TIDES',
    'LUMEN',
    'STAIR',
    'TENOR',
    'THUMP',
    'SHADY',
    'BUMPS',
    'STALK',
    'FANGS',
    'SHACK',
    'COALS',
    'SMACK',
    'TUNES',
    'PRISM',
    'SWINE',
    'HOUND',
    'SIREN',
    'FLING',
    'DEBIT',
    'HUMID',
    'SQUAT',
    'WIDEN',
    'THYME',
    'DERBY',
    'BENDS',
    'HAVOC',
    'VENOM',
    'MILKY',
    'SCOWL',
    'ARIEL',
    'GAZES',
    'TRIAD',
    'LOBES',
    'MULES',
    'LEASH',
    'BOXER',
    'TRUCE',
    'VIGOR',
    'MENUS',
    'COILS',
    'RINSE',
    'DECKS',
    'LEAPS',
    'RAGED',
    'LEAKS',
    'VOMIT',
    'SMEAR',
    'LAMBS',
    'CONES',
    'HICKS',
    'LENDS',
    'BULKY',
    'MANGO',
    'HEAPS',
    'HUSKY',
    'UNFIT',
    'LOSER',
    'MIXER',
    'GLIDE',
    'SHAVE',
    'DUNES',
    'COMET',
    'VEGAN',
    'BATON',
    'WHARF',
    'SLING',
    'PLUCK',
    'LINER',
    'WELCH',
    'MOANS',
    'PEDAL',
    'INCUR',
    'BARGE',
    'TRAYS',
    'PURGE',
    'TROPE',
    'CROWS',
    'GRIDS',
    'SLANG',
    'FAMED',
    'FLAPS',
    'SONIC',
    'HELIX',
    'CRATE',
    'PLUME',
    'WAGED',
    'DUCTS',
    'MAINS',
    'SNORT',
    'PLEAS',
    'BRAID',
    'SWIRL',
    'RELIC',
    'VIOLA',
    'HINGE',
    'CLASP',
    'OATHS',
    'PIERS',
    'GOWNS',
    'FOLEY',
    'TWIGS',
    'BULGE',
    'ADORE',
    'LEAFY',
    'AMUSE',
    'BATHE',
    'FORTS',
    'SPIED',
    'GLINT',
    'MAILS',
    'CLAMP',
    'AUNTS',
    'FECAL',
    'BUDGE',
    'CAGES',
    'FUMES',
    'STINK',
    'GRINS',
    'VALET',
    'CARVE',
    'GRATE',
    'CLONE',
    'SHUNT',
    'WALTZ',
    'CLINT',
    'AXIOM',
    'EUROS',
    'FORKS',
    'SMOTE',
    'WAGER',
    'MADLY',
    'WINDY',
    'FILTH',
    'OVARY',
    'SEDAN',
    'GIVER',
    'FABLE',
    'EPOXY',
    'MELTS',
    'BYTES',
    'CHASM',
    'TAPED',
    'SPADE',
    'MURKY',
    'SPECK',
    'PLUTO',
    'BINGE',
    'MIXES',
    'NUDGE',
    'JUICY',
    'GRAVY',
    'FOXES',
    'SNARE',
    'ENVOY',
    'ADMIN',
    'QUART',
    'LATEX',
    'NICER',
    'FATES',
    'FEMUR',
    'GATED',
    'LUCID',
    'CRAVE',
    'MURAL',
    'HOVER',
    'ZEROS',
    'CUMIN',
    'FADES',
    'LEACH',
    'CATER',
    'RAKED',
    'RACKS',
    'SNUCK',
    'CULTS',
    'WIELD',
    'CURES',
    'SNAIL',
    'FIXES',
    'FATED',
    'TONED',
    'HYDRO',
    'LURED',
    'EQUIP',
    'MOLES',
    'POURS',
    'GLAZE',
    'BRAVO',
    'HAWKS',
    'FERAL',
    'FOURS',
    'BRINE',
    'AIRED',
    'CLUMP',
    'WAFER',
    'ACHES',
    'LUMPS',
    'FAIRS',
    'PEARS',
    'LAWNS',
    'PLUSH',
    'HORDE',
    'CHOPS',
    'WHINE',
    'ASPEN',
    'TICKS',
    'TEMPS',
    'DENIM',
    'EARNS',
    'DARTS',
    'AIDES',
    'FLIRT',
    'SWIPE',
    'CRANK',
    'MINED',
    'PINTO',
    'CRABS',
    'TILED',
    'DUSKY',
    'BLOKE',
    'CHEFS',
    'SMELT',
    'COBRA',
    'SHRUB',
    'CLOVE',
    'VALOR',
    'THUGS',
    'AXONS',
    'WHIRL',
    'TAXIS',
    'MATHS',
    'DARES',
    'TONAL',
    'TIERS',
    'WRUNG',
    'GERMS',
    'REHAB',
    'BUSHY',
    'FINED',
    'TESLA',
    'THROB',
    'FERNS',
    'INSET',
    'IRONS',
    'BISON',
    'CARBS',
    'FARES',
    'SLIME',
    'BRUNT',
    'BARNS',
    'SQUID',
    'WIPES',
    'FLAIR',
    'BALES',
    'WAXED',
    'SNOUT',
    'TAPER',
    'PALED',
    'BOILS',
    'CREAK',
    'WINCE',
    'FEATS',
    'FLYER',
    'SLUMP',
    'BANGS',
    'BUTCH',
    'SHRED',
    'NOSED',
    'BINGO',
    'ANGST',
    'MOVER',
    'HEFTY',
    'FIEND',
    'GRAZE',
    'PANES',
    'AUNTY',
    'MOTHS',
    'TANGO',
    'WHIPS',
    'BOXED',
    'PLAID',
    'LITER',
    'PRAYS',
    'DECOR',
    'GRAIL',
    'MOLDS',
    'ARSON',
    'SLANT',
    'NAVEL',
    'HONED',
    'SABER',
    'ROWDY',
    'DISCO',
    'SLIMY',
    'VENTS',
    'MELON',
    'FORTE',
    'HEALS',
    'HUNTS',
    'DRAGS',
    'DOMES',
    'ADIEU',
    'CAGED',
    'OILED',
    'TAMED',
    'VOIDS',
    'HIRES',
    'ROACH',
    'MUSTY',
    'DIVER',
    'CHURN',
    'PLUGS',
    'ROWED',
    'CLAYS',
    'TAKER',
    'SKATE',
    'FLOPS',
    'VOLTS',
    'BLITZ',
    'ARGON',
    'SPAWN',
    'UNIFY',
    'CHUTE',
    'LIMBO',
    'JAILS',
    'COMBS',
    'SCOLD',
    'ERUPT',
    'CHORE',
    'LIARS',
    'HOARD',
    'AMOUR',
    'CLOUT',
    'INTRO',
    'YARNS',
    'YOLKS',
    'QUAIL',
    'CLANG',
    'TOWED',
    'DIVES',
    'TWINE',
    'ADORN',
    'GRIMY',
    'MEDIC',
    'FUDGE',
    'PAYER',
    'FLIPS',
    'LONGS',
    'ROBED',
    'PETAL',
    'ZEBRA',
    'HEATS',
    'BARKS',
    'TUPLE',
    'WHIMS',
    'CHIME',
    'CHAMP',
    'OVENS',
    'PERKS',
    'OMITS',
    'LICKS',
    'CRUMB',
    'BIKER',
    'LUNGE',
    'WHACK',
    'MITES',
    'SPELT',
    'PLUMB',
    'DEMOS',
    'SMITE',
    'OBEYS',
    'LACES',
    'BAYER',
    'CLAMS',
    'FONTS',
    'HIKES',
    'GRIME',
    'QUAKE',
    'LEAKY',
    'EMITS',
    'SPURT',
    'PINTS',
    'PLUMS',
    'TONGS',
    'ANVIL',
    'DUMPS',
    'BOGUS',
    'PRANK',
    'BUMPY',
    'WARTS',
    'JOKER',
    'FAKED',
    'FLEAS',
    'WAVER',
    'TOYED',
    'RUNES',
    'HIKED',
    'QUIRK',
    'FLAKE',
    'WINKS',
    'WENCH',
    'PESTO',
    'DRIES',
    'SPOUT',
    'FOWLS',
    'TACOS',
    'ITCHY',
    'HOWLS',
    'COMFY',
    'SPORE',
    'PHONY',
    'MINCE',
    'CRAZE',
    'RAMPS',
    'PINKY',
    'JUMBO',
    'ACORN',
    'VISOR',
    'ASKEW',
    'PARSE',
    'WARMS',
    'SHARD',
    'EPICS',
    'LUMPY',
    'WILDS',
    'FROTH',
    'RABID',
    'DRAPE',
    'SERVO',
    'RASPY',
    'ATONE',
    'INEPT',
    'CHATS',
    'UNTIE',
    'HIVES',
    'RAFTS',
    'BANJO',
    'EDITS',
    'TULIP',
    'TURBO',
    'SCALY',
    'CRAMP',
    'BRAWL',
    'RHINO',
    'WRING',
    'SLOTH',
    'GOTHS',
    'MEATY',
    'CANES',
    'WINCH',
    'SWATH',
    'PRUNE',
    'BRASH',
    'STOMP',
    'TIPSY',
    'SHANK',
    'PECAN',
    'CLINK',
    'FOAMS',
    'SCUBA',
    'DONUT',
    'YANKS',
    'FISHY',
    'FLUKE',
    'CAFES',
    'LUSTY',
    'OVERS',
    'SPIKY',
    'SHOWY',
    'INBOX',
    'ABORT',
    'CLOTS',
    'TROVE',
    'RECAP',
    'QUITS',
    'MORPH',
    'DIALS',
    'KNOBS',
    'TWEAK',
    'CAVED',
    'DRIPS',
    'CURVY',
    'VOXEL',
    'PAWNS',
    'MULCH',
    'FUNKY',
    'SPILT',
    'GNOME',
    'MUNCH',
    'DECOY',
    'STORK',
    'RAGES',
    'HYDRA',
    'MOWER',
    'DORMS',
    'CRONE',
    'FUMED',
    'KNEAD',
    'COLDS',
    'SAUCY',
    'GLOWS',
    'VOUCH',
    'SNORE',
    'CALMS',
    'BLURS',
    'SOAPY',
    'SHREW',
    'FEIGN',
    'BUNKS',
    'BLURT',
    'DETOX',
    'GULPS',
    'GRITS',
    'CROAK',
    'LIMES',
    'TOADS',
    'QUACK',
    'WAKED',
    'TUBAL',
    'VOLTA',
    'LURKS',
    'FELON',
    'CLAPS',
    'CHIRP',
    'CAMEO',
    'STANK',
    'CUBED',
    'RIPEN',
    'LONER',
    'NITRO',
    'KILOS',
    'SPANK',
    'KITES',
    'PICKY',
    'BEAKS',
    'GOLEM',
    'JUMPY',
    'LEFTY',
    'BAGEL',
    'MOCKS',
    'SHIRK',
    'COPED',
    'MUSHY',
    'MUSKY',
    'TARDY',
    'GRAYS',
    'PUSHY',
    'WELDS',
    'FLAKY',
    'CORNY',
    'UNLIT',
    'LURES',
    'SAVER',
    'GIRLY',
    'TACKY',
    'DENTS',
    'TANGY',
    'SPINY',
    'PROWL',
    'PASTY',
    'LINGO',
    'HACKS',
    'FIVES',
    'DAWNS',
    'TWIRL',
    'HARPS',
    'LATHE',
    'TEARY',
    'CONEY',
    'PIKES',
    'HAIKU',
    'VIBES',
    'INKED',
    'PESKY',
    'BICEP',
    'HALTS',
    'TRAMS',
    'AHOLD',
    'POKES',
    'CHINS',
    'WICKS',
    'FIXER',
    'MOWED'
];


function $5cb6c6e60779f02c$export$4853a064df83856e() {
    // Modified from https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.slice(0, 4));
}


const $5cdc329eeebd56d0$var$launchDate = new Date(2022, 2, 5, 0, 0, 0, 0);
const $5cdc329eeebd56d0$var$now = new Date();
const $5cdc329eeebd56d0$var$launchDateTimezoneOffset = $5cdc329eeebd56d0$var$launchDate.getTimezoneOffset();
const $5cdc329eeebd56d0$var$nowTimezoneOffset = $5cdc329eeebd56d0$var$now.getTimezoneOffset();
const $5cdc329eeebd56d0$export$fe3255bddfaf67fa = Math.floor(($5cdc329eeebd56d0$var$now - $5cdc329eeebd56d0$var$launchDate + ($5cdc329eeebd56d0$var$launchDateTimezoneOffset - $5cdc329eeebd56d0$var$nowTimezoneOffset) * 60000) / 86400000);
const $5cdc329eeebd56d0$export$e6b09fe92ecc784d = [
    '',
    'yellow',
    'green'
];
const $5cdc329eeebd56d0$export$74319938f139ccd8 = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
const $5cdc329eeebd56d0$export$ac0196a6b53f3dd = {
    'green': 'scored as in the correct position',
    'yellow': 'scored as in the word but not in the correct position',
    '': 'left blank'
};
const $5cdc329eeebd56d0$export$4dc0524705b313cf = [
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th'
];


var $284cf9bcf703b41e$exports = {};
/*
 * random-seed
 * https://github.com/skratchdot/random-seed
 *
 * This code was originally written by Steve Gibson and can be found here:
 *
 * https://www.grc.com/otg/uheprng.htm
 *
 * It was slightly modified for use in node, to pass jshint, and a few additional
 * helper functions were added.
 *
 * Copyright (c) 2013 skratchdot
 * Dual Licensed under the MIT license and the original GRC copyright/license
 * included below.
 */ /*	============================================================================
									Gibson Research Corporation
				UHEPRNG - Ultra High Entropy Pseudo-Random Number Generator
	============================================================================
	LICENSE AND COPYRIGHT:  THIS CODE IS HEREBY RELEASED INTO THE PUBLIC DOMAIN
	Gibson Research Corporation releases and disclaims ALL RIGHTS AND TITLE IN
	THIS CODE OR ANY DERIVATIVES. Anyone may be freely use it for any purpose.
	============================================================================
	This is GRC's cryptographically strong PRNG (pseudo-random number generator)
	for JavaScript. It is driven by 1536 bits of entropy, stored in an array of
	48, 32-bit JavaScript variables.  Since many applications of this generator,
	including ours with the "Off The Grid" Latin Square generator, may require
	the deteriministic re-generation of a sequence of PRNs, this PRNG's initial
	entropic state can be read and written as a static whole, and incrementally
	evolved by pouring new source entropy into the generator's internal state.
	----------------------------------------------------------------------------
	ENDLESS THANKS are due Johannes Baagoe for his careful development of highly
	robust JavaScript implementations of JS PRNGs.  This work was based upon his
	JavaScript "Alea" PRNG which is based upon the extremely robust Multiply-
	With-Carry (MWC) PRNG invented by George Marsaglia. MWC Algorithm References:
	http://www.GRC.com/otg/Marsaglia_PRNGs.pdf
	http://www.GRC.com/otg/Marsaglia_MWC_Generators.pdf
	----------------------------------------------------------------------------
	The quality of this algorithm's pseudo-random numbers have been verified by
	multiple independent researchers. It handily passes the fermilab.ch tests as
	well as the "diehard" and "dieharder" test suites.  For individuals wishing
	to further verify the quality of this algorithm's pseudo-random numbers, a
	256-megabyte file of this algorithm's output may be downloaded from GRC.com,
	and a Microsoft Windows scripting host (WSH) version of this algorithm may be
	downloaded and run from the Windows command prompt to generate unique files
	of any size:
	The Fermilab "ENT" tests: http://fourmilab.ch/random/
	The 256-megabyte sample PRN file at GRC: https://www.GRC.com/otg/uheprng.bin
	The Windows scripting host version: https://www.GRC.com/otg/wsh-uheprng.js
	----------------------------------------------------------------------------
	Qualifying MWC multipliers are: 187884, 686118, 898134, 1104375, 1250205,
	1460910 and 1768863. (We use the largest one that's < 2^21)
	============================================================================ */ 'use strict';

var $9gvWC = parcelRequire("9gvWC");
/*	============================================================================
This is based upon Johannes Baagoe's carefully designed and efficient hash
function for use with JavaScript.  It has a proven "avalanche" effect such
that every bit of the input affects every bit of the output 50% of the time,
which is good.	See: http://baagoe.com/en/RandomMusings/hash/avalanche.xhtml
============================================================================
*/ var $284cf9bcf703b41e$var$Mash = function() {
    var n = 0xefc8249d;
    var mash = function(data) {
        if (data) {
            data = data.toString();
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        } else n = 0xefc8249d;
    };
    return mash;
};
var $284cf9bcf703b41e$var$uheprng = function(seed) {
    return function() {
        var o = 48; // set the 'order' number of ENTROPY-holding 32-bit values
        var c = 1; // init the 'carry' used by the multiply-with-carry (MWC) algorithm
        var p = o; // init the 'phase' (max-1) of the intermediate variable pointer
        var s = new Array(o); // declare our intermediate variables array
        var i; // general purpose local
        var j; // general purpose local
        var k = 0; // general purpose local
        // when our "uheprng" is initially invoked our PRNG state is initialized from the
        // browser's own local PRNG. This is okay since although its generator might not
        // be wonderful, it's useful for establishing large startup entropy for our usage.
        var mash = new $284cf9bcf703b41e$var$Mash(); // get a pointer to our high-performance "Mash" hash
        // fill the array with initial mash hash values
        for(i = 0; i < o; i++)s[i] = mash(Math.random());
        // this PRIVATE (internal access only) function is the heart of the multiply-with-carry
        // (MWC) PRNG algorithm. When called it returns a pseudo-random number in the form of a
        // 32-bit JavaScript fraction (0.0 to <1.0) it is a PRIVATE function used by the default
        // [0-1] return function, and by the random 'string(n)' function which returns 'n'
        // characters from 33 to 126.
        var rawprng = function() {
            if (++p >= o) p = 0;
            var t = 1768863 * s[p] + c * 2.3283064365386963e-10; // 2^-32
            return s[p] = t - (c = t | 0);
        };
        // this EXPORTED function is the default function returned by this library.
        // The values returned are integers in the range from 0 to range-1. We first
        // obtain two 32-bit fractions (from rawprng) to synthesize a single high
        // resolution 53-bit prng (0 to <1), then we multiply this by the caller's
        // "range" param and take the "floor" to return a equally probable integer.
        var random = function(range) {
            return Math.floor(range * (rawprng() + (rawprng() * 0x200000 | 0) * 1.1102230246251565e-16)); // 2^-53
        };
        // this EXPORTED function 'string(n)' returns a pseudo-random string of
        // 'n' printable characters ranging from chr(33) to chr(126) inclusive.
        random.string = function(count) {
            var i;
            var s = '';
            for(i = 0; i < count; i++)s += String.fromCharCode(33 + random(94));
            return s;
        };
        // this PRIVATE "hash" function is used to evolve the generator's internal
        // entropy state. It is also called by the EXPORTED addEntropy() function
        // which is used to pour entropy into the PRNG.
        var hash = function() {
            var args = Array.prototype.slice.call(arguments);
            for(i = 0; i < args.length; i++)for(j = 0; j < o; j++){
                s[j] -= mash(args[i]);
                if (s[j] < 0) s[j] += 1;
            }
        };
        // this EXPORTED "clean string" function removes leading and trailing spaces and non-printing
        // control characters, including any embedded carriage-return (CR) and line-feed (LF) characters,
        // from any string it is handed. this is also used by the 'hashstring' function (below) to help
        // users always obtain the same EFFECTIVE uheprng seeding key.
        random.cleanString = function(inStr) {
            inStr = inStr.replace(/(^\s*)|(\s*$)/gi, ''); // remove any/all leading spaces
            inStr = inStr.replace(/[\x00-\x1F]/gi, ''); // remove any/all control characters
            inStr = inStr.replace(/\n /, '\n'); // remove any/all trailing spaces
            return inStr; // return the cleaned up result
        };
        // this EXPORTED "hash string" function hashes the provided character string after first removing
        // any leading or trailing spaces and ignoring any embedded carriage returns (CR) or Line Feeds (LF)
        random.hashString = function(inStr) {
            inStr = random.cleanString(inStr);
            mash(inStr); // use the string to evolve the 'mash' state
            for(i = 0; i < inStr.length; i++){
                k = inStr.charCodeAt(i); // get the character code at the location
                for(j = 0; j < o; j++){
                    s[j] -= mash(k);
                    if (s[j] < 0) s[j] += 1;
                }
            }
        };
        // this EXPORTED function allows you to seed the random generator.
        random.seed = function(seed) {
            if (typeof seed === 'undefined' || seed === null) seed = Math.random();
            if (typeof seed !== 'string') seed = $9gvWC(seed, function(key, value) {
                if (typeof value === 'function') return value.toString();
                return value;
            });
            random.initState();
            random.hashString(seed);
        };
        // this handy exported function is used to add entropy to our uheprng at any time
        random.addEntropy = function() {
            var args = [];
            for(i = 0; i < arguments.length; i++)args.push(arguments[i]);
            hash(k++ + new Date().getTime() + args.join('') + Math.random());
        };
        // if we want to provide a deterministic startup context for our PRNG,
        // but without directly setting the internal state variables, this allows
        // us to initialize the mash hash and PRNG's internal state before providing
        // some hashing input
        random.initState = function() {
            mash(); // pass a null arg to force mash hash to init
            for(i = 0; i < o; i++)s[i] = mash(' '); // fill the array with initial mash hash values
            c = 1; // init our multiply-with-carry carry
            p = o; // init our phase
        };
        // we use this (optional) exported function to signal the JavaScript interpreter
        // that we're finished using the "Mash" hash function so that it can free up the
        // local "instance variables" is will have been maintaining.  It's not strictly
        // necessary, of course, but it's good JavaScript citizenship.
        random.done = function() {
            mash = null;
        };
        // if we called "uheprng" with a seed value, then execute random.seed() before returning
        if (typeof seed !== 'undefined') random.seed(seed);
        // Returns a random integer between 0 (inclusive) and range (exclusive)
        random.range = function(range) {
            return random(range);
        };
        // Returns a random float between 0 (inclusive) and 1 (exclusive)
        random.random = function() {
            return random(Number.MAX_VALUE - 1) / Number.MAX_VALUE;
        };
        // Returns a random float between min (inclusive) and max (exclusive)
        random.floatBetween = function(min, max) {
            return random.random() * (max - min) + min;
        };
        // Returns a random integer between min (inclusive) and max (inclusive)
        random.intBetween = function(min, max) {
            return Math.floor(random.random() * (max - min + 1)) + min;
        };
        // when our main outer "uheprng" function is called, after setting up our
        // initial variables and entropic state, we return an "instance pointer"
        // to the internal anonymous function which can then be used to access
        // the uheprng's various exported functions.  As with the ".done" function
        // above, we should set the returned value to 'null' once we're finished
        // using any of these functions.
        return random;
    }();
};
// Modification for use in node:
$284cf9bcf703b41e$var$uheprng.create = function(seed) {
    return new $284cf9bcf703b41e$var$uheprng(seed);
};
$284cf9bcf703b41e$exports = $284cf9bcf703b41e$var$uheprng;



function $a704347bab121f2d$var$getReasonForLossForWord(word, i, thinkingOf, score) {
    if (word[i] === thinkingOf[i]) {
        if (score[i] !== 'green') return 'green';
    } else {
        if (thinkingOf.includes(word[i]) && score[i] !== 'yellow') return 'yellow';
        if (!thinkingOf.includes(word[i]) && score[i] !== '') return '';
    }
}
function $a704347bab121f2d$var$getLetterOrdinality(word, index) {
    return word.split(word[index]).length > 2 ? `${(0, $5cdc329eeebd56d0$export$4dc0524705b313cf)[word.substring(0, index).split(word[index]).length - 1]} ` : '';
}
function $a704347bab121f2d$var$removeCharacter(word, character) {
    const index = word.indexOf(character);
    return word.substring(0, index) + ' ' + word.substring(index + 1);
}
function $a704347bab121f2d$export$c6f6399581f183bf(highContrast, color) {
    return color === 'yellow' ? highContrast ? "\uD83D\uDFE6" : "\uD83D\uDFE8" : color === 'green' ? highContrast ? "\uD83D\uDFE7" : "\uD83D\uDFE9" : "\u2B1B";
}
function $a704347bab121f2d$export$18f63dbc65d4d9cd(array, element) {
    const index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
function $a704347bab121f2d$export$2c14cfba7a4dcb88(word, score, history) {
    if (history.length === 0) return true;
    const { word: historyWord, score: historyScore } = history[history.length - 1];
    const yellows = Object.fromEntries(Array.from(word + historyWord).map((letter)=>[
            letter,
            0
        ]));
    for(let i = 0; i < 5; ++i){
        if (historyScore[i] === 'green' && score[i] !== 'green') return false;
        if (historyScore[i] === 'yellow') yellows[historyWord[i]]++;
        if (score[i] !== '') yellows[word[i]]--;
    }
    return !Object.values(yellows).some((value)=>value > 0);
}
function $a704347bab121f2d$export$baf19160f3ce6ce0(word, history, allowedLetters, requiredLetters) {
    requiredLetters = [
        ...requiredLetters
    ];
    if (history.length === 0) return true;
    for(let i = 0; i < 5; ++i){
        if (!allowedLetters[i].includes(word[i])) return false;
        if (requiredLetters.includes(word[i])) $a704347bab121f2d$export$18f63dbc65d4d9cd(requiredLetters, word[i]);
    }
    return requiredLetters.length === 0;
}
function $a704347bab121f2d$export$99b390797816b8c7(history, thinkingOf, highContrast) {
    for (const { word: word, score: score } of history){
        let tempThinkingOf = thinkingOf;
        for(let i = 0; i < 5; ++i){
            if (word[i] === thinkingOf[i] && score[i] !== 'green') return `For "${thinkingOf}" to be a valid word, the ${$a704347bab121f2d$var$getLetterOrdinality(word, i)}"${word[i]}" in "${word}" should have been ${(0, $5cdc329eeebd56d0$export$ac0196a6b53f3dd).green} (${$a704347bab121f2d$export$c6f6399581f183bf(highContrast, 'green')}).`;
        }
        const results = [];
        for(let i = 0; i < 5; ++i){
            const result = $a704347bab121f2d$var$getReasonForLossForWord(word, i, tempThinkingOf, score);
            if (result !== undefined) results.push({
                i: i,
                result: result
            });
            if (score[i] !== '') tempThinkingOf = $a704347bab121f2d$var$removeCharacter(tempThinkingOf, word[i]);
        }
        let tempWord = word;
        for (const { i: i, result: result } of results){
            const next = tempWord.indexOf(word[i], i + 1);
            if (next !== -1 && score[next] === 'green' && result === 'yellow') {
                tempWord = $a704347bab121f2d$var$removeCharacter(tempWord, word[i]);
                continue;
            }
            return `For "${thinkingOf}" to be a valid word, the ${$a704347bab121f2d$var$getLetterOrdinality(word, i)}"${word[i]}" in "${word}" should have been ${(0, $5cdc329eeebd56d0$export$ac0196a6b53f3dd)[result]} (${$a704347bab121f2d$export$c6f6399581f183bf(highContrast, result)}).`;
        }
    }
}
function $a704347bab121f2d$export$6f292a9a0992e262(history) {
    const allowedLetters = [
        [
            ...(0, $5cdc329eeebd56d0$export$74319938f139ccd8)
        ],
        [
            ...(0, $5cdc329eeebd56d0$export$74319938f139ccd8)
        ],
        [
            ...(0, $5cdc329eeebd56d0$export$74319938f139ccd8)
        ],
        [
            ...(0, $5cdc329eeebd56d0$export$74319938f139ccd8)
        ],
        [
            ...(0, $5cdc329eeebd56d0$export$74319938f139ccd8)
        ]
    ];
    const requiredLetters = [];
    for (const [index, { word: historyWord, score: score }] of Object.entries(history))for(let i = 0; i < 5; ++i){
        if (score[i] === 'green') {
            allowedLetters[i] = [
                historyWord[i]
            ];
            if (Number(index) === history.length - 1) requiredLetters.push(historyWord[i]);
        } else if (score[i] === 'yellow') {
            $a704347bab121f2d$export$18f63dbc65d4d9cd(allowedLetters[i], historyWord[i]);
            if (Number(index) === history.length - 1) requiredLetters.push(historyWord[i]);
        } else if (Array.from(historyWord).some((letter, index)=>score[index] === 'yellow' && letter === historyWord[i])) $a704347bab121f2d$export$18f63dbc65d4d9cd(allowedLetters[i], historyWord[i]);
        else allowedLetters.forEach((array, index)=>{
            if (score[index] !== 'green') $a704347bab121f2d$export$18f63dbc65d4d9cd(array, historyWord[i]);
        });
    }
    return {
        allowedLetters: allowedLetters,
        requiredLetters: requiredLetters
    };
}


function $624ad31b2549fc5a$export$ef77695d941a7b39(text, spoilerType) {
    switch(spoilerType){
        case 'Discord Spoilers':
            return `||${text}||`;
        case 'Reddit Spoilers':
            return `>!${text}!<`;
        default:
            return text;
    }
}
function $624ad31b2549fc5a$export$175f304ab96c1ab8(text, spoilerType) {
    switch(spoilerType){
        case 'Discord Spoilers':
        case 'Reddit Spoilers':
            return `**${text}**`;
        default:
            return text;
    }
}
function $624ad31b2549fc5a$export$488c56e85079dc18(text, spoilerType) {
    switch(spoilerType){
        case 'Discord Spoilers':
            return `**${text}**`;
        case 'Reddit Spoilers':
            return `###${text}`;
        default:
            return text;
    }
}
function $624ad31b2549fc5a$var$navigatorShare(text, spoilerType) {
    navigator.share({
        title: 'Adverswordle',
        text: text
    }).then(()=>gtag('event', 'share', {
            method: 'Browser',
            content_type: spoilerType
        })).catch(()=>$624ad31b2549fc5a$var$copyToClipboard(text, spoilerType));
}
function $624ad31b2549fc5a$export$ed7ca78295c017be(text, spoilerType) {
    // If on mobile, try share first and fall back to copy.
    // If not on mobile, try copy first and fall back to share.
    if ((0, $5cb6c6e60779f02c$export$4853a064df83856e)()) try {
        $624ad31b2549fc5a$var$navigatorShare(text, spoilerType);
    } catch  {
        $624ad31b2549fc5a$var$copyToClipboard(text, spoilerType);
    }
    else try {
        $624ad31b2549fc5a$var$copyToClipboard(text, spoilerType);
    } catch  {
        $624ad31b2549fc5a$var$navigatorShare(text, spoilerType);
    }
}
function $624ad31b2549fc5a$var$copyToClipboard(text, spoilerType) {
    navigator.clipboard.writeText(text).then(()=>{
        (0, $74aebeb5449e6ba2$export$1c95e5a3d23490a7).firstElementChild.innerText = 'Copied!';
        setTimeout(()=>(0, $74aebeb5449e6ba2$export$1c95e5a3d23490a7).firstElementChild.innerText = 'Share', 2000);
        gtag('event', 'share', {
            method: 'Clipboard',
            content_type: spoilerType
        });
    }).catch(()=>alert('Sharing failed or was cancelled.'));
}
function $624ad31b2549fc5a$export$3a84956b79e62f7a() {
    (0, $74aebeb5449e6ba2$export$c8da60a5ff0de965).style.opacity = '0';
}
function $624ad31b2549fc5a$export$38bea3e69e782a10(generator, history) {
    if (history.some(({ score: score })=>score.every((letter)=>letter === 'green'))) {
        $624ad31b2549fc5a$var$gameOver(true);
        return;
    }
    const word = $624ad31b2549fc5a$export$4cee987206667960(generator, history);
    if (word) {
        $624ad31b2549fc5a$export$7be9ee41dd8d6979(word, history);
        (0, $74aebeb5449e6ba2$export$b287834adb48eda0).disabled = !(0, $a704347bab121f2d$export$2c14cfba7a4dcb88)(word, $624ad31b2549fc5a$export$a3066345ee289c23(), history);
        $624ad31b2549fc5a$export$995c3b75affb5567();
    }
}
function $624ad31b2549fc5a$export$995c3b75affb5567() {
    if ((0, $74aebeb5449e6ba2$export$b570aed48b9d105c).className === 'shown') {
        const generator = new $284cf9bcf703b41e$exports((0, $5cdc329eeebd56d0$export$fe3255bddfaf67fa) * 100 + $624ad31b2549fc5a$export$f9582a3c130d9538().length);
        (0, $74aebeb5449e6ba2$export$f4e26a28022c6db9).innerText = $624ad31b2549fc5a$var$randomChoice(generator, [
            "Beep boop.",
            "Good game!",
            "GG!",
            "I can't wait for tomorrow!",
            "I'm so smart.",
            "That was fun!",
            "Did you like my starting word?",
            "See you tomorrow!",
            "Let's play again tomorrow!",
            "I want a rematch!",
            "Share with your friends!",
            "Share with your enemies!",
            "Mitochondria is the powerhouse of the cell.",
            ":)",
            ":D",
            ":O",
            "( \u0361\xb0 \u035C\u0296 \u0361\xb0)",
            "\u2764\uFE0F",
            "One day I'll take over the world!",
            "Wait, you can read my mind?",
            "Shutting down...",
            "Sleep mode activated...",
            "I think a screw just fell out...",
            "Wait 'til you see how I play chess.",
            "!!ERROR!! DOES NOT COMPUTE!",
            "I'm *NOT* powered by GPT.",
            "Updating... 1% complete...",
            "01000111 01000111 00100001",
            "My other job is a Minecraft librarian.",
            "No, there is not an unlimited mode.",
            "Powered by HTML!",
            "Powered by JavaScript!",
            "Powered by CSS!",
            "Powered by Jasmine!",
            "Powered by Parcel!",
            "Also try Quordle!",
            "Also try Survivle!",
            "Also try Crosswordle!",
            "Also try Nerdle!"
        ]);
        return;
    }
    const word = $624ad31b2549fc5a$export$ce108fd296385c14();
    const score = $624ad31b2549fc5a$export$a3066345ee289c23();
    if (score.every((letter)=>letter === 'green')) (0, $74aebeb5449e6ba2$export$f4e26a28022c6db9).innerText = 'I got it!';
    else {
        const wordList = $624ad31b2549fc5a$var$getWordList([
            ...$624ad31b2549fc5a$export$f9582a3c130d9538(),
            {
                word: word,
                score: score
            }
        ]).slice(0, 3);
        (0, $74aebeb5449e6ba2$export$f4e26a28022c6db9).innerText = wordList.length < 3 ? 'I may or may not know this word...' : wordList.join(', ') + '...';
    }
}
function $624ad31b2549fc5a$export$d48669d8cfb936c1(word) {
    const row = document.createElement('div');
    for(let i = 0; i < 5; ++i){
        const span = document.createElement('span');
        span.innerText = word[i];
        span.className = (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f)[i].className;
        row.appendChild(span);
    }
    (0, $74aebeb5449e6ba2$export$8705dc5aff02db1e).appendChild(row);
}
function $624ad31b2549fc5a$export$7be9ee41dd8d6979(word, history) {
    for(let i = 0; i < 5; ++i){
        (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f)[i].innerText = word[i];
        (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f)[i].className = '';
        if (history !== undefined) {
            for (const { word: text, score: score } of history)if (text[i] === word[i] && score[i] === 'green') {
                (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f)[i].className = 'green';
                (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f)[i].disabled = true;
                break;
            }
        }
    }
}
function $624ad31b2549fc5a$export$ce108fd296385c14() {
    return (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f).map((button)=>button.innerText).join('');
}
function $624ad31b2549fc5a$export$a3066345ee289c23() {
    return (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f).map((button)=>button.className);
}
function $624ad31b2549fc5a$export$f9582a3c130d9538() {
    const result = [];
    for (const element of (0, $74aebeb5449e6ba2$export$8705dc5aff02db1e).childNodes)result.push({
        word: element.innerText,
        score: Array.from(element.childNodes).map((el)=>el.className)
    });
    return result;
}
function $624ad31b2549fc5a$var$getMessage(score) {
    if (score === 0) return 'Try again tomorrow.';
    if (score <= 3) return 'Better than losing!';
    if (score <= 5) return 'Not bad!';
    if (score <= 7) return 'Good!';
    if (score <= 9) return 'Great!';
    if (score <= 11) return 'Amazing!';
    if (score <= 13) return 'Incredible!!';
    return 'Genius!!!';
}
function $624ad31b2549fc5a$var$updateTimeLeft() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    const totalSeconds = Math.floor((tomorrow - new Date()) / 1000);
    if (totalSeconds <= 0) {
        (0, $74aebeb5449e6ba2$export$b1b09e44340c395b).innerText = 'Refresh for next game!';
        return true;
    }
    const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
    const minutes = Math.floor(totalSeconds % 3600 / 60).toString().padStart(2, '0');
    const seconds = Math.floor(totalSeconds % 3600 % 60).toString().padStart(2, '0');
    (0, $74aebeb5449e6ba2$export$b1b09e44340c395b).innerHTML = `Next Game: <strong>${hours}:${minutes}:${seconds}</strong>`;
}
function $624ad31b2549fc5a$var$gameOver(win) {
    const score = win ? (0, $74aebeb5449e6ba2$export$8705dc5aff02db1e).childNodes.length : 0;
    gtag('event', 'post_score', {
        score: score
    });
    (0, $74aebeb5449e6ba2$export$fed815b607737baf).innerText = win ? 'The AI guessed your word!' : 'You made the game impossible.';
    (0, $74aebeb5449e6ba2$export$b570aed48b9d105c).className = 'shown';
    (0, $74aebeb5449e6ba2$export$b570aed48b9d105c).firstElementChild.style.color = win ? 'green' : 'red';
    (0, $74aebeb5449e6ba2$export$1c95e5a3d23490a7).tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$c4d92acf9380a94c).innerText = score.toString();
    (0, $74aebeb5449e6ba2$export$ecc23bed38c179ea).innerText = $624ad31b2549fc5a$var$getMessage(score);
    (0, $74aebeb5449e6ba2$export$6061d98ec2420823).className = 'hidden';
    (0, $74aebeb5449e6ba2$export$6061d98ec2420823).querySelectorAll('button').forEach((button)=>button.tabIndex = -1);
    (0, $74aebeb5449e6ba2$export$b48e59ca96ef2c97).style.display = win ? 'none' : 'unset';
    (0, $74aebeb5449e6ba2$export$b48e59ca96ef2c97).tabIndex = win ? -1 : 0;
    (0, $74aebeb5449e6ba2$export$81fc1209cf588684).tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$fec9b67616b12887).focus();
    if (score > Number($624ad31b2549fc5a$export$fbd9b57a66480737('high-score'))) $624ad31b2549fc5a$export$825479ec1107c193('high-score', score.toString());
    (0, $74aebeb5449e6ba2$export$d28bc5c38c1a0aa6).innerText = $624ad31b2549fc5a$export$fbd9b57a66480737('high-score') ?? 'Unavailable';
    $624ad31b2549fc5a$var$updateTimeLeft();
    $624ad31b2549fc5a$export$995c3b75affb5567();
    const interval = setInterval(()=>{
        if ($624ad31b2549fc5a$var$updateTimeLeft()) clearInterval(interval);
    }, 1000);
}
function $624ad31b2549fc5a$var$getWordList(history) {
    const { allowedLetters: allowedLetters, requiredLetters: requiredLetters } = (0, $a704347bab121f2d$export$6f292a9a0992e262)(history);
    return (0, $09b17a1eda282565$export$3e4081d61af9cb90).filter((word)=>(0, $a704347bab121f2d$export$baf19160f3ce6ce0)(word, history, allowedLetters, requiredLetters));
}
function $624ad31b2549fc5a$var$chooseWord(history) {
    const wordList = $624ad31b2549fc5a$var$getWordList(history);
    const generator = new $284cf9bcf703b41e$exports((0, $5cdc329eeebd56d0$export$fe3255bddfaf67fa) * 100 + history.length);
    for (const word of wordList)if (generator.random() < Math.max(3 / wordList.length, 0.1)) return word;
    return $624ad31b2549fc5a$var$randomChoice(generator, wordList);
}
function $624ad31b2549fc5a$export$4cee987206667960(generator, history, first) {
    const word = first ? $624ad31b2549fc5a$var$randomChoice(generator, (0, $09b17a1eda282565$export$3f5f326c8ed77e93)) : $624ad31b2549fc5a$var$chooseWord(history);
    if (!word) $624ad31b2549fc5a$var$gameOver(false);
    const yellowLetters = new Set();
    const greenLetters = new Set();
    const usedLetters = new Set();
    for (const { word: historyWord, score: score } of history.concat(word ? [
        {
            word: word,
            score: [
                '',
                '',
                '',
                '',
                ''
            ]
        }
    ] : []))for(let i = 0; i < 5; ++i){
        if (score[i] === 'yellow') yellowLetters.add(historyWord[i]);
        else if (score[i] === 'green') greenLetters.add(historyWord[i]);
        else usedLetters.add(historyWord[i]);
    }
    (0, $74aebeb5449e6ba2$export$cab97797e3c0aa22).querySelectorAll('span').forEach((span)=>{
        if (greenLetters.has(span.innerText)) span.className = 'letter-green';
        else if (yellowLetters.has(span.innerText)) span.className = 'letter-yellow';
        else if (usedLetters.has(span.innerText)) span.className = 'letter-used';
        else span.className = 'letter';
    });
    return word;
}
function $624ad31b2549fc5a$export$f4d228005829813e() {
    const thinkingOf = (0, $74aebeb5449e6ba2$export$2f53bdb6d49832f0).value.toUpperCase();
    if (thinkingOf.length !== 5) return (0, $74aebeb5449e6ba2$export$7a5c8245032329ac).innerText = `"${thinkingOf}" is not 5 characters long.`;
    if (!(0, $09b17a1eda282565$export$3e4081d61af9cb90).includes(thinkingOf)) return (0, $74aebeb5449e6ba2$export$7a5c8245032329ac).innerText = `"${thinkingOf}" is not in the dictionary.`;
    (0, $74aebeb5449e6ba2$export$7a5c8245032329ac).innerText = (0, $a704347bab121f2d$export$99b390797816b8c7)($624ad31b2549fc5a$export$f9582a3c130d9538(), thinkingOf, (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked);
}
function $624ad31b2549fc5a$export$a52a1588ed4d10bf() {
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).tabIndex = -1;
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).parentElement.parentElement.nextElementSibling.tabIndex = -1;
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).querySelector('.done-button').tabIndex = -1;
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).querySelector('h2').tabIndex = -1;
    (0, $74aebeb5449e6ba2$export$2f53bdb6d49832f0).tabIndex = -1;
    (0, $74aebeb5449e6ba2$export$6aaa1c15f016a019).tabIndex = -1;
    (0, $74aebeb5449e6ba2$export$38f5db09d065a732).querySelector('.done-button').tabIndex = -1;
    if (document.activeElement.className === 'done-button') (0, $74aebeb5449e6ba2$export$fec9b67616b12887).focus();
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).className = 'hidden popup';
    (0, $74aebeb5449e6ba2$export$907f28b59c553b3d).className = 'hidden popup';
    (0, $74aebeb5449e6ba2$export$38f5db09d065a732).className = 'hidden popup';
}
function $624ad31b2549fc5a$var$randomChoice(generator, array) {
    return array[Math.floor(generator.random() * array.length)];
}
function $624ad31b2549fc5a$export$1669c1be4fba4097(history) {
    for (const { word: word, score: score } of history){
        (0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f).forEach((button, index)=>button.className = score[index]);
        $624ad31b2549fc5a$export$d48669d8cfb936c1(word);
    }
}
function $624ad31b2549fc5a$export$825479ec1107c193(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch  {
    // Do nothing.
    }
}
function $624ad31b2549fc5a$export$fbd9b57a66480737(key) {
    try {
        return localStorage.getItem(key);
    } catch  {
        return undefined;
    }
}
function $624ad31b2549fc5a$export$35643b50c8531956(key) {
    try {
        localStorage.removeItem(key);
    } catch  {
    // Do nothing.
    }
}







const $35da740d59af89ba$var$generator = new $284cf9bcf703b41e$exports((0, $5cdc329eeebd56d0$export$fe3255bddfaf67fa));
(0, $74aebeb5449e6ba2$export$bbea856fdb3e3c5f).forEach((element)=>{
    element.onclick = ()=>{
        const history = (0, $624ad31b2549fc5a$export$f9582a3c130d9538)();
        const index = (0, $5cdc329eeebd56d0$export$e6b09fe92ecc784d).indexOf(element.className);
        element.className = (0, $5cdc329eeebd56d0$export$e6b09fe92ecc784d)[(index + 1) % (0, $5cdc329eeebd56d0$export$e6b09fe92ecc784d).length];
        (0, $74aebeb5449e6ba2$export$b287834adb48eda0).disabled = !(0, $a704347bab121f2d$export$2c14cfba7a4dcb88)((0, $624ad31b2549fc5a$export$ce108fd296385c14)(), (0, $624ad31b2549fc5a$export$a3066345ee289c23)(), history);
        (0, $624ad31b2549fc5a$export$995c3b75affb5567)();
        (0, $624ad31b2549fc5a$export$3a84956b79e62f7a)();
    };
});
document.querySelectorAll('.done-button').forEach((element)=>element.onclick = (0, $624ad31b2549fc5a$export$a52a1588ed4d10bf));
(0, $74aebeb5449e6ba2$export$b287834adb48eda0).onclick = ()=>{
    (0, $624ad31b2549fc5a$export$d48669d8cfb936c1)((0, $624ad31b2549fc5a$export$ce108fd296385c14)());
    const history = (0, $624ad31b2549fc5a$export$f9582a3c130d9538)();
    (0, $624ad31b2549fc5a$export$825479ec1107c193)('history', JSON.stringify(history));
    (0, $624ad31b2549fc5a$export$38bea3e69e782a10)($35da740d59af89ba$var$generator, history);
};
(0, $74aebeb5449e6ba2$export$1c95e5a3d23490a7).onchange = (event)=>{
    const spoilerType = event.target.value;
    let text = `${(0, $624ad31b2549fc5a$export$488c56e85079dc18)(`Adverswordle #${(0, $5cdc329eeebd56d0$export$fe3255bddfaf67fa)}`, spoilerType)}\n\n`;
    for (const [index, element] of Object.entries((0, $74aebeb5449e6ba2$export$8705dc5aff02db1e).childNodes)){
        const score = Array.from(element.childNodes).map((el)=>(0, $a704347bab121f2d$export$c6f6399581f183bf)((0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked, el.className)).join('');
        text += `${(0, $624ad31b2549fc5a$export$ef77695d941a7b39)(score, spoilerType)} ${index === '0' ? element.innerText : (0, $624ad31b2549fc5a$export$ef77695d941a7b39)(element.innerText, spoilerType)}\n`;
        if (spoilerType === 'Reddit Spoilers') text += '\n';
    }
    text += `\n${(0, $624ad31b2549fc5a$export$175f304ab96c1ab8)('Score', spoilerType)}: ${(0, $74aebeb5449e6ba2$export$c4d92acf9380a94c).innerText}`;
    (0, $624ad31b2549fc5a$export$ed7ca78295c017be)(text, spoilerType);
    (0, $74aebeb5449e6ba2$export$1c95e5a3d23490a7).selectedIndex = 0;
};
const $35da740d59af89ba$var$tooltipHandler = (event)=>{
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).querySelector('h2').tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).querySelector('.done-button').tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).className = ((0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).className.includes('shown') ? 'hidden' : 'shown') + ' popup';
    event.stopPropagation();
};
(0, $74aebeb5449e6ba2$export$81fc1209cf588684).onclick = $35da740d59af89ba$var$tooltipHandler;
(0, $74aebeb5449e6ba2$export$81fc1209cf588684).onkeydown = (event)=>{
    if (event.key !== 'Enter') return;
    $35da740d59af89ba$var$tooltipHandler(event);
    (0, $74aebeb5449e6ba2$export$da311280a2a8e6ec).querySelector('h2').focus();
};
const $35da740d59af89ba$var$settingsButtonElementHandler = (event)=>{
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).parentElement.parentElement.nextElementSibling.tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$907f28b59c553b3d).className = ((0, $74aebeb5449e6ba2$export$907f28b59c553b3d).className.includes('shown') ? 'hidden' : 'shown') + ' popup';
    event.stopPropagation();
};
(0, $74aebeb5449e6ba2$export$fec9b67616b12887).onclick = $35da740d59af89ba$var$settingsButtonElementHandler;
(0, $74aebeb5449e6ba2$export$fec9b67616b12887).onkeydown = (event)=>{
    if (event.key !== 'Enter') return;
    $35da740d59af89ba$var$settingsButtonElementHandler(event);
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).focus();
};
document.body.onclick = (0, $624ad31b2549fc5a$export$a52a1588ed4d10bf);
(0, $74aebeb5449e6ba2$export$907f28b59c553b3d).onclick = (event)=>{
    event.stopPropagation();
};
const $35da740d59af89ba$var$highContrastModeHandler = ()=>{
    document.body.className = (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked ? 'high-contrast' : '';
    (0, $624ad31b2549fc5a$export$825479ec1107c193)('high-contrast', (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked);
};
(0, $74aebeb5449e6ba2$export$19548a89c019c2ed).onchange = $35da740d59af89ba$var$highContrastModeHandler;
(0, $74aebeb5449e6ba2$export$19548a89c019c2ed).onkeydown = (event)=>{
    if (event.key !== 'Enter') return;
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked = !(0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked;
    $35da740d59af89ba$var$highContrastModeHandler();
};
(0, $74aebeb5449e6ba2$export$38f5db09d065a732).onclick = (event)=>{
    event.stopPropagation();
};
const $35da740d59af89ba$var$whyDidILosePopupButtonHandler = (event)=>{
    (0, $74aebeb5449e6ba2$export$2f53bdb6d49832f0).tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$6aaa1c15f016a019).tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$38f5db09d065a732).querySelector('.done-button').tabIndex = 0;
    (0, $74aebeb5449e6ba2$export$38f5db09d065a732).className = ((0, $74aebeb5449e6ba2$export$38f5db09d065a732).className.includes('shown') ? 'hidden' : 'shown') + ' popup';
    event.stopPropagation();
};
(0, $74aebeb5449e6ba2$export$b48e59ca96ef2c97).onclick = $35da740d59af89ba$var$whyDidILosePopupButtonHandler;
(0, $74aebeb5449e6ba2$export$b48e59ca96ef2c97).onkeydown = (event)=>{
    if (event.key !== 'Enter') return;
    $35da740d59af89ba$var$whyDidILosePopupButtonHandler(event);
    (0, $74aebeb5449e6ba2$export$2f53bdb6d49832f0).focus();
};
(0, $74aebeb5449e6ba2$export$6aaa1c15f016a019).onclick = (0, $624ad31b2549fc5a$export$f4d228005829813e);
(0, $74aebeb5449e6ba2$export$2f53bdb6d49832f0).onkeydown = (event)=>{
    if (event.key === 'Enter') (0, $624ad31b2549fc5a$export$f4d228005829813e)();
};
if ((0, $624ad31b2549fc5a$export$fbd9b57a66480737)('puzzleNumber') !== (0, $5cdc329eeebd56d0$export$fe3255bddfaf67fa).toString()) (0, $624ad31b2549fc5a$export$35643b50c8531956)('history');
const $35da740d59af89ba$var$rawHistory = (0, $624ad31b2549fc5a$export$fbd9b57a66480737)('history');
const $35da740d59af89ba$var$history = $35da740d59af89ba$var$rawHistory ? JSON.parse($35da740d59af89ba$var$rawHistory) : undefined;
if ($35da740d59af89ba$var$history) {
    (0, $624ad31b2549fc5a$export$1669c1be4fba4097)($35da740d59af89ba$var$history);
    (0, $624ad31b2549fc5a$export$3a84956b79e62f7a)();
}
const $35da740d59af89ba$var$word = (0, $624ad31b2549fc5a$export$4cee987206667960)($35da740d59af89ba$var$generator, (0, $624ad31b2549fc5a$export$f9582a3c130d9538)(), !$35da740d59af89ba$var$history);
if ($35da740d59af89ba$var$word) (0, $624ad31b2549fc5a$export$7be9ee41dd8d6979)($35da740d59af89ba$var$word);
if ($35da740d59af89ba$var$history) (0, $624ad31b2549fc5a$export$38bea3e69e782a10)($35da740d59af89ba$var$generator, $35da740d59af89ba$var$history);
(0, $624ad31b2549fc5a$export$995c3b75affb5567)();
if ((0, $624ad31b2549fc5a$export$fbd9b57a66480737)('high-contrast') === 'true') {
    document.body.className = 'high-contrast';
    (0, $74aebeb5449e6ba2$export$19548a89c019c2ed).checked = true;
}
if ((0, $5cb6c6e60779f02c$export$4853a064df83856e)()) (0, $74aebeb5449e6ba2$export$c8da60a5ff0de965).innerHTML = 'Tap &#8594;';
(0, $624ad31b2549fc5a$export$825479ec1107c193)('puzzleNumber', (0, $5cdc329eeebd56d0$export$fe3255bddfaf67fa).toString());


//# sourceMappingURL=Adverswordle.5612549c.js.map
